/**
* @description: 营业设置
* @author: hwx
* @update: lyr
* @update: wgt
*/
<template>
    <div class="store-set-business">
        <!-- 微信/支付宝端支付方式配置 -->
        <div class="store-pay-set" v-show="show1">
            <div class="pay-list">
                <h1 class="title">微信/支付宝端支付方式配置</h1>
                <div class="table-responsive">
                    <table id="payList" class="table table-bordered table-hover" data-pagination="true" ref="payList"
                        style="margin-top:10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(1)">返回</button>
                </div>
            </div>
            <div class="li-select" ref="payAlert">
                <p>微信端和支付宝端消费者可使用支付方式选择</p>
                <ul>
                    <li>
                        <input type="checkbox" id="pall" v-model='sel_all' @click="clkSelAll">
                        <label for="pall">全部</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pwx" v-model="sel_item" value="1">
                        <label for="pwx">微信</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pali" v-model="sel_item" value="2">
                        <label for="pali">支付宝</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pcard" v-model="sel_item" value="3">
                        <label for="pcard">会员卡</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pcash" v-model="sel_item" value="4">
                        <label for="pcash">现金</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pbank" v-model="sel_item" value="5">
                        <label for="pbank">刷卡</label>
                    </li>
                    <li>
                        <input type="checkbox" id="pafter" v-model="sel_item" value="10">
                        <label for="pafter">后买单</label>
                    </li>
                </ul>
            </div>
        </div>


        <!-- app支付方式设置 -->
        <div class="store-app-set" v-show="show2">
            <div class="app-list">
                <h1 class="title">app支付方式设置</h1>
                <div class="table-responsive">
                    <table id="appList" class="table table-bordered table-hover" data-pagination="true" ref="appList"
                        style="margin-top:10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(2)">返回</button>
                </div>
            </div>
            <div class="app-modify" ref="appAlert">
                <table>
                    <thead>
                        <th>支付方式</th>
                        <th>开启</th>
                        <th>优先级</th>
                        <th>操作</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>现金</td>
                            <td>{{ cash.status }}</td>
                            <td><input type="text" v-model="cash.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('cash', cash.btn)">{{ cash.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>刷卡</td>
                            <td>{{ swipe.status }}</td>
                            <td><input type="text" v-model="swipe.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('swipe', swipe.btn)">{{ swipe.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>会员卡</td>
                            <td>{{ vip.status }}</td>
                            <td><input type="text" v-model="vip.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('vip', vip.btn)">{{ vip.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>微信</td>
                            <td>{{ wx.status }}</td>
                            <td><input type="text" v-model="wx.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('wx', wx.btn)">{{ wx.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>支付宝</td>
                            <td>{{ ali.status }}</td>
                            <td><input type="text" v-model="ali.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('ali', ali.btn)">{{ ali.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>后买单（挂房后结）</td>
                            <td>{{ after.status }}</td>
                            <td><input type="text" v-model="after.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('after', after.btn)">{{ after.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>免单招待</td>
                            <td>{{ present.status }}</td>
                            <td><input type="text" v-model="present.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('present', present.btn)">{{ present.btn }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>会员赠送账户</td>
                            <td>{{ member.status }}</td>
                            <td><input type="text" v-model="member.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('member', member.btn)">{{ member.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>挂账</td>
                            <td>{{ hac.status }}</td>
                            <td><input type="text" v-model="hac.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('hac', hac.btn)">{{ hac.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy1.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy1.status }}</td>
                            <td><input type="text" v-model="zdy1.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy1', zdy1.btn)">{{ zdy1.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy2.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy2.status }}</td>
                            <td><input type="text" v-model="zdy2.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy2', zdy2.btn)">{{ zdy2.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy3.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy3.status }}</td>
                            <td><input type="text" v-model="zdy3.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy3', zdy3.btn)">{{ zdy3.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy4.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy4.status }}</td>
                            <td><input type="text" v-model="zdy4.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy4', zdy4.btn)">{{ zdy4.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy5.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy5.status }}</td>
                            <td><input type="text" v-model="zdy5.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy5', zdy5.btn)">{{ zdy5.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy6.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy6.status }}</td>
                            <td><input type="text" v-model="zdy6.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy6', zdy6.btn)">{{ zdy6.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy7.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy7.status }}</td>
                            <td><input type="text" v-model="zdy7.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy7', zdy7.btn)">{{ zdy7.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy8.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy8.status }}</td>
                            <td><input type="text" v-model="zdy8.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy8', zdy8.btn)">{{ zdy8.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy9.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy9.status }}</td>
                            <td><input type="text" v-model="zdy9.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy9', zdy9.btn)">{{ zdy9.btn }}</span></td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" v-model="zdy10.tit">
                                <span>(可改名称)</span>
                            </td>
                            <td>{{ zdy10.status }}</td>
                            <td><input type="text" v-model="zdy10.txt"></td>
                            <td><span class="edit-btn" @click="clkBtn('zdy10', zdy10.btn)">{{ zdy10.btn }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>



        <!-- 智慧商家app会员支付是否开启密码验证 -->
        <div class="store-card-set" v-show="show3">
            <div class="card-list">
                <h1 class="title">智慧商家app会员支付是否开启密码验证</h1>
                <div class="table-responsive">
                    <table id="cardList" class="table table-bordered table-hover" data-pagination="true" ref="cardList"
                        style="margin-top:10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(3)">返回</button>
                </div>
            </div>
        </div>


        <!-- app任务自动接收 -->
        <div class="store-sfr-set" v-show="show4">
            <div class="sfr-list">
                <h1 class="title">app任务自动接收</h1>
                <p class="p-hint">注：智慧商家app我的任务设置自动接收成功后，任务将不需要人工操作，系统自动接收完成。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="sfrList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(4)">返回</button>
                </div>
            </div>
            <div class="sfr-modify">
                <div class="page-tit">修改app任务自动接收</div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用门店：</label>
                    <div class="col-md-6 sfr-modify-shop">
                        {{ sfr_shop_name }}
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">自动接收任务：</label>
                    <div class="col-md-6 sfr-sel-list">
                        <h3>请选择自动接收的任务</h3>
                        <ul class="clearfix">
                            <li @click="sfrSel('1')">自动备货完成</li>
                            <li @click="sfrSel('2')">自动送达商品</li>
                            <li @click="sfrSel('3')">自动接收服务</li>
                            <li @click="sfrSel('4')">自动完成服务</li>
                            <li @click="sfrSel('5')">自动接收取酒单</li>
                            <li @click="sfrSel('6')">自动审核员工存酒单</li>
                            <li @click="sfrSel('7')">自动取酒配送完成</li>
                            <li @click="sfrSel('8')">自动清扫完成</li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backSfrList">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                        @click="sfrSub()">确定</button>
                </div>
            </div>
        </div>


        <!-- 扫微信取酒二维码设置 -->
        <div class="store-sqe-set" v-show="show5">
            <div class="sqe-list">
                <h1 class="title">扫微信取酒二维码设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="sqeList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(5)">返回</button>
                </div>
            </div>
        </div>


        <!-- 微信端播控设置 -->
        <div class="store-wxbk-set" v-show="show6">
            <div class="wxbk-list">
                <h1 class="title">微信端播控设置</h1>
                <p class="p-hint">注：关闭后则微信点歌页不显示对应操作按键</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wxbkList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(6)">返回</button>
                </div>
            </div>
        </div>


        <!-- 挂账人担保人是否需要密码验证 -->
        <div class="store-gdm-set" v-show="show7">
            <div class="gdm-list">
                <h1 class="title">挂账人担保人是否需要密码验证</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="gdmList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(7)">返回</button>
                </div>
            </div>
        </div>


        <!-- app历史任务权限是否细分到账号 -->
        <div class="store-lqx-set" v-show="show8">
            <div class="lqx-list">
                <h1 class="title">app历史任务权限是否细分到账号</h1>
                <p class="p-hint">注：【是】app历史任务只能查看自己账号操作过的历史任务。【否】app历史任务可以查看所有账号操作过的历史任务。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="lqxList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(8)">返回</button>
                </div>
            </div>
        </div>


        <!-- 结账是否进行员工验证 -->
        <div class="store-jyy-set" v-show="show9">
            <div class="jyy-list">
                <h1 class="title">结账是否进行员工验证</h1>
                <p class="p-hint">注：【是】则在账单页面显示结账人字段，且结账人需要输入员工工号/手机号码及密码进行身份确认。【否】则账单页面不显示结账人字段</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jyyList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(9)">返回</button>
                </div>
            </div>
        </div>


        <!-- 包厢营业额预警设置 -->
        <div class="store-byy-set" v-show="show10">
            <div class="byy-list" v-show="showByyList">
                <div class="row rowmagin">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="addByy">新增包厢营业额预警设置</button>
                </div>
                <h1 class="title">包厢营业额预警设置</h1>
                <div class="row">
                    <label class="ct-label">门店:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="byy_shop" data-placeholder="请选择门店"></select>
                    </div>
                    <label class="ct-label">包厢类型:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="byy_box_type" data-placeholder="请选择包厢类型"></select>
                    </div>
                    <label class="ct-label">状态:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="byy_status" data-placeholder="请选择状态">
                            <option value=" ">全部</option>
                            <option value="1">启用</option>
                            <option value="-1">禁用</option>
                        </select>
                    </div>
                    <div class="pull-right">
                        <button type="button" class="btn btn-flat btn-small btn-orange" @click="clkByyQuery">查询</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="byyList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(10)">返回</button>
                </div>
            </div>
            <div class="byy-edit" v-show="showByyEdit">
                <div class="page-tit">{{ byy_edit_tit }}</div>
                <p>注：开房时长设置成功后则相应时间消费额未达到/超出设定值时APP/一体机包厢状态页面会有警报提醒</p>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用门店：</label>
                    <div class="col-md-4 ct-col">
                        <select class="form-control" ref="byy_edit_shop"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">包厢类型：</label>
                    <div class="col-md-4 ct-col">
                        <select class="form-control" ref="byy_edit_box_type"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">开房时长：</label>
                    <div class="col-md-4">
                        <input class="form-control" v-model="byy_edit_time" ref="add_priority"
                            placeholder="请输入时长，示例：数字1，2...">
                    </div>
                    <span>分钟</span>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">营业额：</label>
                    <div class="col-md-4">
                        <input class="form-control" v-model="byy_edit_amount" ref="add_priority"
                            placeholder="请输入金额，示例：100，200...">
                    </div>
                    <span>元</span>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">有效时间段：</label>
                    <div class="col-md-4">
                        <input class="form-control input-readonly" v-model="byy_time_range" ref="byy_time_range"
                            placeholder="请选择有效时间段" readonly="readonly" @click="byyTimePop()">
                        <span class="selection_clear" @click="byy_clear_input('byy_time_range')">×</span>
                        <span class="printer_arrow" role="presentation">
                            <b role="presentation"></b>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">预警类型：</label>
                    <div class="col-md-4 ct-col">
                        <select class="form-control" ref="byy_edit_type">
                            <option value="1">低于</option>
                            <option value="2">超出</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">开启/禁用：</label>
                    <div class="col-md-4 ct-col">
                        <select class="form-control" ref="byy_edit_status">
                            <option value="1">开启</option>
                            <option value="-1">禁用</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backListByy">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="byySub"
                        ref="byy_sub">确定</button>
                </div>
                <!-- 使用时间弹窗 -->
                <div class="use-time-wrap" ref="byy_time_wrap">
                    <div class="chooseTime_popup-wrap">
                        <h2>开始时间：</h2>
                        <select ref="starthour"></select>
                        <label class="colon">:</label>
                        <select ref="startseconds"></select>
                        <h2>结束时间：</h2>
                        <select ref="stophour"></select>
                        <label class="colon">:</label>
                        <select ref="stopseconds"></select>
                    </div>
                </div>
            </div>
        </div>


        <!-- 经理打折是否剔除不打折商品 -->
        <div class="store-jds-set" v-show="show11">
            <div class="jds-list">
                <h1 class="title">经理打折是否剔除不打折商品</h1>
                <p class="p-hint">注：【是】商品不允许打折时不参与经理打折，【否】商品不允许打折时参与经理打折</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jdsList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(11)">返回</button>
                </div>
            </div>
        </div>


        <!-- 会员刷卡是否允许手动输入卡号 -->
        <div class="store-hsk-set" v-show="show12">
            <div class="hsk-list">
                <h1 class="title">会员刷卡是否允许手动输入卡号</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="hskList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(12)">返回</button>
                </div>
            </div>
        </div>


        <!-- 计时开房是否支持跨时段 -->
        <div class="store-jkk-set" v-show="show13">
            <div class="jkk-list">
                <h1 class="title">计时开房是否支持跨时段</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jkkList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(13)">返回</button>
                </div>
            </div>
        </div>


        <!-- 取消开房时限设置 -->
        <div class="store-qks-set" v-show="show14">
            <div class="qks-list">
                <h1 class="title">取消开房时限设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="qksList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(14)">返回</button>
                </div>
            </div>
            <!-- 修改 -->
            <div class="qks-edit" ref="qks_edit">
                <div class="row">
                    <label class="col-md-3">门店：</label>
                    <div class="col-md-8 ct-col">
                        <select class="form-control" ref="qks_shop" disabled></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">开房时长：</label>
                    <div class="col-md-5">
                        <input class="form-control" placeholder="请输入时长，示例：数字1，2" v-model="qks_minute"
                            :disabled="qks_limit">
                    </div>
                    <span class="ctr-hint-txt">分钟</span>
                    <el-checkbox v-model="qks_limit">不限制</el-checkbox>
                </div>
                <p class="p-hint">注：1、不限制，开房后任意时间可取消开房</p>
                <p class="p-hint">2、若设置为0，则开房后不支持取消开房</p>
                <p class="p-hint">3、若设置为1（或其他数值），则在对应数值的分钟数内可以取消开房，超过则不能取消开房</p>
            </div>
        </div>


        <!-- 团购套餐兑券是否授权销券 -->
        <div class="store-tsx-set" v-show="show15">
            <div class="tsx-list">
                <h1 class="title">团购套餐兑券是否授权销券</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="tsxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(15)">返回</button>
                </div>
            </div>
        </div>


        <!-- 全场霸屏设置 -->
        <div class="store-qbs-set" v-show="show16">
            <div class="qbs-list">
                <h1 class="title">全场霸屏设置</h1>
                <p class="p-hint">注：门店如果设置开启的话，电视界面全场霸屏和微信端霸屏功能可以显示。设置关闭的话，电视屏和微信端不显示霸屏相关界面</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="qbsList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(16)">返回</button>
                </div>
            </div>
        </div>


        <!-- 会员到店预警设置 -->
        <div class="store-hdy-set" v-show="show17">
            <div class="hdy-list">
                <h1 class="title">会员到店预警设置</h1>
                <div class="row row-margin">
                    <button type="button" class="btn btn-flat btn-big btn-orange" @click="addHdy">新增会员到店预警设置</button>
                </div>
                <div class="row">
                    <label class="list-label-2">门店:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="hdy_shop" data-placeholder="请选择门店"></select>
                    </div>
                    <label class="list-label-4">预警方式:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="hdy_type" data-placeholder="请选择状态">
                            <option value=" ">全部</option>
                            <option value="1">按消费总额</option>
                            <option value="2">按会员等级</option>
                        </select>
                    </div>
                    <label class="list-label-2">状态:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="hdy_status" data-placeholder="请选择状态">
                            <option value=" ">全部</option>
                            <option value="1">启用</option>
                            <option value="-1">禁用</option>
                        </select>
                    </div>
                    <button type="button" class="btn btn-flat btn-small btn-orange pull-right"
                        @click="clkHdyQuery">查询</button>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="hdyList"></table>
                </div>
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(17)">返回</button>
            </div>
            <div class="pb-edit-alert" ref="hdy_edit">
                <div class="row">
                    <label class="col-md-3">门店：</label>
                    <div class="col-md-9 ct-col">
                        <select class="form-control" data-placeholder="请选择门店" ref="hdy_edit_shop"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">会员到店预警方式：</label>
                    <div class="col-md-9 ct-col">
                        <select class="form-control" ref="hdy_edit_type">
                            <option value="1">按消费总额</option>
                            <option value="2">按会员等级</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">预警阈值设置：</label>
                    <div class="col-md-9" v-show="hdy_edit_radio == '1'">
                        金额大于等于 <input type="text" class="form-control" placeholder="请输入数字" v-model="hdy_mn_min"> 元
                        &nbsp;&nbsp;&nbsp;
                        金额小于等于 <input type="text" class="form-control" placeholder="请输入数字" v-model="hdy_mn_max"> 元
                    </div>
                    <div class="col-md-9" v-show="hdy_edit_radio == '2'">
                        等级大于等于 <input type="text" class="form-control" placeholder="请输入数字" v-model="hdy_lv_min"> 级
                        &nbsp;&nbsp;&nbsp;
                        等级小于等于 <input type="text" class="form-control" placeholder="请输入数字" v-model="hdy_lv_max"> 级
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-3">是否启用：</label>
                    <div class="col-md-9 ct-col">
                        <select class="form-control" ref="hdy_edit_status">
                            <option value="1">是</option>
                            <option value="-1">否</option>
                        </select>
                    </div>
                </div>
                <p class="p-hint">
                    注：预警阈值设置若大于小于均填写则为区间范围，设置如：500-1000元之间<br />若只填写大于或小于，则取值条件如500元以上/以下<br />支持填写任一条件均生效<br />会员等级设置只支持1-5级
                </p>
            </div>
        </div>


        <!-- 智慧麦克风低电量消息提醒 -->
        <div class="store-mdx-set" v-show="show18">
            <div class="mdx-list">
                <h1 class="title">智慧麦克风低电量消息提醒</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="mdxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(18)">返回</button>
                </div>
            </div>
        </div>
        <!-- 消息提醒时间 -->
        <div class="use-time-wrap" ref="mdx_usetime_alert">
            <div>
                <input type="checkbox" v-model="mdx_usetime_allday" value="1">
                <label>不提示</label>
            </div>
            <h2>开始时间：</h2>
            <select ref="mdx_starthour"></select>
            <label class="colon">:</label>
            <select ref="mdx_startseconds"></select>
            <h2>结束时间：</h2>
            <select ref="mdx_stophour"></select>
            <label class="colon">:</label>
            <select ref="mdx_stopseconds"></select>
        </div>


        <!-- 会员折扣是否仅会员支付时生效 -->
        <div class="store-vps-set" v-show="show19">
            <div class="vps-list">
                <h1 class="title">会员折扣是否仅会员支付时生效</h1>
                <p class="p-hint">注：选中【否】时会员折扣在任何支付方式下都生效。选中【是】时会员折扣仅在使用会员支付时生效，其他支付方式支付是正常售价。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="vpsList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(19)">返回</button>
                </div>
            </div>
        </div>


        <!-- 暂停营业时间设置 -->
        <div class="store-zys-set" v-show="show20">
            <div class="zys-list">
                <h1 class="title">暂停营业时间设置</h1>
                <p class="p-hint">注：暂停营业可设置暂停时段为12：00~06：00点，第二个营业日08：00系统将自动恢复营业。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zysList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(20)">返回</button>
                </div>
            </div>
            <!-- 修改 -->
            <div class="use-time-wrap" ref="zys_usetime_alert">
                <div class="zys-usetime-allday">
                    <input type="checkbox" v-model="zys_usetime_allday" value="1">
                    <label>无</label>
                </div>
                <select ref="zys_hour"></select>
                <label class="colon">:</label>
                <select ref="zys_seconds"></select>
            </div>
        </div>


        <!-- 酒水服务费是否参与账单经理打折 -->
        <div class="store-fjd-set" v-show="show21">
            <div class="fjd-list">
                <h1 class="title">酒水服务费是否参与账单经理打折</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="fjdList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(21)">返回</button>
                </div>
            </div>
        </div>


        <!-- 每次开房可使用券总量 -->
        <div class="store-mkq-set" v-show="show22">
            <div class="mkq-list">
                <h1 class="title">每次开房可使用券总量</h1>
                <p class="p-hint">注：每次开房可使用的各种券的总数量。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="mkqList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(22)">返回</button>
                </div>
            </div>
            <!-- 修改 -->
            <div class="use-time-wrap" ref="mkq_usetime_alert">
                <div class="mkq-usetime-allday">
                    <input type="checkbox" v-model="mkq_usetime_allday" value="1">
                    <label>不限制</label>
                </div>
                <div class="row">
                    <input type="text" class="form-control" placeholder="请输入每次开房可使用的券的总数量" ref="mkq_num"
                        v-model="mkq_num" />
                </div>
            </div>
        </div>


        <!-- 支付时优惠券是否打折 -->
        <div class="store-zyd-set" v-show="show23">
            <div class="zyd-list">
                <h1 class="title">支付时优惠券是否打折</h1>
                <p class="p-hint">注：【是】支付页面选择优惠券时，如使用经理打折或会员卡打折优惠券也会被打折，【否】支付页面选择优惠券时，如使用经理打折或会员卡打折优惠券也不会被打折。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zydList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(23)">返回</button>
                </div>
            </div>
        </div>


        <!-- 自助大厅支付形式设置 -->
        <div class="store-dzs-set" v-show="show24">
            <div class="dzs-list">
                <h1 class="title">自助大厅支付形式设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="dzsList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(24)">返回</button>
                </div>
            </div>
        </div>


        <!-- 微信在线预定类型 -->
        <div class="store-wzy-set" v-show="show25">
            <div class="wzy-list">
                <h1 class="title">微信在线预定类型</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wzyList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(25)">返回</button>
                </div>
            </div>
        </div>


        <!-- 手机短信类型模板设置 -->
        <div class="store-dlm-set" v-show="show26">
            <div class="dlm-list">
                <h1 class="title">手机短信类型模板设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="dlmList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(26)">返回</button>
                </div>
            </div>
        </div>


        <!-- 经理实收是否需要密码验证 -->
        <div class="store-jsy-set" v-show="show27">
            <div class="jsy-list">
                <h1 class="title">经理实收是否需要密码验证</h1>
                <p class="p-hint">注：【是】：APP操作经理实收时需要输入账号密码验证</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jsyList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(27)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单低消部分是否参与经理打折 -->
        <div class="store-djd-set" v-show="show28">
            <div class="djd-list">
                <h1 class="title">账单低消部分是否参与经理打折</h1>
                <p class="p-hint">【是】：账单消费的商品金额（除不能打折商品外），都能参与经理打折</p>
                <p class="p-hint">【否】：账单消费的商品金额（除不能打折商品外），超出低消的部分才能参与经理打折</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="djdList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(28)">返回</button>
                </div>
            </div>
        </div>


        <!-- 商品赠送是否需要密码验证 -->
        <div class="store-szy-set" v-show="show29">
            <div class="szy-list">
                <h1 class="title">商品赠送是否需要密码验证</h1>
                <p class="p-hint">【否】：APP操作商品赠送时不需要输入密码验证</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="szyList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(29)">返回</button>
                </div>
            </div>
        </div>


        <!-- 经理打折是否需要密码验证 -->
        <div class="store-jdy-set" v-show="show30">
            <div class="jdy-list">
                <h1 class="title">经理打折是否需要密码验证</h1>
                <p class="p-hint">【否】：APP操作经理打折时不需要输入密码验证</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jdyList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(30)">返回</button>
                </div>
            </div>
        </div>


        <!-- 微信扫码是否默认办理会员卡 -->
        <div class="store-smbh-set" v-show="show31">
            <div class="smbh-list" v-show="showSmbhList">
                <h1 class="title">微信扫码是否默认办理会员卡</h1>
                <p class="p-hint">【是】：用户使用微信扫描包厢点歌/点单二维码时，微信端页面直接跳转到办理会员卡页面</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="smbhList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(31)">返回</button>
                </div>
            </div>
            <!-- 修改适用包厢 -->
            <div class="smbh-room-set" v-show="!showSmbhList">
                <h1>修改适用包厢</h1>
                <div class="tip">请选择包厢</div>
                <div class="room-wrapper">
                    <div class="block-title">
                        <el-checkbox v-model="checkAllSmbhRoom" @change="handleCheckAllSmbhRoomChange">全选</el-checkbox>
                    </div>
                    <div class="block" v-for="(item, pindex) in smbhRoomList">
                        <div class="block-title">
                            <el-checkbox @change="checked => handleCheckSmbhArea(checked, pindex)"
                                v-model="item.checked">{{ item.room_area_name }}</el-checkbox>
                        </div>
                        <el-checkbox-group class="rooms" v-model="smbhChoosedRoom">
                            <el-checkbox class="room" v-for="(room, cindex) in item.room" :label="room.id" :key="room.id"
                                @change="checked => handleCheckSmbhRoom(checked, pindex, cindex)">{{ room.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <el-button @click="showSmbhList = true">返回</el-button>
                <el-button type="primary" @click="submitSmbhRoom">确认</el-button>
            </div>
        </div>


        <!-- app下单默认导购员设置 -->
        <div class="store-axm-set" v-show="show32">
            <div class="axm-list">
                <h1 class="title">app下单默认导购员设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="axmList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(32)">返回</button>
                </div>
            </div>
        </div>


        <!-- APP刷卡业务账号登录是否需要密码验证 -->
        <div class="store-szmy-set" v-show="show33">
            <div class="szmy-list">
                <h1 class="title">APP刷卡业务账号登录是否需要密码验证</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="szmyList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(33)">返回</button>
                </div>
            </div>
        </div>


        <!-- 开房剩余时长预警设置 -->
        <div class="store-kfyj-set" v-show="show34">
            <div class="kfyj-list">
                <h1 class="title">开房剩余时长预警设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="kfyjList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(34)">返回</button>
                </div>
            </div>
        </div>


        <!-- 花单金额是否与账单金额合并支付 -->
        <div class="store-hzhz-set" v-show="show35">
            <div class="hzhz-list">
                <h1 class="title">花单金额是否与账单金额合并支付</h1>
                <p class="p-hint">
                    注：【否】收款或结账买单时，支付金额不包含花单金额；【是】收款或结账买单时，支付金额包含花单金额；【手动选择】收款或结账买单时，支付金额默认不包含花单金额，收银可手动选择是否包含花单金额合并支付
                </p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="hzhzList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(35)">返回</button>
                </div>
            </div>
        </div>


        <!-- 包厢状态图当前消费与未收款是否包含花单金额 -->
        <div class="store-bzbh-set" v-show="show36">
            <div class="bzbh-list">
                <h1 class="title">包厢状态图当前消费与未收款是否包含花单金额</h1>
                <p class="p-hint">注：【是】当前消费金额与未收款金额包含了对应花单金额；【否】当前消费金额与未收款金额仅显示为酒水账单金额</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bzbhList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(36)">返回</button>
                </div>
            </div>
        </div>

        <!-- 不满低消时酒水服务费统计方式设置 -->
        <div class="store-bdjft-set" v-show="show37">
            <div class="bdjft-list">
                <h1 class="title">不满低消时酒水服务费统计方式设置</h1>
                <p class="p-hint">注：1 按低消金额折算服务费：仅低消开房，未满低消结账时，按照“低消金额*服务费收取比例”来收取酒水服务费</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bdjftList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(37)">返回</button>
                </div>
            </div>
        </div>

        <!-- 自助大厅扫码登录是否默认办理会员卡 -->
        <div class="store-zzsm-set" v-show="show38">
            <div class="wxbk-list">
                <h1 class="title">自助大厅扫码登录是否默认办理会员卡</h1>
                <p class="p-hint">注：选择“是”，则自助大厅对应模块扫码登录时，非会员用户微信扫码后默认进入办理会员卡页面</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zzsmList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(38)">返回</button>
                </div>
            </div>
        </div>

        <!-- 会员积分兑换是否支持连锁门店通用 -->
        <div class="store-hjdty-set" v-show="show39">
            <div class="bzbh-list">
                <h1 class="title">会员积分兑换是否支持连锁门店通用</h1>
                <p class="p-hint">注：选择“是”，用户在积分商城可切换选择会员卡通用的门店，即可兑换其他门店的商品/卡券</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="hjdtyList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(39)">返回</button>
                </div>
            </div>
        </div>

        <!-- 收银交接是否包含花单金额 -->
        <div class="store-sjbh-set" v-show="show40">
            <div class="wxbk-list">
                <h1 class="title">收银交接是否包含花单金额</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="sjbhList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(40)">返回</button>
                </div>
            </div>
        </div>

        <!-- 微信端会员条码显示设置 -->
        <div class="store-wxhtx-set" v-show="show41">
            <div class="wxbk-list">
                <h1 class="title">微信端会员条码显示设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wxhtxList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(41)">返回</button>
                </div>
            </div>
        </div>

        <!-- 账单员工可赠送比例金额是否扣除已赠送金额 -->
        <div class="store-zykzbj-set" v-show="show42">
            <div class="wxbk-list">
                <h1 class="title">账单员工可赠送比例金额是否扣除已赠送金额</h1>
                <p class="p-hint">注：【是】员工赠送时，按照员工账单消费金额可赠送比例算出可赠送金额时，需扣掉当前账单已赠送金额，超出的部分才能赠送</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zykzbjList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(42)">返回</button>
                </div>
            </div>
        </div>

        <!-- 客遗回收入库默认设置 -->
        <div class="store-kyrk-set" v-show="show43">
            <div class="wxbk-list">
                <h1 class="title">客遗回收入库默认设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="kyrkList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(43)">返回</button>
                </div>
            </div>
        </div>

        <!-- 点单收银待支付划线价显示 -->
        <div class="store-ddhxj-set" v-show="show44">
            <div class="wxbk-list">
                <h1 class="title">点单收银待支付划线价显示</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="ddhxjList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(44)">返回</button>
                </div>
            </div>
        </div>

        <!-- 报表默认检索时间设置 -->
        <div class="store-bbmss-set" v-show="show45">
            <div class="wxbk-list">
                <h1 class="title">报表默认检索时间设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bbmssList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(45)">返回</button>
                </div>
            </div>
        </div>

        <!-- 订台业绩是否包含未收款金额 -->
        <div class="store-dysbw-set" v-show="show46">
            <div class="wxbk-list">
                <h1 class="title">订台业绩是否包含未收款金额</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="dysbwList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(46)">返回</button>
                </div>
            </div>
        </div>

        <!-- 班次设置 -->
        <div class="store-bcsz-set" v-show="show47">
            <div class="wxbk-list">
                <h1 class="title">班次设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bcszList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(47)">返回</button>
                </div>
            </div>

            <!-- 班次修改弹窗 -->
            <div class="bcsz-pop ele-hide" ref="bcsz_pop">
                <div class="pop-row" v-for="(item, index) in bcszInfo">
                    <div class="pop-label">名称</div>
                    <el-input v-model="item.name" placeholder="请输入名称"></el-input>
                    <div class="pop-label">时段</div>
                    <el-time-picker v-model="item.start_time" format="HH:mm" value-format="HH:mm" placeholder="开始时间"
                        popper-class="high-index"></el-time-picker>
                    <span class="split">-</span>
                    <el-time-picker v-model="item.end_time" format="HH:mm" value-format="HH:mm" placeholder="结束时间"
                        popper-class="high-index"></el-time-picker>
                    <img src="../../../assets/images/vod_add.png" class="icon" v-show="index == 0" @click="addBcsz">
                    <img src="../../../assets/images/vod_del.png" class="icon" v-show="bcszInfo.length > 1"
                        @click="delBcsz(index)">
                </div>
            </div>
        </div>

        <!-- 收银机app包厢状态背景图设置 -->
        <div class="store-roombg-set" v-show="show48">
            <div class="smbh-list" v-show="!showRoomBgImgSet && !showRoomBgColorSet">
                <h1 class="title">收银app包厢状态图设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="roombgList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(48)">返回</button>
                </div>
            </div>
            <!-- 修改背景 -->
            <div class="room-bg-img-set" v-show="showRoomBgImgSet && !showRoomBgColorSet">
                <h1>选择背景图</h1>
                <div class="tip">注：自定义图片规范：尺寸1920*1080，大小不超过5M，图片格式均为png，如您上传图片不符规范，将不能显示或被压缩</div>
                <div class="bg-img-wrapper">
                    <div class="item" v-for="(item, pindex) in roomBgImgs">
                        <img :src="item.img_url" alt="" class="bg-img">
                        <img src="../../../assets/images/vod_del.png" alt="" class="del-icon" v-if="item.type == 2"
                            @click="delRoomBgImg(item.id)">
                        <el-radio v-model="roomBgImgId" :label="item.id">{{ "" }}</el-radio>
                    </div>
                    <div class="item" id="roomBgImgAdd">
                        <img src="../../../assets/images/adsc_up.png" alt="" class="bg-img">
                    </div>
                </div>
                <el-button @click="showRoomBgImgSet = false">返回</el-button>
                <el-button type="primary" @click="saveRoomBgImg">确认</el-button>
            </div>
            <!-- 修改房态底图颜色 -->
            <div class="room-bg-color-set" v-show="!showRoomBgImgSet && showRoomBgColorSet">
                <h1>房态底图设置</h1>
                <div class="room-colors-wrapper">
                    <div class="item" v-for="(item, index) in room_bg_colors">
                        <div class="opers">
                            <div class="back-to-default" @click="backToDefaultColor(index)">恢复默认</div>
                            <div class="custom-color" @click="openColorPickerPop(index)">自定义颜色</div>
                        </div>
                        <div class="color-box" :style="{ 'background-color': '#' + item.color }">
                            <div class="room-name">VIP888</div>
                            <div class="room-status">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <!-- 颜色选择器弹窗 -->
                <div class="color-picker-pop ele-hide" ref="color_picker_pop">
                    <chrome v-model="colorPickerPopColor" @input="onColorPickerChange" class="color-picker-chrome" />
                </div>
                <el-button @click="showRoomBgColorSet = false">返回</el-button>
                <el-button type="primary" @click="commitRoomBgColorSet">确认</el-button>
            </div>
        </div>

        <!-- 团购平台类型设置 -->
        <div class="store-tgpl-set" v-show="show49">
            <h1 class="title">团购平台类型设置</h1>
            <el-form :inline="true">
                <el-form-item label="门店">
                    <el-select v-model="tgpl_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="团购平台">
                    <el-input v-model="tgpl_form.name" placeholder="请输入团购平台名称" clearable></el-input>
                </el-form-item>
                <el-button type="primary" @click="getTgplList(1)">查询</el-button>
                <el-button type="primary" @click="addNewTgpl">新增平台</el-button>
            </el-form>
            <el-table v-loading="tgpl_loading" element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }" :data="tgpl_table">
                <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                <el-table-column prop="name" label="团购平台"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">{{ scope.row.status == '1' ? '启用' : '禁用' }}</template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="editTgpl(scope.row)">修改</span>
                        <span class="text-blue" @click="updateTgplStatus(scope.row.id, -2)"
                            v-if="scope.row.type - 0 < 2">删除</span>
                        <span class="text-blue" @click="updateTgplStatus(scope.row.id, 1)"
                            v-if="scope.row.status == '-1'">启用</span>
                        <span class="text-blue" @click="updateTgplStatus(scope.row.id, -1)"
                            v-if="scope.row.status == '1'">禁用</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="tgpl_page" :total="tgpl_total" @current-change="getTgplList">
            </el-pagination>
            <el-button @click="backIndex(49)">返回</el-button>
            <!-- 新增、修改弹窗 -->
            <div class="add-tgpl-pop ele-hide" ref="tgpl_pop">
                <el-form label-width="80px">
                    <el-form-item label="显示顺序">
                        <el-input v-model="tgpl_add_form.listorder" placeholder="请输入显示顺序（数字大的优先）"></el-input>
                    </el-form-item>
                    <el-form-item label="平台名称">
                        <el-input v-model="tgpl_add_form.name" placeholder="请输入平台名称"
                            :disabled="tgplModify && (tgpl_add_form.type - 0 > 1)"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 会员资料必填项设置 -->
        <div class="store-hzbt-set" v-show="show50">
            <div class="hzbt-list">
                <h1 class="title">会员资料必填项设置</h1>
                <p class="p-hint">注：设置“是”时，app端新增会员资料时对应项需必填</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="hzbtList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(50)">返回</button>
                </div>
            </div>
        </div>

        <!-- 微信端优惠券显示设置 -->
        <div class="store-wyx-set" v-show="show51">
            <div class="hzbt-list">
                <h1 class="title">微信端优惠券显示设置</h1>
                <p class="p-hint">注：关闭后，微信端不显示对应状态下的优惠券及存酒单</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wyxList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(51)">返回</button>
                </div>
            </div>
        </div>

        <!-- 排队取号会员是否独立排号 -->
        <div class="store-vipQueue-set" v-show="show52">
            <div class="hzbt-list">
                <h1 class="title">排队取号会员是否独立排号</h1>
                <p class="p-hint">注： 【是】排队取号输入手机号判断是会员的则独立排号</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="vipQueueList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(52)">返回</button>
                </div>
            </div>
        </div>

        <!-- 排队取号叫号语音文本设置 -->
        <div class="store-queueVoice-set" v-show="show53">
            <div class="hzbt-list">
                <h1 class="title">排队取号叫号语音文本设置</h1>
                <p class="p-hint">注： 用于app端排队取号中叫号时语音播报内容</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="queueVoiceList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(53)">返回</button>
                </div>
            </div>
        </div>
        <div class="voice-set-pop ele-hide" ref="voice_set_pop">
            <div class="params-txt">变量选择：<span @click="insertVariableText">【排队号】</span></div>
            <el-input type="textarea" ref="voiceTextarea" :rows="4" placeholder="请输入叫号语音播报文本内容，例：亲爱的 “【排队号】”朋友们，您的桌位已经准备好了，准备好享受您的欢快之夜吧！
                    注：未设置时，默认播报排队号" v-model="voice_call_content">
            </el-input>
        </div>

        <!-- 服务评价管理设置 -->
        <div class="store-serviceComment-set" v-show="show54">
            <div class="smbh-list" v-show="showServiceCommentList">
                <h1 class="title">服务评价管理设置</h1>
                <p class="p-hint">注：1 支持设置用户评价后开启自动送券。2 支持管理设置评价其他项内容</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="serviceCommentList">
                    </table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(54)">返回</button>
                </div>
            </div>
            <!-- 修改设置 -->
            <div class="service-comment-set" v-show="!showServiceCommentList">
                <h1>设置</h1>
                <div class="el-row">
                    <div class="row-label">门店：</div>
                    <div class="shop">{{ service_comment_form.shop_name }}</div>
                </div>
                <div class="el-row">
                    <div class="row-label">服务评价自动送券：</div>
                    <el-radio-group v-model="service_comment_form.comment_voucher_status">
                        <el-radio label="-1">关闭</el-radio>
                        <el-radio label="1">开启</el-radio>
                    </el-radio-group>
                    <el-input v-model="service_comment_form.comment_voucher_name"
                        :disabled="service_comment_form.comment_voucher_status == '-1'" placeholder="请选择赠送的券" readonly
                        @click.native="openVoucherPop">
                    </el-input>
                </div>
                <div class="el-row">
                    <div class="row-label">其他评价项内容设置：</div>
                    <div class="tip">每项最多6各字</div>
                </div>
                <div class="el-row">
                    <el-input class="short" clearable placeholder="请选择输入评价名称" maxlength="6"
                        v-for="(item, index) in service_comment_form.comment_type" v-model="item.name" :key="index">
                    </el-input>
                </div>
                <el-button @click="showServiceCommentList = true">返回</el-button>
                <el-button type="primary" @click="commitServiceCommentSet">确认</el-button>
            </div>
            <!-- 关联券弹窗 -->
            <div class="coupon-pop ele-hide" ref="coupon_pop">
                <el-form :inline="true">
                    <el-select v-model="service_comment_form.comment_voucher_type" placeholder="请选择"
                        @change="onVoucherTypeChange" popper-class="high-index" v-if="business_model == 2">
                        <el-option label="卡券" value="1"></el-option>
                        <el-option label="售货机商品券" value="2"></el-option>
                    </el-select>
                    <el-select v-model="card_type_name" filterable clearable placeholder="卡券类型"
                        v-if="service_comment_form.comment_voucher_type == '1'" @change="onPopQueryClick"
                        popper-class="high-index">
                        <el-option :label="item.text" :value="item.id" v-for="item in card_type"
                            :key="item.id"></el-option>
                    </el-select>
                    <el-select v-model="card_type_name" filterable clearable placeholder="商品券类型"
                        v-if="service_comment_form.comment_voucher_type == '2'" @change="onPopQueryClick"
                        popper-class="high-index">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="兑换券" value="1"></el-option>
                    </el-select>
                    <el-input v-model="query_voucher_name" clearable
                        :placeholder="service_comment_form.comment_voucher_type == '1' ? '请输入卡券名称' : '请输入商品券名称'"></el-input>
                    <el-button type="primary" @click="onPopQueryClick">查询</el-button>
                </el-form>
                <el-table v-loading="pop_loading" element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)" ref="coupon_table" :data="coupon_list"
                    @select="onPopCouponSelect">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                    <el-table-column prop="goods_name" label="名称"></el-table-column>
                    <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                </el-table>
                <el-pagination background layout="total, prev, pager, next, jumper" :page-size="coupon_page_size"
                    :current-page.sync="coupon_page" :total="coupon_total" @current-change="getPopCouponList">
                </el-pagination>
            </div>
        </div>

        <!-- 账单自助付款功能设置 -->
        <div class="store-selfPay-set" v-show="show55">
            <div class="smbh-list">
                <h1 class="title">账单自助付款功能设置</h1>
                <p class="p-hint">注：开启后，用户可通过微信包厢账单自助付款，也可通过扫打印账单二维码或触摸屏包厢账单二维码自助付款</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="selfPayList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(55)">返回</button>
                </div>
            </div>
            <!-- 设置弹窗 -->
            <div class="self-pay-pop ele-hide" ref="self_pay_pop">
                <el-form label-width="120px">
                    <el-form-item label="状态">
                        <el-radio-group v-model="self_pay_form.status">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="-1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="付款二维码显示">
                        <div class="red-tip">（仅账单存在未收款时显示）</div>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="self_pay_form.show.printer" :true-label="1"
                            :false-label="-1">打印账单</el-checkbox>
                        <el-checkbox v-model="self_pay_form.show.screen" :true-label="1"
                            :false-label="-1">触摸屏包厢账单</el-checkbox>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 会员自助注册用户协议设置 -->
        <div class="store-userAgreement-set" v-show="show56">
            <div v-show="!showUserAgreementContent">
                <h1 class="title">会员自助注册用户协议设置</h1>
                <p class="p-hint">注：开启后，用户微信自助注册会员时，需勾选阅读用户协议后才可办理</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="userAgreementList">
                    </table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(56)">返回</button>
                </div>
            </div>
            <div class="edit-panel" v-show="showUserAgreementContent">
                <h1>用户协议内容</h1>
                <quill-editor v-model="userAgreementContent" :options="{ placeholder: '请输入协议内容...' }"></quill-editor>
                <el-button @click="showUserAgreementContent = false">取消</el-button>
                <el-button type="primary" @click="commitUserAgreementContent">确认</el-button>
            </div>
        </div>

        <!-- 在线预订回执设置 -->
        <div class="store-onlineReserveReceipt-set" v-show="show57">
            <div v-show="showOnlineReserveReceiptList">
                <h1 class="title">在线预订回执设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true"
                        ref="onlineReserveReceiptList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(57)">返回</button>
                </div>
            </div>
            <div class="book-receipt-set-panel"
                v-show="!showOnlineReserveReceiptList && !showBookReceiptModuleBannerSet && !showBookReceiptModuleTextSet && !showBookReceiptModuleUserOperationSet">
                <h1>在线预订回执详情页自定义设置</h1>
                <p class="p-hint">注：1.在“设置”内操作“在线预订回执功能-开启“后，在线预订详情页将显示对应设置内容 2.排序数值大的靠前</p>
                <el-tabs v-model="book_receipt_scene_name" @tab-click="onBookReceiptSceneTabClick">
                    <el-tab-pane :label="item.operational_scene_name" 
                        :name="item.operational_scene_name" 
                        v-for="item in book_receipt_scene_list" 
                        :key="item.operational_scene">
                        <div class="pull-right" style="margin-bottom: 10px;">
                            <el-button type="primary" @click="openBookReceiptSetPop">设置</el-button>
                            <el-button type="primary" @click="addBookReceiptModule">新增内容</el-button>
                        </div>
                        <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                            element-loading-background="rgba(0, 0, 0, 0.6)" :data="book_receipt_module_list">
                            <el-table-column prop="listorder" label="排序"></el-table-column>
                            <el-table-column prop="type_name" label="类型"></el-table-column>
                            <el-table-column prop="status_name" label="状态"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="editBookReceiptModule(scope.row)">修改</span>
                                    <span class="text-blue" @click="delBookReceiptModule(scope.row.id)">删除</span>
                                    <span class="text-blue"
                                        @click="updateBookReceiptModuleStatus(scope.row.id)">{{ scope.row.status == -1 ? '启用' : '禁用' }}</span>
                                    <span class="text-blue" @click="bookReceiptModuleSetting(scope.row)"
                                        v-if="scope.row.type == 1 || scope.row.type == 2 || scope.row.type == 8">模块设置</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button @click="showOnlineReserveReceiptList = true">返回</el-button>

                    </el-tab-pane>
                </el-tabs>
                <!-- 设置弹窗 -->
                <div class="book-receipt-set-pop ele-hide" ref="book_receipt_set_pop">
                    <el-form label-width="140px" v-model="book_receipt_set_form">
                        <el-form-item label="在线预订回执功能">
                            <el-radio-group v-model="book_receipt_set_form.status">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="-1">关闭</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="预订回执页标题">
                            <el-input v-model="book_receipt_set_form.title" placeholder="请输入预订回执页顶部标题"></el-input>
                        </el-form-item>
                        <el-form-item label="被邀请页设置">
                            <el-checkbox v-model="book_receipt_set_form.share_priv" true-label="1"
                                false-label="-1">邀请好友</el-checkbox>
                            <el-checkbox v-model="book_receipt_set_form.open_room_priv" true-label="1"
                                false-label="-1">自助开房</el-checkbox>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 新增预订回执模块弹窗 -->
                <div class="add-book-receipt-module-pop ele-hide" ref="add_book_receipt_module_pop">
                    <el-form label-width="100px" v-model="add_book_receipt_module_form">
                        <el-form-item label="排序">
                            <el-input v-model="add_book_receipt_module_form.listorder" placeholder="请输入排序"></el-input>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-select v-model="add_book_receipt_module_form.type" placeholder="请选择类型"
                                popper-class="high-index" :disabled="!!add_book_receipt_module_form.id">
                                <el-option v-for="item in book_receipt_module_type" :label="item.name" :value="item.id"
                                    :key="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="视频标题" v-show="add_book_receipt_module_form.type == 4">
                            <el-input v-model="add_book_receipt_module_form.detail.title"
                                placeholder="请输入视频标题"></el-input>
                        </el-form-item>
                        <el-form-item label="视频封面" v-show="add_book_receipt_module_form.type == 4">
                            <div class="book-receipt-module-img-wrapper" id="add_book_receipt_module_poster">
                                <img :src="add_book_receipt_module_form.detail.img_url" alt=""
                                    v-if="add_book_receipt_module_form.detail.img_url">
                                <img src="../../../assets/images/upload_btn.png" alt="" v-else>
                            </div>
                        </el-form-item>
                        <el-form-item label="视频地址" v-show="add_book_receipt_module_form.type == 4">
                            <el-input v-model="add_book_receipt_module_form.detail.video_url" placeholder="请输入视频地址"
                                readonly></el-input>
                            <el-button type="primary" id="add_book_receipt_module_upload_video_btn"
                                @click="">上传视频</el-button>
                        </el-form-item>
                        <el-form-item label="图片标题" v-show="add_book_receipt_module_form.type == 5">
                            <el-input v-model="add_book_receipt_module_form.detail.title"
                                placeholder="请输入图片标题"></el-input>
                        </el-form-item>
                        <el-form-item label="图片" v-show="add_book_receipt_module_form.type == 5 || add_book_receipt_module_form.type == 10">
                            <div class="book-receipt-module-img-wrapper" id="add_book_receipt_module_img">
                                <img :src="add_book_receipt_module_form.detail.img_url" alt=""
                                    v-if="add_book_receipt_module_form.detail.img_url">
                                <img src="../../../assets/images/upload_btn.png" alt="" v-else>
                            </div>
                        </el-form-item>
                        <el-form-item label="标题"
                            v-show="add_book_receipt_module_form.type == 6 || add_book_receipt_module_form.type == 7">
                            <el-input v-model="add_book_receipt_module_form.detail.title"
                                placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="适用">
                            <el-checkbox-group v-model="add_book_receipt_module_form.detail.theme">
                                <el-checkbox v-for="item in book_receipt_theme_list" :key="item.theme"
                                    :label="item.theme">{{
                                    item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!-- banner图设置面板 -->
            <div class="banner-set-panel" v-show="showBookReceiptModuleBannerSet">
                <h1>banner-模块设置</h1>
                <p class="p-hint">注：1.图片规范：尺寸750*273，如您上传图片不符规范，将不能显示或被压缩</p>
                <el-button type="primary" @click="addModuleBanner">新增图片</el-button>
                <div class="banners-wrapper">
                    <div class="banner-item" v-for="(item, index) in book_receipt_module_detail" :key="index">
                        <el-form label-width="180px">
                            <el-form-item label="首页图片">
                                <div class="banner-item-img-wrapper" :id="`book-receipt-module-banner-img-${index}`">
                                    <img :src="item.img_url" alt="" v-if="item.img_url">
                                    <img src="../../../assets/images/upload_btn.png" alt="" v-else>
                                </div>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input v-model="item.listorder" placeholder="请输入排序"></el-input>
                            </el-form-item>
                            <el-form-item label="点击图片是否进入详情页">
                                <el-select v-model="item.enter" placeholder="请选择">
                                    <el-option label="是" :value="1"></el-option>
                                    <el-option label="否" :value="-1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="详情页样式" v-show="item.enter == 1">
                                <el-select v-model="item.enter_type" placeholder="请选择"
                                    @change="onEnterTypeChange(index)">
                                    <el-option label="图片" :value="1"></el-option>
                                    <el-option label="链接" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="详情页图片" v-show="item.enter_type == 1">
                                <div class="banner-item-img-wrapper" :id="`book-receipt-module-detail-img-${index}`">
                                    <img :src="item.detail_img" alt="" v-if="item.detail_img">
                                    <img src="../../../assets/images/upload_btn.png" alt="" v-else>
                                </div>
                            </el-form-item>
                            <el-form-item label="详情页链接" v-show="item.enter_type == 2">
                                <el-input v-model="item.detail_url" placeholder="请输入详情页链接" clearable></el-input>
                            </el-form-item>
                        </el-form>
                        <i class="el-icon-error" @click="delModuleBanner(index)"></i>
                    </div>
                </div>
                <el-button @click="showBookReceiptModuleBannerSet = false">返回</el-button>
                <el-button type="primary" @click="commitBookReceiptModuleDetailSet">确认</el-button>
            </div>
            <!-- 文案设置面板 -->
            <div class="text-set-panel" v-show="showBookReceiptModuleTextSet">
                <h1>文案-模块设置</h1>
                <quill-editor v-model="book_receipt_module_detail.content" :options="{ placeholder: '请输入文案...' }"
                    @ready="onEditorReady" ref="moduleTextEditor">
                </quill-editor>
                <div class="key-words-wrapper">
                    <div class="tip">变量：</div>
                    <div class="word-item" v-for="(item, index) in book_receipt_module_key_words" :key="index"
                        @click="onKeyWordClick(item)">#{{ item.name }}</div>
                </div>
                <el-button @click="showBookReceiptModuleTextSet = false">取消</el-button>
                <el-button type="primary" @click="commitBookReceiptModuleDetailSet">确认</el-button>
            </div>
            <!-- 用户操作设置面板 -->
            <div class="user-operation-set-panel" v-show="showBookReceiptModuleUserOperationSet">
                <h1>用户操作设置</h1>
                <div class="red-tip">注：可勾选需要显示的控制模块，数字大的排序靠前</div>
                <div class="user-operation-set-list">
                    <div class="user-operation-set-item" v-for="(item, index) in book_receipt_module_detail"
                        :key="index">
                        <el-form label-width="80px">
                            <el-form-item label="勾选模块">
                                <el-checkbox v-model="item.selected">{{ item.name }}</el-checkbox>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input v-model="item.listorder" placeholder="请输入排序"></el-input>
                            </el-form-item>
                            <el-form-item label="图片">
                                <div class="user-operation-img-wrapper"
                                    :id="`book-receipt-user-operation-img-${index}`">
                                    <img :src="item.img" alt="" v-if="item.img">
                                    <img src="../../../assets/images/upload_btn.png" alt="" v-else>
                                    <img src="../../../assets/images/vod_del.png" alt="" class="del-icon"
                                        v-if="item.img" @click.stop="delUserOperationImg(index)">
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <el-button @click="showBookReceiptModuleUserOperationSet = false">返回</el-button>
                <el-button type="primary" @click="commitBookReceiptModuleDetailSet">确认</el-button>
            </div>
        </div>

        <!-- 包厢状态新增预定必填项设置 -->
        <div class="store-roomReserveRequired-set" v-show="show58">
            <div class="hzbt-list">
                <h1 class="title">包厢状态新增预定必填项设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="roomReserveRequiredList"
                        style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                        @click="backIndex(58)">返回</button>
                </div>
            </div>
        </div>

        <!-- 智慧超市设置 -->
        <div class="store-smartMarket-set" v-show="show59">
            <div class="smartMarket-list" v-show="!isAdDetail">
                <h1 class="title">智慧超市设置</h1>
                <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)" :data="smartMarketList">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column label="包厢是否自动关联用户所在包厢">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.auto_link_room" placeholder="请选择" size="mini"
                                @change="setAdStatus(scope.row, 1)">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="包厢是否支持手动选择">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.room_open_chose" placeholder="请选择" size="mini"
                                @change="setAdStatus(scope.row, 2)">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="广告位设置">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.ad" placeholder="请选择" size="mini"
                                @change="setAdStatus(scope.row, 3)">
                                <el-option label="开启" value="1"></el-option>
                                <el-option label="关闭" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="toAdDetail(scope.row)">广告详情设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination 
                    background 
                    layout="total, prev, pager, next, jumper" 
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="smartMarketList_page" 
                    :total="smartMarketList_total" 
                    @current-change="getSmartMarketList">
                    </el-pagination>
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(59)">返回</button>
            </div>
            <div class="smartMarket-list" v-show="isAdDetail">
                <h1 class="title">广告详情设置</h1>
                <el-form :model="ad_form" label-width="120px">
                    <el-form-item label="广告封面样式" required>
                        <el-select v-model="ad_form.ad_type" placeholder="请选择广告封面样式" @change="changeType">
                            <el-option label="长图轮播" :value="1"></el-option>
                            <el-option label="3张大图" :value="2"></el-option>
                            <el-option label="多图轮播" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="block-item" v-for="(item, index) in ad_form.ads">
                        <p>图{{ index + 1 }}</p>
                        <img class="delete-icon" src="../../../assets/images/scrn_del.png"
                            v-if="ad_form.ad_type != 2 && ad_form.ads.length > 1 && index == ad_form.ads.length -1" @click="deleteThisImg(index)" />
                        <el-form-item label="广告封面" required>
                            <span>{{ ad_form.ad_type == 1 ? '图片比例长1020*宽140，大小不超过2m' : '图片比例1920*1080，大小不超过2M' }}</span>
                            <div class="img-wrapper" :class="{ 'big-img': ad_form.ad_type == 1 }" v-if="item.img == ''"
                                :id="'faceImg' + index">
                                <img src="../../../assets/images/icon_add.png" alt="" class="add-icon">
                                <div class="add-txt">点击上传图片</div>
                            </div>
                            <div class="img-wrapper" :class="{ 'big-img': ad_form.ad_type == 1 }" v-else
                                :id="'faceImg' + index">
                                <img :src="item.img" alt="" class="ad-img">
                            </div>
                        </el-form-item>
                            <el-form-item label="广告详情样式" required>
                            <el-radio v-model="item.style" label="-1" @change="(val)=>contentTypeChange(val, index)">无</el-radio>
                            <el-radio v-model="item.style" label="1" @change="(val)=>contentTypeChange(val, index)">图片</el-radio>
                            <div class="red-tip">{{item.style=='-1'?'点击广告封面无任何响应':item.style=='1'?'点击广告封面后，则进入广告详情页，并显示上传的图片':''}}</div>
	                    </el-form-item>
                        <el-form-item label="广告详情页内容" v-if="item.style=='1'">
                            <span>{{'图片比例1080*1920或者1920*1080，大小不超过2M'}}</span>
                            <div class="img-wrapper normal-img" v-if="item.content==''" :id="'contentImg'+index">
                                <img src="../../../assets/images/icon_add.png" alt="" class="add-icon">
                                <div class="add-txt">点击上传图片</div>
                            </div>
                            <div class="img-wrapper normal-img" v-else :id="'contentImg'+index">
                                <img :src="item.content" alt="" class="content-img">
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item v-if="ad_form.ad_type == 3 || ad_form.ad_type == 1">
                            <el-button type="primary" @click="addImg">新增图片</el-button>
                        </el-form-item>
                </el-form>
                <el-button @click="backSmartMarket">返回</el-button>
                <el-button type="primary" @click="commitAdDetail">确认</el-button>
            </div>
        </div>

        <!-- 到店指引设置 -->
        <div class="store-guide-set" v-show="show60">
            <div class="guide-list">
                <h1 class="title">到店指引设置</h1>
                <el-table 
                    :data="guideList" 
                    style="width: 100%" 
                    v-loading="loading" 
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                    >
                    <el-table-column prop="shop_name" label="门店" />
                    <el-table-column label="到店指引是否开启">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.shop_guide_status" @change="changeGuideStatus(scope.row)" placeholder="请选择" size="mini">
                                <el-option label="开启" value="1"></el-option>
                                <el-option label="关闭" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="到店指引图片">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.shop_guide_img != ''" type="text" size="mini" @click="showGuideImg(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="listorder" label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.shop_guide_img == ''" type="text" size="mini" @click="guideSet(scope.row)">上传</el-button>
                            <el-button v-else type="text" size="mini" @click="guideSet(scope.row)">重新上传</el-button>
                            <el-button v-if="scope.row.shop_guide_img != ''" type="text" size="mini" @click="delGuide(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination 
                    background 
                    layout="total, prev, pager, next, jumper" 
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="guide_page" 
                    :total="guide_total" 
                    @current-change="getStoreGuideList">
                    </el-pagination>
            </div>
            <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(60)">返回</button>
        </div>

        <!-- 到店指引设置弹窗 -->
        <div class="guide-set-pop" ref="guide_set_pop">
            <el-form :model="guide_form" label-width="90px">
                <div class="tip">注：图片宽度限制750px，高度不限，格式仅支持jpg、png，图片大小不超过5M</div>
                <el-form-item label="到店指引" required>
                    <div class="upload-img-wrapper" id="guide-img-uploader">
                        <img :src="guide_form.shop_guide_img" style="max-width: 200px;" alt="" class="uploaded-img" v-if="guide_form.shop_guide_img != ''">
                        <img src="../../../assets/images/upload_btn.png" alt="" class="upload-img" v-else>
                        <div class="txt" v-if="guide_form.shop_guide_img == ''">点击上传图片</div>
                        <img src="../../../assets/images/vod_del.png" alt="" class="del-icon" v-if="guide_form.shop_guide_img != ''" @click.stop="delGuideImg()">
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import 'quill/dist/quill.core.css'; // Quill 的核心样式
import 'quill/dist/quill.snow.css'; // Quill 的雪主题样式
import { quillEditor } from 'vue-quill-editor';
import { Chrome } from 'vue-color';
import Global from '../../../components/global.vue';
export default {
    name: '',
    components: {
        quillEditor,
        Chrome,
    },
    data() {
        return {
            show1: false,
            show2: false,
            show3: false,
            show4: false,
            show5: false,
            show6: false,
            show7: false,
            show8: false,
            show9: false,
            show10: false,
            show11: false,
            show12: false,
            show13: false,
            show14: false,
            show15: false,
            show16: false,
            show17: false,
            show18: false,
            show19: false,
            show20: false,
            show21: false,
            show22: false,
            show23: false,
            show24: false,
            show25: false,
            show26: false,
            show27: false,
            show28: false,
            show29: false,
            show30: false,
            show31: false,
            show32: false,
            show33: false,
            show34: false,
            show35: false,
            show36: false,
            show37: false,
            show38: false,
            show39: false,
            show40: false,
            show41: false,
            show42: false,
            show43: false,
            show44: false,
            show45: false,
            show46: false,
            show47: false,
            show48: false,
            show49: false,
            show50: false,
            show51: false,
            show52: false,
            show53: false,
            show54: false,
            show55: false,
            show56: false,
            show57: false,
            show58: false,
            show59: false,
            show60: false,

            // 微信/支付宝端支付方式配置
            sel_all: false,
            c_sel_all: false,
            sel_item: [],
            sel_data: [{ id: "1", name: "微信" }, { id: "2", name: "支付宝" }, { id: "3", name: "会员卡" }, { id: "4", name: "现金" }, { id: "5", name: "刷卡" }, { id: "10", name: "后买单" }],

            // app支付方式设置
            cash: {
                status: '',
                btn: '',
                txt: ''
            },
            swipe: {
                status: '',
                btn: '',
                txt: ''
            },
            vip: {
                status: '',
                btn: '',
                txt: ''
            },
            wx: {
                status: '',
                btn: '',
                txt: ''
            },
            ali: {
                status: '',
                btn: '',
                txt: ''
            },
            after: {
                status: '',
                btn: '',
                txt: ''
            },
            present: {
                status: '',
                btn: '',
                txt: ''
            },
            member: {
                status: '',
                btn: '',
                txt: ''
            },
            hac: {
                status: '',
                btn: '',
                txt: ''
            },
            zdy1: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy2: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy3: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy4: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy5: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy6: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy7: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy8: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy9: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },
            zdy10: {
                status: '',
                btn: '',
                txt: '',
                tit: '',
            },

            // 智慧商家app会员卡号支付是否开启密码
            card_sel: '',

            // app任务自动接收
            sfr_shop_id: '',
            sfr_shop_name: '',
            sfr_auto_receive: [],

            // 包厢营业额预警设置
            showByyList: true,
            showByyEdit: false,
            byy_modify: '1',
            byy_edit_id: '',
            byy_edit_tit: '新增包厢营业额预警设置',
            byy_edit_time: '',
            byy_start_time: '',
            byy_end_time: '',
            byy_edit_amount: '',

            // 取消开房时限设置
            qks_minute: '',
            qks_limit: true,

            // 会员到店预警设置
            hdy_modify: '1',
            hdy_edit_radio: '1',
            hdy_mn_max: '',
            hdy_mn_min: '',
            hdy_lv_max: '',
            hdy_lv_min: '',

            // 智慧麦克风低电量消息提醒
            mdx_usetime_allday: '',

            // 暂停营业时间设置
            zys_usetime_allday: '',

            // 每次开房可使用券总量
            mkq_usetime_allday: '',
            mkq_num: '',

            // 微信扫码是否默认办理会员卡
            smbh_shop_id: '',
            showSmbhList: true,
            checkAllSmbhRoom: false,
            smbhRoomList: [], // 全部包厢列表
            smbhChoosedRoom: [], // 选择的包厢

            bcszInfo: [], // 班次设置信息
            showRoomBgImgSet: false, // 显示收银机app包厢背景图设置面板
            roomBgImgs: [], // 背景图列表
            roomBgImgId: '', // 选择的背景图id
            roomBgImgUploader: [],
            shop_id: '',
            showRoomBgColorSet: false, // 显示房态底图颜色设置
            room_bg_colors: [],
            colorPickerPopColor: '#ffffff',
            colorPickerIndex: -1,
            //团购平台类型设置
            shop_list: [],
            tgpl_form: {
                shop_id: '',
                name: ''
            },
            tgpl_loading: false,
            tgpl_total: 0,
            tgpl_page: 1,
            tgpl_table: [],
            tgpl_add_form: {
                id: '',
                shop_id: '',
                listorder: '',
                name: '',
                type: '',
            },
            tgplModify: false,

            voice_call_content: '',// 排队叫号语音播报内容
            // 服务评价管理设置
            showServiceCommentList: true,
            service_comment_form: {
                shop_id: '',
                shop_name: '',
                comment_voucher_status: '-1',
                comment_voucher_type: '1', // 1巨嗨卡券 2友宝售后机商品券
                comment_voucher_id: '', // 送券id
                comment_voucher_name: '', // 送券名称
                comment_type: []
            },
            card_type: [{
                id: '',
                text: '全部'
            }, {
                id: '1',
                text: '优惠券'
            }, {
                id: '2',
                text: '物品券'
            }, {
                id: '3',
                text: '商品套餐券'
            }, {
                id: '4',
                text: '开房套餐券'
            }],
            card_type_name: '', // 卡券名称
            query_voucher_name: '', // 关联券弹窗检索名称
            coupon_page: 1,
            coupon_page_size: 5,
            coupon_total: 0,
            coupon_list: [],
            pop_loading: false,
            choosedVoucher: {}, // 选择的关联券

            self_pay_form: {
                shop_id: '',
                status: '1',
                show: {
                    printer: '1',
                    screen: '1',
                }
            },

            showUserAgreementContent: false,
            userAgreementContent: '',
            // 在线预订回执设置
            loading: false,
            showOnlineReserveReceiptList: true,
            shop_book_receipt: {}, // 预订回执各场景设置
            book_receipt_set_form: {
                shop_id: '',
                operational_scene: '',
                status: '',
                title: '',
                share_priv: '',
                open_room_priv: '',
            },
            book_receipt_operational_scene: '', // 预订回执场景
            book_receipt_scene_name: '', // 预订回执场景名称
            book_receipt_scene_list: [], // 预订回执场景列表
            book_receipt_module_type: [], // 预订回执模块类型
            book_receipt_module_list: [], // 预订回执模块列表
            add_book_receipt_module_form: {
                shop_id: '',
                operational_scene: '', // 场景
                id: '', // 模块id
                listorder: '', // 排序
                type: '', // 模块类型，1：banner，2：文案，3：门店地址，4：视频，5：图片，6：包厢素材，7：商品预购，8：用户操作，9：聚会好友列表
                detail: {
                    theme: [], // 主题
                    title: '',
                    img_url: '',
                    video_url: '',
                }
            },
            showBookReceiptModuleBannerSet: false,
            showBookReceiptModuleTextSet: false,
            book_receipt_module_detail: [],
            book_receipt_module_id: '',
            book_receipt_module_oper_type: '', // 操作的模块类型
            book_receipt_module_key_words: [], // 关键字
            book_receipt_theme_list: [], // 主题列表
            showBookReceiptModuleUserOperationSet: false,

            // 智慧超市设置
            smartMarketList: [],
            smartMarketList_total: 0,
            smartMarketList_page: 1,
            isAdDetail: false,
            // 广告详情表单
            ad_form: {
                ad_type: 1, //广告封面样式 1:长图轮播 2:三张大图 3:多图轮播
                shop_id: '', //店铺id
                ads: [
                    {
                        id: '', //新增时不传
                        content: '',//广告详情内容
                        img: '',//广告封面
                        style: '1' //广告详情样式 -1：无 1:图片
                    }
                ]
            },
            plupload_list: [],
            now_shop_id: '',

            // 到店指引
            guideList: [],
            guide_page: 1,
            guide_total: 0,
            guide_form: {
                shop_id: '',
                shop_guide_img: '',
                shop_guide_status: '',
            },
            guide_img_uploader: [], // 到店指引上传实例
        }
    },
    computed: {
        // 包厢营业额预警设置
        byy_time_range() {
            return this.byy_start_time + "-" + this.byy_end_time;
        },
        // 社区模式
        business_model() {
            return this.$store.state.business_model
        },
    },
    watch: {
        // 微信/支付宝端支付方式配置
        sel_item: {
            handler: function (val, oldVal) {
                if (this.sel_item.length >= this.sel_data.length) {
                    this.sel_all = true;
                    this.c_sel_all = true;
                } else {
                    this.sel_all = false;
                    this.c_sel_all = false;
                }
            },
            deep: true
        },

        // 智慧麦克风低电量消息提醒
        mdx_usetime_allday: {
            handler: function (val, oldVal) {
                if (val == '1') {
                    $(this.$refs.mdx_starthour).attr('disabled', true);
                    $(this.$refs.mdx_startseconds).attr('disabled', true);
                    $(this.$refs.mdx_stophour).attr('disabled', true);
                    $(this.$refs.mdx_stopseconds).attr('disabled', true);
                } else {
                    $(this.$refs.mdx_starthour).attr('disabled', false);
                    $(this.$refs.mdx_startseconds).attr('disabled', false);
                    $(this.$refs.mdx_stophour).attr('disabled', false);
                    $(this.$refs.mdx_stopseconds).attr('disabled', false);
                }
            },
            deep: true
        },

        // 暂停营业时间设置
        zys_usetime_allday: {
            handler: function (val, oldVal) {
                if (val == '1') {
                    $(this.$refs.zys_hour).attr('disabled', true);
                    $(this.$refs.zys_seconds).attr('disabled', true);
                } else {
                    $(this.$refs.zys_hour).attr('disabled', false);
                    $(this.$refs.zys_seconds).attr('disabled', false);
                }
            },
            deep: true
        },

        // 每次开房可使用券总量
        mkq_usetime_allday: {
            handler: function (val, oldVal) {
                if (val == '1') {
                    $(this.$refs.mkq_num).attr('disabled', true);
                } else {
                    $(this.$refs.mkq_num).attr('disabled', false);
                }
            },
            deep: true
        },
    },
    mounted: function () {
    },
    methods: {
        // 显示页面
        showTargetPage(num) {
            this[`show${num}`] = true

            if (num == '1') {
                this.innitTable()
            } else if (num == '2') {
                this.innitAppTable()
            } else if (num == '3') {
                this.innitCardTable()
            } else if (num == '4') {
                this.innitSfrTable()
            } else if (num == '5') {
                this.innitSqeTable()
            } else if (num == '6') {
                this.innitWxbkTable()
            } else if (num == '7') {
                this.innitGdmTable()
            } else if (num == '8') {
                this.innitLqxTable()
            } else if (num == '9') {
                this.innitJyyTable()
            } else if (num == '10') {
                this.getShopData('byy')
                $(this.$refs.byy_status).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })
                $(this.$refs.byy_edit_type).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })
                $(this.$refs.byy_edit_status).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })
                this.byySelectTime()
            } else if (num == '11') {
                this.innitJdsTable()
            } else if (num == '12') {
                this.innitHskTable()
            } else if (num == '13') {
                this.innitJkkTable()
            } else if (num == '14') {
                this.innitQksTable()
                this.getShopData('qks')
            } else if (num == '15') {
                this.innitTsxTable()
            } else if (num == '16') {
                this.innitQbsTable()
            } else if (num == '17') {
                this.getShopData('hdy')
                $(this.$refs.hdy_type).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })
                $(this.$refs.hdy_status).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })

                $(this.$refs.hdy_edit_type).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                }).on("select2:select", function (e) {
                    this.hdy_edit_radio = e.params.data.id
                })
                $(this.$refs.hdy_edit_status).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                })
            } else if (num == '18') {
                this.innitMdxTable()
                this.initMdxTime()
            } else if (num == '19') {
                this.innitVpsTable()
            } else if (num == '20') {
                this.initZysTime()
                this.innitZysTable()
            } else if (num == '21') {
                this.innitFjdTable()
            } else if (num == '22') {
                this.innitMkqTable()
            } else if (num == '23') {
                this.innitZydTable()
            } else if (num == '24') {
                this.innitDzsTable()
            } else if (num == '25') {
                this.innitWzyTable()
            } else if (num == '26') {
                this.innitDlmTable()
            } else if (num == '27') {
                this.innitJsyTable()
            } else if (num == '28') {
                this.innitDjdTable()
            } else if (num == '29') {
                this.innitSzyTable()
            } else if (num == '30') {
                this.innitJdyTable()
            } else if (num == '31') {
                this.innitSmbhTable(1)
            } else if (num == '32') {
                this.innitAxmTable(1)
            } else if (num == '33') {
                this.innitSzmyTable(1)
            } else if (num == '34') {
                this.innitKfyjTable(1)
            } else if (num == '35') {
                this.innitHzhzTable()
            } else if (num == '36') {
                this.innitBzbhTable()
            } else if (num == '37') {
                this.innitBdjftTable()
            } else if (num == '38') {
                this.innitZzsmTable()
            } else if (num == '39') {
                this.innitHjdtyTable()
            } else if (num == '40') {
                this.innitSjbhTable()
            } else if (num == '41') {
                this.innitWxhtxTable()
            } else if (num == '42') {
                this.innitZykzbjTable()
            } else if (num == '43') {
                this.innitKyrkTable()
            } else if (num == '44') {
                this.innitDdhxjTable()
            } else if (num == '45') {
                this.innitBbmssTable()
            } else if (num == '46') {
                this.innitDysbwTable()
            } else if (num == '47') {
                this.innitBcszTable()
            } else if (num == '48') {
                this.innitRoomBgTable()
            } else if (num == '49') {
                new Promise(resolve => {
                    this.getShopList(resolve)
                }).then(res => {
                    this.tgpl_form.shop_id = this.shop_list[0].id;
                    this.getTgplList(1);
                })
            } else if (num == '50') {
                this.innitHzbtTable()
            } else if (num == '51') {
                this.innitWyxTable()
            } else if (num == '52') {
                this.innitVipQueueTable()
            } else if (num == '53') {
                this.innitQueueVoiceTable()
            } else if (num == '54') {
                this.innitServiceCommentTable()
            } else if (num == '55') {
                this.innitSelfPayTable()
            } else if (num == '56') {
                this.innitUserAgreementTable()
            } else if (num == '57') {
                this.innitOnlineReserveReceiptTable()
                this.getBookReceiptModuleTypeList() // 获取预订回执模块类型列表
                this.getBookReceiptThemeList() // 获取预订回执主题列表
            } else if (num == '58') {
                this.innitRoomReserveRequiredTable()
            } else if (num == '59') {
                this.getSmartMarketList()
            } else if (num == '60') {
                // 到店指引设置
                this.getStoreGuideList()
            }
        },
        // 返回
        backIndex(index) {
            this[`show${index}`] = false
            this.$emit('targetBack')
        },
        // 获取门店数据
        getShopData: function (name) {
            let _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let arr = [];
                        $.each(data.response.result, function (k, v) {
                            arr.push({ id: v.id, text: v.name });
                        });
                        arr.shift();

                        if (name == 'byy') {
                            $(_this.$refs.byy_shop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function (e) {
                                $(_this.$refs.byy_box_type).prop('disabled', true);
                                _this.getByyBoxType(e.params.data.id, '1');
                            });
                            $(_this.$refs.byy_box_type).prop('disabled', true);
                            _this.getByyBoxType($(_this.$refs.byy_shop).val(), '1');
                            _this.innitByyTable();

                            $(_this.$refs.byy_edit_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function (e) {
                                $(_this.$refs.byy_edit_box_type).prop('disabled', true);
                                _this.getByyBoxType(e.params.data.id, '2');
                            });
                        } else if (name == 'qks') {
                            $(_this.$refs.qks_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else if (name == 'hdy') {
                            $(_this.$refs.hdy_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                            _this.innitHdyTable();

                            $(_this.$refs.hdy_edit_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.data.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },


        /*
         * 微信/支付宝端支付方式配置
         */
        innitTable: function () {
            let _this = this;
            $(_this.$refs.payList).bootstrapTable('destroy')
            $(_this.$refs.payList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getPayList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "pay_platform_name",
                    title: "微信/支付宝端支付方式配置",
                    width: "30%"
                }, {
                    title: "操作",
                    width: "30%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.sel_item = row.pay_platform;
                            _this.openModify(row);
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>'
                    }
                }]
            });
        },
        getPayList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "shop/getShopPayPlatformSetting",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 修改
        openModify: function (row) {
            var _this = this;
            if (_this.sel_item == '') {
                _this.sel_item = [];
            }
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['修改', true],
                area: ['400px', ''], // 宽高
                content: $(_this.$refs.payAlert)
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": row.shop_id,
                            "pay_platform": _this.sel_item
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/setShopPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.payList).bootstrapTable('refresh')
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 全选
        clkSelAll: function () {
            var _this = this;
            _this.sel_all = _this.c_sel_all;
            if (!_this.sel_all) { // 实现全选
                _this.sel_item = [];
                _this.sel_data.forEach(function (item) {
                    _this.sel_item.push(item.id);
                });
            } else { // 实现反选
                _this.sel_item = [];
            }
        },
        // 清空多选
        clearInput: function (name) {
            if (name == "scrn_room_txt") {
                this.scrn_all_rooms = '-1';
                this.scrn_room_txt = '';
                this.scrn_room_item = [];
            }
        },


        /*
         * app支付方式设置
         */
        innitAppTable: function () {
            let _this = this;
            $(_this.$refs.appList).bootstrapTable('destroy')
            $(_this.$refs.appList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getAppList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "app_pay_platform",
                    title: "智慧商家app支付方式配置",
                    width: "30%"
                }, {
                    title: "操作",
                    width: "30%",
                    events: {
                        'click .modify': function (e, value, row) {
                            if (row.config.cash.s == '1') {
                                _this.cash.status = '启用中';
                                _this.cash.btn = '禁用';
                            } else if (row.config.cash.s == '-1') {
                                _this.cash.status = '禁用中';
                                _this.cash.btn = '启用';
                            }
                            _this.cash.txt = row.config.cash.l;

                            if (row.config.swipe.s == '1') {
                                _this.swipe.status = '启用中';
                                _this.swipe.btn = '禁用';
                            } else if (row.config.swipe.s == '-1') {
                                _this.swipe.status = '禁用中';
                                _this.swipe.btn = '启用';
                            }
                            _this.swipe.txt = row.config.swipe.l;

                            if (row.config.vip.s == '1') {
                                _this.vip.status = '启用中';
                                _this.vip.btn = '禁用';
                            } else if (row.config.vip.s == '-1') {
                                _this.vip.status = '禁用中';
                                _this.vip.btn = '启用';
                            }
                            _this.vip.txt = row.config.vip.l;

                            if (row.config.wx.s == '1') {
                                _this.wx.status = '启用中';
                                _this.wx.btn = '禁用';
                            } else if (row.config.wx.s == '-1') {
                                _this.wx.status = '禁用中';
                                _this.wx.btn = '启用';
                            }
                            _this.wx.txt = row.config.wx.l;

                            if (row.config.ali.s == '1') {
                                _this.ali.status = '启用中';
                                _this.ali.btn = '禁用';
                            } else if (row.config.ali.s == '-1') {
                                _this.ali.status = '禁用中';
                                _this.ali.btn = '启用';
                            }
                            _this.ali.txt = row.config.ali.l;

                            if (row.config.pay_after.s == '1') {
                                _this.after.status = '启用中';
                                _this.after.btn = '禁用';
                            } else if (row.config.pay_after.s == '-1') {
                                _this.after.status = '禁用中';
                                _this.after.btn = '启用';
                            }
                            _this.after.txt = row.config.pay_after.l;

                            if (row.config.pay_present.s == '1') {
                                _this.present.status = '启用中';
                                _this.present.btn = '禁用';
                            } else if (row.config.pay_present.s == '-1') {
                                _this.present.status = '禁用中';
                                _this.present.btn = '启用';
                            }
                            _this.present.txt = row.config.pay_present.l;

                            if (row.config.present_account.s == '1') {
                                _this.member.status = '启用中';
                                _this.member.btn = '禁用';
                            } else if (row.config.present_account.s == '-1') {
                                _this.member.status = '禁用中';
                                _this.member.btn = '启用';
                            }
                            _this.member.txt = row.config.present_account.l;

                            if (row.config.hanging_account.s == '1') {
                                _this.hac.status = '启用中';
                                _this.hac.btn = '禁用';
                            } else if (row.config.hanging_account.s == '-1') {
                                _this.hac.status = '禁用中';
                                _this.hac.btn = '启用';
                            }
                            _this.hac.txt = row.config.hanging_account.l;

                            if (row.config.custom_1.s == '1') {
                                _this.zdy1.status = '启用中';
                                _this.zdy1.btn = '禁用';
                            } else if (row.config.custom_1.s == '-1') {
                                _this.zdy1.status = '禁用中';
                                _this.zdy1.btn = '启用';
                            }
                            _this.zdy1.txt = row.config.custom_1.l;
                            _this.zdy1.tit = row.config.custom_1.n;

                            if (row.config.custom_2.s == '1') {
                                _this.zdy2.status = '启用中';
                                _this.zdy2.btn = '禁用';
                            } else if (row.config.custom_2.s == '-1') {
                                _this.zdy2.status = '禁用中';
                                _this.zdy2.btn = '启用';
                            }
                            _this.zdy2.txt = row.config.custom_2.l;
                            _this.zdy2.tit = row.config.custom_2.n;

                            if (row.config.custom_3.s == '1') {
                                _this.zdy3.status = '启用中';
                                _this.zdy3.btn = '禁用';
                            } else if (row.config.custom_3.s == '-1') {
                                _this.zdy3.status = '禁用中';
                                _this.zdy3.btn = '启用';
                            }
                            _this.zdy3.txt = row.config.custom_3.l;
                            _this.zdy3.tit = row.config.custom_3.n;

                            if (row.config.custom_4.s == '1') {
                                _this.zdy4.status = '启用中';
                                _this.zdy4.btn = '禁用';
                            } else if (row.config.custom_4.s == '-1') {
                                _this.zdy4.status = '禁用中';
                                _this.zdy4.btn = '启用';
                            }
                            _this.zdy4.txt = row.config.custom_4.l;
                            _this.zdy4.tit = row.config.custom_4.n;

                            if (row.config.custom_5.s == '1') {
                                _this.zdy5.status = '启用中';
                                _this.zdy5.btn = '禁用';
                            } else if (row.config.custom_5.s == '-1') {
                                _this.zdy5.status = '禁用中';
                                _this.zdy5.btn = '启用';
                            }
                            _this.zdy5.txt = row.config.custom_5.l;
                            _this.zdy5.tit = row.config.custom_5.n;

                            if (row.config.custom_6.s == '1') {
                                _this.zdy6.status = '启用中';
                                _this.zdy6.btn = '禁用';
                            } else if (row.config.custom_6.s == '-1') {
                                _this.zdy6.status = '禁用中';
                                _this.zdy6.btn = '启用';
                            }
                            _this.zdy6.txt = row.config.custom_6.l;
                            _this.zdy6.tit = row.config.custom_6.n;

                            if (row.config.custom_7.s == '1') {
                                _this.zdy7.status = '启用中';
                                _this.zdy7.btn = '禁用';
                            } else if (row.config.custom_7.s == '-1') {
                                _this.zdy7.status = '禁用中';
                                _this.zdy7.btn = '启用';
                            }
                            _this.zdy7.txt = row.config.custom_7.l;
                            _this.zdy7.tit = row.config.custom_7.n;

                            if (row.config.custom_8.s == '1') {
                                _this.zdy8.status = '启用中';
                                _this.zdy8.btn = '禁用';
                            } else if (row.config.custom_8.s == '-1') {
                                _this.zdy8.status = '禁用中';
                                _this.zdy8.btn = '启用';
                            }
                            _this.zdy8.txt = row.config.custom_8.l;
                            _this.zdy8.tit = row.config.custom_8.n;

                            if (row.config.custom_9.s == '1') {
                                _this.zdy9.status = '启用中';
                                _this.zdy9.btn = '禁用';
                            } else if (row.config.custom_9.s == '-1') {
                                _this.zdy9.status = '禁用中';
                                _this.zdy9.btn = '启用';
                            }
                            _this.zdy9.txt = row.config.custom_9.l;
                            _this.zdy9.tit = row.config.custom_9.n;

                            if (row.config.custom_10.s == '1') {
                                _this.zdy10.status = '启用中';
                                _this.zdy10.btn = '禁用';
                            } else if (row.config.custom_10.s == '-1') {
                                _this.zdy10.status = '禁用中';
                                _this.zdy10.btn = '启用';
                            }
                            _this.zdy10.txt = row.config.custom_10.l;
                            _this.zdy10.tit = row.config.custom_10.n;

                            _this.openAppModify(row);
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>'
                    }
                }]
            });
        },
        // app支付方式列表
        getAppList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "shop/getShopAppPayPlatformSetting",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 修改
        openAppModify: function (row) {
            let _this = this;
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['修改', true],
                area: ['600px', '500px'], // 宽高
                content: $(_this.$refs.appAlert)
            }, function () {
                // 自定义不为空
                if ($.trim(_this.zdy1.tit) == '' || $.trim(_this.zdy2.tit) == '' || $.trim(_this.zdy3.tit) == '' || $.trim(_this.zdy4.tit) == '' || $.trim(_this.zdy5.tit) == '' || $.trim(_this.zdy6.tit) == '' || $.trim(_this.zdy7.tit) == '' || $.trim(_this.zdy8.tit) == '' || $.trim(_this.zdy9.tit) == '' || $.trim(_this.zdy10.tit) == '') {
                    layer.msg('自定义支付类型不能为空');
                    return false;
                }
                let cash,
                    swipe,
                    vip,
                    wx,
                    ali,
                    after,
                    present,
                    member,
                    hac,
                    zdy1,
                    zdy2,
                    zdy3,
                    zdy4,
                    zdy5,
                    zdy6,
                    zdy7,
                    zdy8,
                    zdy9,
                    zdy10;
                if (_this.cash.status == '启用中') {
                    cash = '1';
                } else if (_this.cash.status == '禁用中') {
                    cash = '-1';
                }
                if (_this.swipe.status == '启用中') {
                    swipe = '1';
                } else if (_this.swipe.status == '禁用中') {
                    swipe = '-1';
                }
                if (_this.vip.status == '启用中') {
                    vip = '1';
                } else if (_this.vip.status == '禁用中') {
                    vip = '-1';
                }
                if (_this.wx.status == '启用中') {
                    wx = '1';
                } else if (_this.wx.status == '禁用中') {
                    wx = '-1';
                }
                if (_this.ali.status == '启用中') {
                    ali = '1';
                } else if (_this.ali.status == '禁用中') {
                    ali = '-1';
                }
                if (_this.after.status == '启用中') {
                    after = '1';
                } else if (_this.after.status == '禁用中') {
                    after = '-1';
                }
                if (_this.present.status == '启用中') {
                    present = '1';
                } else if (_this.present.status == '禁用中') {
                    present = '-1';
                }
                if (_this.member.status == '启用中') {
                    member = '1';
                } else if (_this.member.status == '禁用中') {
                    member = '-1';
                }
                if (_this.hac.status == '启用中') {
                    hac = '1';
                } else if (_this.hac.status == '禁用中') {
                    hac = '-1';
                }
                if (_this.zdy1.status == '启用中') {
                    zdy1 = '1';
                } else if (_this.zdy1.status == '禁用中') {
                    zdy1 = '-1';
                }
                if (_this.zdy2.status == '启用中') {
                    zdy2 = '1';
                } else if (_this.zdy2.status == '禁用中') {
                    zdy2 = '-1';
                }
                if (_this.zdy3.status == '启用中') {
                    zdy3 = '1';
                } else if (_this.zdy3.status == '禁用中') {
                    zdy3 = '-1';
                }
                if (_this.zdy4.status == '启用中') {
                    zdy4 = '1';
                } else if (_this.zdy4.status == '禁用中') {
                    zdy4 = '-1';
                }
                if (_this.zdy5.status == '启用中') {
                    zdy5 = '1';
                } else if (_this.zdy5.status == '禁用中') {
                    zdy5 = '-1';
                }
                if (_this.zdy6.status == '启用中') {
                    zdy6 = '1';
                } else if (_this.zdy6.status == '禁用中') {
                    zdy6 = '-1';
                }
                if (_this.zdy7.status == '启用中') {
                    zdy7 = '1';
                } else if (_this.zdy7.status == '禁用中') {
                    zdy7 = '-1';
                }
                if (_this.zdy8.status == '启用中') {
                    zdy8 = '1';
                } else if (_this.zdy8.status == '禁用中') {
                    zdy8 = '-1';
                }
                if (_this.zdy9.status == '启用中') {
                    zdy9 = '1';
                } else if (_this.zdy9.status == '禁用中') {
                    zdy9 = '-1';
                }
                if (_this.zdy10.status == '启用中') {
                    zdy10 = '1';
                } else if (_this.zdy10.status == '禁用中') {
                    zdy10 = '-1';
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": row.shop_id,
                            "config": {
                                "wx": {
                                    "s": wx,
                                    "l": _this.wx.txt
                                },
                                "ali": {
                                    "s": ali,
                                    "l": _this.ali.txt
                                },
                                "swipe": {
                                    "s": swipe,
                                    "l": _this.swipe.txt
                                },
                                "cash": {
                                    "s": cash,
                                    "l": _this.cash.txt
                                },
                                "vip": {
                                    "s": vip,
                                    "l": _this.vip.txt
                                },
                                "pay_after": {
                                    "s": after,
                                    "l": _this.after.txt
                                },
                                "pay_present": {
                                    "s": present,
                                    "l": _this.present.txt
                                },
                                "present_account": {
                                    "s": member,
                                    "l": _this.member.txt
                                },
                                "hanging_account": {
                                    "s": hac,
                                    "l": _this.hac.txt
                                },
                                "custom_1": {
                                    "s": zdy1,
                                    "l": _this.zdy1.txt,
                                    "n": _this.zdy1.tit
                                },
                                "custom_2": {
                                    "s": zdy2,
                                    "l": _this.zdy2.txt,
                                    "n": _this.zdy2.tit
                                },
                                "custom_3": {
                                    "s": zdy3,
                                    "l": _this.zdy3.txt,
                                    "n": _this.zdy3.tit
                                },
                                "custom_4": {
                                    "s": zdy4,
                                    "l": _this.zdy4.txt,
                                    "n": _this.zdy4.tit
                                },
                                "custom_5": {
                                    "s": zdy5,
                                    "l": _this.zdy5.txt,
                                    "n": _this.zdy5.tit
                                },
                                "custom_6": {
                                    "s": zdy6,
                                    "l": _this.zdy6.txt,
                                    "n": _this.zdy6.tit
                                },
                                "custom_7": {
                                    "s": zdy7,
                                    "l": _this.zdy7.txt,
                                    "n": _this.zdy7.tit
                                },
                                "custom_8": {
                                    "s": zdy8,
                                    "l": _this.zdy8.txt,
                                    "n": _this.zdy8.tit
                                },
                                "custom_9": {
                                    "s": zdy9,
                                    "l": _this.zdy9.txt,
                                    "n": _this.zdy9.tit
                                },
                                "custom_10": {
                                    "s": zdy10,
                                    "l": _this.zdy10.txt,
                                    "n": _this.zdy10.tit
                                },
                            }
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/setShopAppPayPlatformSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.appList).bootstrapTable('refresh')
                        } else {
                            layer.closeAll();
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 禁用启用
        clkBtn: function (type, name) {
            if (type == 'cash') {
                if (name == '禁用') {
                    this.cash.status = '禁用中';
                    this.cash.btn = '启用';
                } else if (name == '启用') {
                    this.cash.status = '启用中';
                    this.cash.btn = '禁用';
                }
            } else if (type == 'swipe') {
                if (name == '禁用') {
                    this.swipe.status = '禁用中';
                    this.swipe.btn = '启用';
                } else if (name == '启用') {
                    this.swipe.status = '启用中';
                    this.swipe.btn = '禁用';
                }
            } else if (type == 'vip') {
                if (name == '禁用') {
                    this.vip.status = '禁用中';
                    this.vip.btn = '启用';
                } else if (name == '启用') {
                    this.vip.status = '启用中';
                    this.vip.btn = '禁用';
                }
            } else if (type == 'wx') {
                if (name == '禁用') {
                    this.wx.status = '禁用中';
                    this.wx.btn = '启用';
                } else if (name == '启用') {
                    this.wx.status = '启用中';
                    this.wx.btn = '禁用';
                }
            } else if (type == 'ali') {
                if (name == '禁用') {
                    this.ali.status = '禁用中';
                    this.ali.btn = '启用';
                } else if (name == '启用') {
                    this.ali.status = '启用中';
                    this.ali.btn = '禁用';
                }
            } else if (type == 'after') {
                if (name == '禁用') {
                    this.after.status = '禁用中';
                    this.after.btn = '启用';
                } else if (name == '启用') {
                    this.after.status = '启用中';
                    this.after.btn = '禁用';
                }
            } else if (type == 'present') {
                if (name == '禁用') {
                    this.present.status = '禁用中';
                    this.present.btn = '启用';
                } else if (name == '启用') {
                    this.present.status = '启用中';
                    this.present.btn = '禁用';
                }
            } else if (type == 'member') {
                if (name == '禁用') {
                    this.member.status = '禁用中';
                    this.member.btn = '启用';
                } else if (name == '启用') {
                    this.member.status = '启用中';
                    this.member.btn = '禁用';
                }
            } else if (type == 'hac') {
                if (name == '禁用') {
                    this.hac.status = '禁用中';
                    this.hac.btn = '启用';
                } else if (name == '启用') {
                    this.hac.status = '启用中';
                    this.hac.btn = '禁用';
                }
            } else if (type == 'zdy1') {
                if (name == '禁用') {
                    this.zdy1.status = '禁用中';
                    this.zdy1.btn = '启用';
                } else if (name == '启用') {
                    this.zdy1.status = '启用中';
                    this.zdy1.btn = '禁用';
                }
            } else if (type == 'zdy2') {
                if (name == '禁用') {
                    this.zdy2.status = '禁用中';
                    this.zdy2.btn = '启用';
                } else if (name == '启用') {
                    this.zdy2.status = '启用中';
                    this.zdy2.btn = '禁用';
                }
            } else if (type == 'zdy3') {
                if (name == '禁用') {
                    this.zdy3.status = '禁用中';
                    this.zdy3.btn = '启用';
                } else if (name == '启用') {
                    this.zdy3.status = '启用中';
                    this.zdy3.btn = '禁用';
                }
            } else if (type == 'zdy4') {
                if (name == '禁用') {
                    this.zdy4.status = '禁用中';
                    this.zdy4.btn = '启用';
                } else if (name == '启用') {
                    this.zdy4.status = '启用中';
                    this.zdy4.btn = '禁用';
                }
            } else if (type == 'zdy5') {
                if (name == '禁用') {
                    this.zdy5.status = '禁用中';
                    this.zdy5.btn = '启用';
                } else if (name == '启用') {
                    this.zdy5.status = '启用中';
                    this.zdy5.btn = '禁用';
                }
            } else if (type == 'zdy6') {
                if (name == '禁用') {
                    this.zdy6.status = '禁用中';
                    this.zdy6.btn = '启用';
                } else if (name == '启用') {
                    this.zdy6.status = '启用中';
                    this.zdy6.btn = '禁用';
                }
            } else if (type == 'zdy7') {
                if (name == '禁用') {
                    this.zdy7.status = '禁用中';
                    this.zdy7.btn = '启用';
                } else if (name == '启用') {
                    this.zdy7.status = '启用中';
                    this.zdy7.btn = '禁用';
                }
            } else if (type == 'zdy8') {
                if (name == '禁用') {
                    this.zdy8.status = '禁用中';
                    this.zdy8.btn = '启用';
                } else if (name == '启用') {
                    this.zdy8.status = '启用中';
                    this.zdy8.btn = '禁用';
                }
            } else if (type == 'zdy9') {
                if (name == '禁用') {
                    this.zdy9.status = '禁用中';
                    this.zdy9.btn = '启用';
                } else if (name == '启用') {
                    this.zdy9.status = '启用中';
                    this.zdy9.btn = '禁用';
                }
            } else if (type == 'zdy10') {
                if (name == '禁用') {
                    this.zdy10.status = '禁用中';
                    this.zdy10.btn = '启用';
                } else if (name == '启用') {
                    this.zdy10.status = '启用中';
                    this.zdy10.btn = '禁用';
                }
            }
        },


        /*
         * 智慧商家app会员卡号支付是否开启密码
         */
        innitCardTable: function () {
            let _this = this;
            $(_this.$refs.cardList).bootstrapTable('destroy');
            $(_this.$refs.cardList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getCardList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: 'open_vip_pwd_by_mobile',
                    title: '会员手机号支付是否开启短信验证码验证',
                    width: '30%',
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.openCardModify(row.shop_id, 'open_vip_pwd_by_mobile', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.open_vip_pwd_by_mobile == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "open_vip_pwd",
                    title: "会员卡号支付是否开启密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.openCardModify(row.shop_id, 'open_vip_pwd', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.open_vip_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 会员卡号支付是否开启密码列表
        getCardList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "shop/getShopAppVipPwdSetting",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 修改
        openCardModify: function (shop_id, config_type, config) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": config_type,
                        "config": config
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg("修改成功！");
                        $(_this.$refs.cardList).bootstrapTable("refresh");
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * app任务自动接收
         */
        // 初始化app任务自动接收列表
        innitSfrTable: function () {
            let _this = this;
            $(_this.$refs.sfrList).bootstrapTable('destroy');
            $(_this.$refs.sfrList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSfrList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "auto_receive_show",
                    title: "自动接收任务",
                    width: "30%"
                }, {
                    title: "操作",
                    width: "30%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.sfr_shop_id = row.shop_id;
                            _this.sfr_shop_name = row.shop_name;
                            _this.sfr_auto_receive = row.auto_receive;
                            $('.sfr-sel-list li').removeClass('sfr-sel-li');
                            $.each(_this.sfr_auto_receive, function (k, v) {
                                $('.sfr-sel-list li').eq(v - 1).addClass('sfr-sel-li');
                            });
                            $('.sfr-list').hide();
                            $('.sfr-modify').show();
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>'
                    }
                }]
            });
        },
        // app任务自动接收列表
        getSfrList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "shop/getAutoReceiveSetting",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 选择任务
        sfrSel: function (num) {
            let index = this.sfr_auto_receive.indexOf(num);
            if (index == '-1') {
                this.sfr_auto_receive.push(num);
                $('.sfr-sel-list li').eq(num - 1).addClass('sfr-sel-li');
            } else {
                this.sfr_auto_receive.splice(index, 1);
                $('.sfr-sel-list li').eq(num - 1).removeClass('sfr-sel-li');
            }
        },
        // 返回
        backSfrList: function () {
            $('.sfr-list').show();
            $('.sfr-modify').hide();
        },
        // 修改
        sfrSub: function () {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.sfr_shop_id,
                        "auto_receive": _this.sfr_auto_receive
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/setAutoReceiveSetting",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.sfrList).bootstrapTable('refresh');
                        $('.sfr-list').show();
                        $('.sfr-modify').hide();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 扫微信取酒二维码设置
         */
        // 初始化扫微信取酒二维码设置
        innitSqeTable: function () {
            let _this = this;
            $(_this.$refs.sqeList).bootstrapTable('destroy');
            $(_this.$refs.sqeList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geSqeList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "deposit_check_mobile",
                    title: "扫微信取酒二维码是否开启手机验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.sqeSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.deposit_check_mobile == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 扫微信取酒二维码设置列表
        geSqeList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 扫微信取酒二维码设置
        sqeSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "deposit_check_mobile": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.sqeList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 微信端播控设置
         */
        // 初始化微信端播控设置
        innitWxbkTable: function () {
            let _this = this;
            $(_this.$refs.wxbkList).bootstrapTable('destroy');
            $(_this.$refs.wxbkList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geWxbkList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "broadcast_control",
                    title: "播控浮窗是否开启",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wxbkSub(row.shop_id, 'broadcast_control', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.broadcast_control == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "dg_topping",
                    title: "点歌置顶操作是否开启",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wxbkSub(row.shop_id, 'dg_topping', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.dg_topping == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "dg_first",
                    title: "点歌抢歌操作是否开启",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wxbkSub(row.shop_id, 'dg_first', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.dg_first == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 微信端播控设置列表
        geWxbkList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "wx_broadcast_control"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 微信端播控设置
        wxbkSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.wxbkList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 挂账人担保人是否需要密码验证
         */
        // 初始化挂账人担保人是否需要密码验证
        innitGdmTable: function () {
            let _this = this;
            $(_this.$refs.gdmList).bootstrapTable('destroy');
            $(_this.$refs.gdmList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geGdmList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "hanging_require_pwd",
                    title: "挂账人是否需要密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.gdmSub(row.id, check_stock, 1);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.hanging_require_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "hanging_require_bondsman_pwd",
                    title: "担保人是否需要密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.gdmSub(row.id, check_stock, 2);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.hanging_require_bondsman_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 挂账人担保人是否需要密码验证列表
        geGdmList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 挂账人担保人是否需要密码验证设置
        gdmSub: function (id, check_stock, type) {
            let _this = this;
            let datas = {};
            if (type == '1') {
                datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "hanging_require_pwd": check_stock
                        }
                    },
                    "comment": ""
                };
            } else if (type == '2') {
                datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "hanging_require_bondsman_pwd": check_stock
                        }
                    },
                    "comment": ""
                };
            }
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.gdmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * app历史任务权限是否细分到账号
         */
        // 初始化app历史任务权限是否细分到账号
        innitLqxTable: function () {
            let _this = this;
            $(_this.$refs.lqxList).bootstrapTable('destroy');
            $(_this.$refs.lqxList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geLqxList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "task_history",
                    title: "app历史任务权限是否细分到账号",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.lqxSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.task_history == "-1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='-1' selected>是</option><option value='1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='-1'>是</option><option value='1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // app历史任务权限是否细分到账号列表
        geLqxList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getTaskHistoryList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // app历史任务权限是否细分到账号设置
        lqxSub: function (shop_id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/setTaskHistory",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.lqxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 结账是否进行员工验证
         */
        // 初始化结账是否进行员工验证
        innitJyyTable: function () {
            let _this = this;
            $(_this.$refs.jyyList).bootstrapTable('destroy');
            $(_this.$refs.jyyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geJyyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "pay_admin_required",
                    title: "结账是否进行员工验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.jyySub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.pay_admin_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 结账是否进行员工验证列表
        geJyyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 结账是否进行员工验证设置
        jyySub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "pay_admin_required": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.jyyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 包厢营业额预警设置
         */
        // 获取门店下包厢类型
        getByyBoxType: function (shop_id, num) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getRoomType",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let arr = [{ id: ' ', text: '全部' }];
                        $.each(data.response.result.data, function (k, v) {
                            arr.push({ id: v.id, text: v.name });
                        });
                        if (num == '1') {
                            $(_this.$refs.byy_box_type).html('');
                            $(_this.$refs.byy_box_type).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.byy_box_type).prop('disabled', false);
                        } else if (num == '2') {
                            arr.shift();
                            $(_this.$refs.byy_edit_box_type).html('');
                            $(_this.$refs.byy_edit_box_type).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                            $(_this.$refs.byy_edit_box_type).prop('disabled', false);
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.data.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 初始化包厢营业额预警设置
        innitByyTable: function () {
            let _this = this;
            $(_this.$refs.byyList).bootstrapTable("destroy");
            $(_this.$refs.byyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getByyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "行号",
                    width: "5%",
                    valign: "middle",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "10%"
                }, {
                    field: "room_type_nmae",
                    title: "包厢类型",
                    width: "13%"
                }, {
                    field: "open_room_limit_time_str",
                    title: "开房时长",
                    width: "10%"
                }, {
                    field: "income",
                    title: "营业额",
                    width: "10%"
                }, {
                    field: "start_time_str",
                    title: "有效时间段",
                    width: "9%",
                    formatter: function (value, row, index) {
                        return row.start_time_str + ' - ' + row.end_time_str;
                    }
                }, {
                    field: "status",
                    title: "启用/禁用",
                    width: "9%",
                    formatter: function (value, row, index) {
                        if (row.status == '1') {
                            return '启用';
                        } else if (row.status == '-1') {
                            return '禁用';
                        }
                    }
                }, {
                    title: "操作",
                    width: "13%",
                    events: {
                        'click .edit': function (e, value, row) {
                            _this.getByyDet(row.id);
                            _this.byy_modify = '2';
                            _this.byy_edit_tit = '修改包厢营业额预警设置';
                            _this.byy_edit_id = row.id;
                        },
                        'click .del': function (e, value, row) {
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消']
                            }, function () {
                                _this.delByy(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">修改</span><span class="text-blue del">删除</span>';
                    }
                }],
            });
        },
        // 表格数据
        getByyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "shop_id": $(_this.$refs.byy_shop).val(),
                        "room_type": $.trim($(_this.$refs.byy_box_type).val()),
                        "status": $.trim($(_this.$refs.byy_status).val())
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "IncomeWarning/getList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 查询
        clkByyQuery: function () {
            this.innitByyTable();
        },
        // 点击新增
        addByy: function () {
            let _this = this;
            _this.byy_modify = '1';
            _this.byy_edit_tit = '新增包厢营业额预警设置';
            $(_this.$refs.byy_edit_shop).prop('disabled', false);
            $(_this.$refs.byy_edit_shop).val('').trigger('change');
            $(_this.$refs.byy_edit_box_type).prop('disabled', true);
            _this.getByyBoxType($(_this.$refs.byy_edit_shop).val(), '2');
            // $(_this.$refs.byy_edit_box_type).val('').trigger('change');
            _this.byy_edit_time = '';
            _this.byy_edit_amount = '';
            _this.byy_start_time = '';
            _this.byy_end_time = '';
            _this.byy_edit_time = '';
            $(_this.$refs.byy_edit_type).val('').trigger('change');
            $(_this.$refs.byy_edit_status).val('').trigger('change');
            _this.showByyList = false;
            _this.showByyEdit = true;
        },
        // 点击选择时间
        byyTimePop: function () {
            let _this = this;
            $(_this.$refs.starthour).val(_this.byy_start_time.split(':')[0]).trigger('change');
            $(_this.$refs.startseconds).val(_this.byy_start_time.split(':')[1]).trigger('change');
            $(_this.$refs.stophour).val(_this.byy_end_time.split(':')[0]).trigger('change');
            $(_this.$refs.stopseconds).val(_this.byy_end_time.split(':')[1]).trigger('change');
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: '使用时间选择',
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.byy_time_wrap)
            }, function () {
                _this.getByySelTime();
                layer.closeAll();
            });
        },
        // 获取选择的时间
        getByySelTime() {
            let _this = this;
            let starthour = $(_this.$refs.starthour).select2("val");
            let startseconds = $(_this.$refs.startseconds).select2("val");
            let stophour = $(_this.$refs.stophour).select2("val");
            let stopseconds = $(_this.$refs.stopseconds).select2("val");
            _this.byy_start_time = starthour + ":" + startseconds;
            _this.byy_end_time = stophour + ":" + stopseconds;
        },
        // 获取时间
        byySelectTime: function () {
            let _this = this;
            let seconds = [];
            for (let i = 0; i < 60; i++) {
                let item = {};
                item.id = (i < 10) ? '0' + i : i;
                item.text = (i < 10) ? '0' + i : i;
                seconds[i] = item;
            };
            let hour = [];
            for (let i = 0; i < 24; i++) {
                let item = {};
                item.id = (i < 10) ? '0' + i : i;
                item.text = (i < 10) ? '0' + i : i;
                hour[i] = item;
            }
            $(_this.$refs.starthour).select2({
                data: hour,
                language: "zh-CN"
            });
            $(_this.$refs.startseconds).select2({
                data: seconds,
                language: "zh-CN"
            });
            $(_this.$refs.stophour).select2({
                data: hour,
                language: "zh-CN"
            });
            $(_this.$refs.stopseconds).select2({
                data: seconds,
                language: "zh-CN"
            })
        },
        // 详情
        getByyDet: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "IncomeWarning/showData",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        $(_this.$refs.byy_edit_shop).val(data.response.result.shop_id).trigger('change');
                        $(_this.$refs.byy_edit_shop).prop('disabled', true);
                        $(_this.$refs.byy_edit_box_type).prop('disabled', true);
                        _this.getByyBoxType(data.response.result.shop_id, '2');
                        $(_this.$refs.byy_edit_box_type).val(data.response.result.room_type).trigger('change');
                        _this.byy_edit_time = data.response.result.open_room_limit_time;
                        _this.byy_edit_amount = data.response.result.income;
                        _this.byy_start_time = data.response.result.start_time;
                        _this.byy_end_time = data.response.result.end_time;
                        $(_this.$refs.byy_edit_type).val(data.response.result.waring_type).trigger('change');
                        $(_this.$refs.byy_edit_status).val(data.response.result.status).trigger('change');
                        _this.showByyList = false;
                        _this.showByyEdit = true;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 新增、修改
        byySub: function () {
            let _this = this;
            let datas,
                url = '';
            if (_this.byy_modify == '1') {
                // 新增
                datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.byy_edit_shop).val(),
                            "room_type": $(_this.$refs.byy_edit_box_type).val(),
                            "open_room_limit_time": _this.byy_edit_time,
                            "income": _this.byy_edit_amount,
                            "start_time": _this.byy_start_time,
                            "end_time": _this.byy_end_time,
                            "waring_type": $(_this.$refs.byy_edit_type).val(),
                            "status": $(_this.$refs.byy_edit_status).val()
                        }
                    },
                    "comment": ""
                };
                url = Vue.ctUrl + "IncomeWarning/addData";
            } else if (_this.byy_modify == '2') {
                // 修改
                datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": _this.byy_edit_id,
                            "shop_id": $(_this.$refs.byy_edit_shop).val(),
                            "room_type": $(_this.$refs.byy_edit_box_type).val(),
                            "open_room_limit_time": _this.byy_edit_time,
                            "income": _this.byy_edit_amount,
                            "start_time": _this.byy_start_time,
                            "end_time": _this.byy_end_time,
                            "waring_type": $(_this.$refs.byy_edit_type).val(),
                            "status": $(_this.$refs.byy_edit_status).val()
                        }
                    },
                    "comment": ""
                };
                url = Vue.ctUrl + "IncomeWarning/editData";
            }
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: url,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('操作成功');
                        $(_this.$refs.byyList).bootstrapTable("refresh");
                        _this.showByyList = true;
                        _this.showByyEdit = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 返回列表
        backListByy() {
            this.showByyList = true;
            this.showByyEdit = false;
        },
        // 删除
        delByy: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "IncomeWarning/delData",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg('删除成功');
                        $(_this.$refs.byyList).bootstrapTable("refresh");
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 经理打折是否剔除不打折商品
         */
        // 初始化经理打折是否剔除不打折商品
        innitJdsTable: function () {
            let _this = this;
            $(_this.$refs.jdsList).bootstrapTable('destroy');
            $(_this.$refs.jdsList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getJdsList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "discount_include_all",
                    title: "经理打折是否剔除不打折商品",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.jdsSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.discount_include_all == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 经理打折是否剔除不打折商品列表
        getJdsList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 经理打折是否剔除不打折商品设置
        jdsSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "discount_include_all": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.jdsList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 会员刷卡是否允许手动输入卡号
         */
        innitHskTable: function () {
            let _this = this;
            $(_this.$refs.hskList).bootstrapTable('destroy');
            $(_this.$refs.hskList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.geHskList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "vip_card_input",
                    title: "会员刷卡是否允许手动输入卡号",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.hskSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        geHskList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 账单是否自动打印设置
        hskSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "vip_card_input": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.hskList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 计时开房是否支持跨时段
         */
        innitJkkTable: function () {
            let _this = this;
            $(_this.$refs.jkkList).bootstrapTable('destroy');
            $(_this.$refs.jkkList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getJkkList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "choose_timing",
                    title: "计时开房是否支持跨时段",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.jkkSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getJkkList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        jkkSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "choose_timing": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.jkkList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 取消开房时限设置
         */
        innitQksTable: function () {
            let _this = this;
            $(_this.$refs.qksList).bootstrapTable('destroy');
            $(_this.$refs.qksList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getQksList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "cancel_open_room_limit_time_str",
                    title: "开房时长",
                    width: "30%"
                }, {
                    field: "op",
                    title: "操作",
                    width: "30%",
                    events: {
                        'click .edit': function (e, value, row) {
                            $(_this.$refs.qks_shop).val(row.shop_id).trigger('change');
                            if (row.cancel_open_room_limit_time == '-1') {
                                _this.qks_minute = ''
                                _this.qks_limit = true
                            } else {
                                _this.qks_minute = row.cancel_open_room_limit_time
                                _this.qks_limit = false
                            }
                            _this.editQks(row.shop_id);
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">修改</span>'
                    }
                }]
            });
        },
        // 列表
        getQksList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'cancel_open_room_limit_time'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        editQks: function (shop_id) {
            let _this = this;
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'],
                title: ['修改设置', true],
                area: ['660px', ''],
                content: $(_this.$refs.qks_edit),
                offset: '100px'
            }, function () {
                if (!_this.qks_limit && _this.qks_minute < 0) {
                    layer.msg('开房时长不能为负数')
                    return false
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": shop_id,
                            "config_type": 'cancel_open_room_limit_time',
                            "config": _this.qks_limit ? '-1' : _this.qks_minute
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('设置成功');
                            $(_this.$refs.qksList).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },


        /*
         * 团购套餐兑券是否授权销券
         */
        innitTsxTable: function () {
            let _this = this;
            $(_this.$refs.tsxList).bootstrapTable('destroy');
            $(_this.$refs.tsxList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getTsxList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "group_consume",
                    title: "团购套餐兑券是否授权销券",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.tsxSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "",
                    title: "平台授权",
                    width: "30%",
                    events: {
                        'click .author': function (e, value, row) {
                            let shop_id = row.shop_id
                            _this.getMeituanAuth(shop_id)
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue author">美团授权</span>'
                    }
                }]
            });
        },
        // 列表
        getTsxList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        tsxSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "group_consume": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.tsxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 获取美团授权
        getMeituanAuth: function (shop_id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                        "scope": "tuangou"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getMeituanAuthUrl",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        console.log(data.response.result)
                        // 浏览器打开新页面
                        window.open(data.response.result.auth_url, '_blank');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 全场霸屏设置
         */
        innitQbsTable: function () {
            let _this = this;
            $(_this.$refs.qbsList).bootstrapTable('destroy');
            $(_this.$refs.qbsList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getQbsList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "jh_fun_setting",
                    title: "全场霸屏是否开启",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = [];
                            if ($(this).children('option:selected').val() == '1') {
                                check_stock.push('niubility');
                            }
                            _this.qbsSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value.niubility == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        getQbsList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "jh_fun_setting"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        qbsSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config": check_stock,
                        "config_type": "jh_fun_setting"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.qbsList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 会员到店预警设置
         */
        innitHdyTable: function () {
            let _this = this;
            $(_this.$refs.hdyList).bootstrapTable('destroy')
            $(_this.$refs.hdyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.gethdyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "16%"
                }, {
                    field: "type_name",
                    title: "会员到店预警方式",
                    width: "16%"
                }, {
                    field: "min",
                    title: "具体预警阈值",
                    width: "16%",
                    formatter: function (value, row, index) {
                        if (row.type == '1') {
                            if (value == '-1.00') {
                                return '小于等于' + row.max + '元';
                            } else if (row.max == '-1.00') {
                                return '大于等于' + value + '元';
                            } else {
                                return '大于等于' + value + '元,' + '小于等于' + row.max + '元';
                            }
                        } else if (row.type == '2') {
                            if (value == '-1') {
                                return '小于等于' + row.max + '级';
                            } else if (row.max == '-1') {
                                return '大于等于' + value + '级';
                            } else {
                                return '大于等于' + value + '级,' + '小于等于' + row.max + '级';
                            }
                        }
                    }
                }, {
                    field: "status_name",
                    title: "启用/禁用",
                    width: "16%"
                }, {
                    field: "op",
                    title: "操作",
                    width: "16%",
                    events: {
                        'click .edit': function (e, value, row, index) {
                            _this.hdy_modify = '2';
                            $(_this.$refs.hdy_edit_shop).prop('disabled', true);
                            $(_this.$refs.hdy_edit_shop).val(row.shop_id).trigger('change');
                            $(_this.$refs.hdy_edit_type).val(row.type).trigger('change');
                            _this.hdy_edit_radio = row.type;
                            if (row.type == '1') {
                                _this.hdy_mn_min = row.min == '-1.00' ? '' : row.min;
                                _this.hdy_mn_max = row.max == '-1.00' ? '' : row.max;
                                _this.hdy_lv_min = '';
                                _this.hdy_lv_max = '';
                            } else if (row.type == '2') {
                                _this.hdy_mn_min = '';
                                _this.hdy_mn_max = '';
                                _this.hdy_lv_min = row.min == '-1' ? '' : row.min;
                                _this.hdy_lv_max = row.max == '-1' ? '' : row.max;
                            }
                            $(_this.$refs.hdy_edit_status).val(row.status).trigger('change');
                            _this.editHyd('修改', row.id);
                        },
                        'click .del': function (e, value, row, index) {
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消']
                            }, function () {
                                _this.delHyd(row.id);
                            });
                        },
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-blue del">删除</span>'
                    }
                }]
            });
        },
        gethdyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "shop_id": $(_this.$refs.hdy_shop).val(),
                        "type": $(_this.$refs.hdy_type).val(),
                        "status": $(_this.$refs.hdy_status).val()
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/getVipWarningList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 查询
        clkHdyQuery: function () {
            this.innitHdyTable();
        },
        // 点击新增
        addHdy: function () {
            let _this = this;

            _this.hdy_modify = '1';
            $(_this.$refs.hdy_edit_shop).prop('disabled', false);
            $(_this.$refs.hdy_edit_shop).val('').trigger('change');
            $(_this.$refs.hdy_edit_type).val('').trigger('change');
            _this.hdy_edit_radio = '1';
            _this.hdy_mn_min = '';
            _this.hdy_mn_max = '';
            _this.hdy_lv_min = '';
            _this.hdy_lv_max = '';
            $(_this.$refs.hdy_edit_status).val('').trigger('change');
            _this.editHyd('新增', '');
        },
        // 新增、修改
        editHyd: function (name, id) {
            let _this = this;
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: [name, true],
                area: ['660px', ''], // 宽高
                content: $(_this.$refs.hdy_edit)
            }, function () {
                let url = Vue.ctUrl + "Vip/addVipWarning";
                let min = '',
                    max = '',
                    type = $(_this.$refs.hdy_edit_type).val();
                if (type == '1') {
                    min = $.trim(_this.hdy_mn_min);
                    max = $.trim(_this.hdy_mn_max);
                } else if (type == '2') {
                    min = $.trim(_this.hdy_lv_min);
                    max = $.trim(_this.hdy_lv_max);
                }
                if (min == '') {
                    min = '-1'
                }
                if (max == '') {
                    max = '-1'
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.hdy_edit_shop).val(),
                            "type": type,
                            "min": min,
                            "max": max,
                            "status": $(_this.$refs.hdy_edit_status).val()
                        }
                    },
                    "comment": ""
                };
                if (_this.hdy_modify == '2') {
                    datas.request.param.id = id;
                    url = Vue.ctUrl + "Vip/updateVipWarning";
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            $(_this.$refs.hdyList).bootstrapTable("refresh");
                            layer.msg('操作成功');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 删除
        delHyd(id) {
            let _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/delVipWarning",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.hdyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 智慧麦克风低电量消息提醒
         */
        innitMdxTable: function () {
            let _this = this;
            $(_this.$refs.mdxList).bootstrapTable('destroy');
            $(_this.$refs.mdxList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getMdxList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "mic_dont_tips",
                    title: "消息提醒时段",
                    width: "30%",
                    events: {
                        'click .mdx-edit': function (e, value, row) {
                            _this.mdxSub(row);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = '<span class="mdx-edit">不提示<i class="fa fa-angle-down fa-lg"></i></span>';
                        } else {
                            strHtml = '<span class="mdx-edit">' + row.mic_tips_start_time + ' - ' + row.mic_tips_end_time + '<i class="fa fa-angle-down fa-lg"></i></span>';
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getMdxList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 使用时间
        initMdxTime: function () {
            let _this = this;

            let seconds = [];
            for (let i = 0; i < 60; i++) {
                let item = {};
                item.id = (i < 10) ? '0' + i : i;
                item.text = (i < 10) ? '0' + i : i;
                seconds[i] = item;
            };
            let hour = [];
            for (let i = 0; i < 24; i++) {
                let item = {};
                item.id = (i < 10) ? '0' + i : i;
                item.text = (i < 10) ? '0' + i : i;
                hour[i] = item;
            }
            $(_this.$refs.mdx_starthour).select2({
                data: hour,
                language: "zh-CN",
                width: 'auto'
            });
            $(_this.$refs.mdx_stophour).select2({
                data: hour,
                language: "zh-CN",
                width: 'auto'
            });
            $(_this.$refs.mdx_startseconds).select2({
                data: seconds,
                language: "zh-CN",
                width: 'auto'
            });
            $(_this.$refs.mdx_stopseconds).select2({
                data: seconds,
                language: "zh-CN",
                width: 'auto'
            })
        },
        mdxSub: function (row) {
            let _this = this;

            if (row.mic_dont_tips == '1') {
                _this.mdx_usetime_allday = '1';
                $(_this.$refs.mdx_starthour).val('00').trigger('change');
                $(_this.$refs.mdx_startseconds).val('00').trigger('change');
                $(_this.$refs.mdx_stophour).val('00').trigger('change');
                $(_this.$refs.mdx_stopseconds).val('00').trigger('change');
            } else if (row.mic_dont_tips == '-1') {
                _this.mdx_usetime_allday = '';
                $(_this.$refs.mdx_starthour).val(row.mic_tips_start_time.split(':')[0]).trigger('change');
                $(_this.$refs.mdx_startseconds).val(row.mic_tips_start_time.split(':')[1]).trigger('change');
                $(_this.$refs.mdx_stophour).val(row.mic_tips_end_time.split(':')[0]).trigger('change');
                $(_this.$refs.mdx_stopseconds).val(row.mic_tips_end_time.split(':')[1]).trigger('change');
            }
            layer.confirm('', {
                type: 1,
                skin: 'public-alert-skin',
                btn: ['确定', '取消'], // 按钮
                title: '消息提醒',
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.mdx_usetime_alert)
            }, function () {
                let mic_tips_start_time = '',
                    mic_tips_end_time = '',
                    mic_dont_tips = '1';
                if (_this.mdx_usetime_allday == '') {
                    let starthour = $(_this.$refs.mdx_starthour).select2("val");
                    let startseconds = $(_this.$refs.mdx_startseconds).select2("val");
                    let stophour = $(_this.$refs.mdx_stophour).select2("val");
                    let stopseconds = $(_this.$refs.mdx_stopseconds).select2("val");

                    mic_tips_start_time = starthour + ":" + startseconds;
                    mic_tips_end_time = stophour + ":" + stopseconds;
                    mic_dont_tips = '-1';
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id,
                            "mic_tips_start_time": mic_tips_start_time,
                            "mic_tips_end_time": mic_tips_end_time,
                            "mic_dont_tips": mic_dont_tips
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setShopConfig",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.mdxList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },


        /*
         * 会员折扣是否仅会员支付时生效
         */
        innitVpsTable: function () {
            let _this = this;
            $(_this.$refs.vpsList).bootstrapTable('destroy');
            $(_this.$refs.vpsList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getVpsList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "vip_price_limit",
                    title: "会员折扣是否仅会员支付时生效",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.vpsSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getVpsList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        vpsSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "vip_price_limit": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.vpsList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 暂停营业时间设置
         */
        innitZysTable: function () {
            let _this = this;
            $(_this.$refs.zysList).bootstrapTable('destroy')
            $(_this.$refs.zysList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getZysList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "适用门店",
                    width: "30%"
                }, {
                    field: "pause_time",
                    title: "暂停营业开始时间",
                    width: "30%"
                }, {
                    field: "op",
                    title: "操作",
                    width: "30%",
                    events: {
                        'click .edit': function (e, value, row) {
                            if (row.pause_time == '无') {
                                _this.zys_usetime_allday = '1';
                                $(_this.$refs.zys_hour).val('').trigger('change');
                                $(_this.$refs.zys_seconds).val('').trigger('change');
                            } else {
                                _this.zys_usetime_allday = '';
                                $(_this.$refs.zys_hour).val(row.pause_time.split(':')[0]).trigger('change');
                                $(_this.$refs.zys_seconds).val(row.pause_time.split(':')[1]).trigger('change');
                            }
                            _this.zysEdit(row.shop_id);
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">修改</span>';
                    }
                }]
            });
        },
        getZysList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('shop/getShopPauseSet', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            })
                .then(function (res) {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(function (error) {
                    layer.msg("出错啦");
                });
        },
        // 修改
        initZysTime: function () {
            const _this = this;

            let hour = [];
            for (let i = 0; i < 7; i++) {
                let item = {};
                item.id = '0' + i;
                item.text = '0' + i;
                hour[i] = item;
            }
            for (let i = 12; i < 24; i++) {
                let item = {};
                item.id = `${i}`;
                item.text = `${i}`;
                hour.push(item);
            }
            let seconds = [];
            for (let i = 0; i < 60; i++) {
                let item = {};
                item.id = (i < 10) ? '0' + i : i;
                item.text = (i < 10) ? '0' + i : i;
                seconds[i] = item;
            };
            $(_this.$refs.zys_hour).select2({
                data: hour,
                language: "zh-CN",
                width: 'auto'
            });
            $(_this.$refs.zys_seconds).select2({
                data: seconds,
                language: "zh-CN",
                width: 'auto'
            });
        },
        zysEdit: function (shop_id) {
            const _this = this;

            layer.confirm('', {
                type: 1,
                skin: 'public-alert-skin',
                btn: ['确定', '取消'], // 按钮
                title: '暂停营业开始时间',
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.zys_usetime_alert)
            }, function () {
                let pause_time = '-1';
                if (_this.zys_usetime_allday == '') {
                    pause_time = `${$(_this.$refs.zys_hour).val()}:${$(_this.$refs.zys_seconds).val()}`;
                }
                Vue.axios.post('shop/editShopPauseSet', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "pause_time": pause_time
                        }
                    },
                    "comment": ""
                })
                    .then(function (res) {
                        if (res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('修改成功');
                            $(_this.$refs.zysList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(function (error) {
                        layer.msg("出错啦");
                    });
            });
        },


        /*
         * 酒水服务费是否参与账单经理打折
         */
        innitFjdTable: function () {
            let _this = this;
            $(_this.$refs.fjdList).bootstrapTable('destroy');
            $(_this.$refs.fjdList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getFjdList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "server_manage_discount",
                    title: "酒水服务费是否参与账单经理打折",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.fjdSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getFjdList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        fjdSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "server_manage_discount": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        $(_this.$refs.fjdList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 每次开房可使用券总量
         */
        innitMkqTable: function () {
            let _this = this;
            $(_this.$refs.mkqList).bootstrapTable('destroy')
            $(_this.$refs.mkqList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getMkqList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "reward_limit_use_num",
                    title: "每次开房可使用券总量",
                    width: "30%",
                    events: {
                        'click .edit': function (e, value, row) {
                            if (value == '-1') {
                                _this.mkq_usetime_allday = '1';
                                _this.mkq_num = '';
                            } else {
                                _this.mkq_usetime_allday = '';
                                _this.mkq_num = value;
                            }
                            _this.mkqEdit(row.shop_id);
                        }
                    },
                    formatter: function (value, row, index) {
                        if (value == '-1') {
                            return '<span class="text-blue edit">不限制</span>';
                        } else {
                            return '<span class="text-blue edit">' + value + '</span>';
                        }
                    }
                }]
            });
        },
        getMkqList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'reward_limit_use_num'
                    }
                },
                "comment": ""
            })
                .then(function (res) {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(function (error) {
                    layer.msg("出错啦");
                });
        },
        // 修改
        mkqEdit: function (id) {
            const _this = this;

            layer.confirm('', {
                type: 1,
                skin: 'public-alert-skin',
                btn: ['确定', '取消'], // 按钮
                title: '每次开房可使用券总量',
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.mkq_usetime_alert)
            }, function () {
                let config = '-1';
                if (_this.mkq_usetime_allday == '') {
                    config = _this.mkq_num;
                }
                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": 'reward_limit_use_num',
                            "config": config
                        }
                    },
                    "comment": ""
                })
                    .then(function (res) {
                        if (res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('修改成功');
                            $(_this.$refs.mkqList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(function (error) {
                        layer.msg("出错啦");
                    });
            });
        },


        /*
         * 支付时优惠券是否打折
         */
        innitZydTable: function () {
            let _this = this;
            $(_this.$refs.zydList).bootstrapTable('destroy');
            $(_this.$refs.zydList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getZydList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "reward_discount",
                    title: "支付时优惠券是否打折",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.zydSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getZydList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        zydSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "reward_discount": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setShopConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.zydList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 自助大厅支付形式设置
         */
        innitDzsTable: function () {
            let _this = this;
            $(_this.$refs.dzsList).bootstrapTable('destroy');
            $(_this.$refs.dzsList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getDzsList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "hall_pay_type",
                    title: "自助大厅支付形式设置",
                    width: "30%",
                    events: {
                        'change .select-sel-big': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.dzsSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel-big select2 ct-select'><option value='1' selected>扫描消费付款码（扫描枪扫消费者手机上付款码）</option><option value='2'>消费者扫付款码（消费者扫页面上付款码）</option></select>";
                        } else {
                            strHtml = "<select class='select-sel-big select2 ct-select'><option value='1'>扫描消费付款码（扫描枪扫消费者手机上付款码）</option><option value='2' selected>消费者扫付款码（消费者扫页面上付款码）</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getDzsList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Setting/getShopConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        dzsSub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Setting/setShopConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "hall_pay_type": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.dzsList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 微信在线预定类型
         */
        innitWzyTable: function () {
            let _this = this;
            $(_this.$refs.wzyList).bootstrapTable('destroy');
            $(_this.$refs.wzyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getWzyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "wx_book_type",
                    title: "微信在线预定",
                    width: "30%",
                    events: {
                        'change .select-sel-big': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wzySub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel-big select2 ct-select'><option value='1' selected>预定到包厢类型</option><option value='2'>预定到具体包厢号</option></select>";
                        } else {
                            strHtml = "<select class='select-sel-big select2 ct-select'><option value='1'>预定到包厢类型</option><option value='2' selected>预定到具体包厢号</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getWzyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'wx_book_type'
                    }
                },
                "comment": ""
            })
                .then(function (res) {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(function (error) {
                    layer.msg("出错啦");
                });
        },
        // 设置
        wzySub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config": check_stock,
                        "config_type": "wx_book_type"
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        $(_this.$refs.wzyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 手机短信类型模板设置
         */
        innitDlmTable: function () {
            let _this = this;
            $(_this.$refs.dlmList).bootstrapTable('destroy');
            $(_this.$refs.dlmList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getDlmList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "sms_tmp_type",
                    title: "手机短信类型模板设置",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.dlmSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>量贩式</option><option value='2'>商务式</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>量贩式</option><option value='2' selected>商务式</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getDlmList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Setting/getShopConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        dlmSub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Setting/setShopConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "sms_tmp_type": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.dlmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 经理实收是否需要密码验证
         */
        innitJsyTable: function () {
            let _this = this;
            $(_this.$refs.jsyList).bootstrapTable('destroy');
            $(_this.$refs.jsyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getJsyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "manager_amount_pwd",
                    title: "经理实收是否需要密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.jsySub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getJsyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Setting/getShopConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        jsySub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Setting/setShopConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "manager_amount_pwd": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.jsyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 账单低消部分是否参与经理打折
         */
        innitDjdTable: function () {
            let _this = this;
            $(_this.$refs.djdList).bootstrapTable('destroy');
            $(_this.$refs.djdList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getDjdList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "minimum_manager_discount",
                    title: "账单低消部分是否参与经理打折",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.djdSub(row.id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getDjdList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Setting/getShopConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        djdSub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Setting/setShopConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "minimum_manager_discount": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.djdList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 商品赠送是否需要密码验证
         */
        innitSzyTable: function () {
            let _this = this;
            $(_this.$refs.szyList).bootstrapTable('destroy');
            $(_this.$refs.szyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSzyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "present_check_pwd",
                    title: "商品赠送是否需要密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.szySub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getSzyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'present_check_pwd'
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        szySub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": 'present_check_pwd',
                        "config": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.szyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 经理打折是否需要密码验证
         */
        innitJdyTable: function () {
            let _this = this;
            $(_this.$refs.jdyList).bootstrapTable('destroy');
            $(_this.$refs.jdyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getJdyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "manager_discount_check_pwd",
                    title: "经理打折是否需要密码验证",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.jdySub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getJdyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'manager_discount_check_pwd'
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        jdySub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": 'manager_discount_check_pwd',
                        "config": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.jdyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * 微信扫码是否默认办理会员卡
         */
        innitSmbhTable: function () {
            let _this = this;
            $(_this.$refs.smbhList).bootstrapTable('destroy');
            $(_this.$refs.smbhList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSmbhList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "force_register_vip",
                    title: "微信扫码是否默认办理会员卡",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.smbhSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (value == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "force_register_vip_room_name",
                    title: "适用包厢",
                    width: "25%",
                    formatter: function (value, row, index) {
                        var room = value.split(",")
                        if (room.length > 4) {
                            var str = room.slice(0, 4).join(",") + ',...'
                            return str
                        } else {
                            return value
                        }
                    }
                }, {
                    field: "",
                    title: "操作",
                    width: "25%",
                    events: {
                        'click .text-blue': function (e, value, row) {
                            console.log("click:", row)
                            _this.getAllRoom(row)
                            _this.smbh_shop_id = row.shop_id
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "<span class='text-blue'>修改适用包厢</span>";
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getSmbhList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'force_register_vip'
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 设置
        smbhSub: function (id, check_stock) {
            const _this = this;

            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": 'force_register_vip',
                        "config": check_stock
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.smbhList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 获取所有包厢
        getAllRoom: function (row) {
            let _this = this
            Vue.axios.post('Shop/getAllRoomByArea', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": row.shop_id,
                        "type": 1 // 类型 1 按包间区域分组 2 按包间类型分组
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.smbhRoomList = res.data.response.result
                        _this.formatChoosedSmbhRoom(row.force_register_vip_room_ids)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 格式化已选择包厢
        formatChoosedSmbhRoom(ids) {
            this.smbhChoosedRoom = []
            this.checkAllSmbhRoom = false
            if (ids == -1) { // 全部包厢
                this.checkAllSmbhRoom = true
                this.smbhRoomList.forEach(item => {
                    item.checked = true
                    item.room.forEach(v => {
                        let cindex = this.smbhChoosedRoom.findIndex(val => val == v.id)
                        if (cindex < 0) {
                            this.smbhChoosedRoom.push(v.id)
                        }
                    })
                })
            } else {
                let choosedIds = ids.split(",")
                this.smbhChoosedRoom = choosedIds

                if (choosedIds.length > 0) { // 判断区域全选状态
                    this.smbhRoomList.forEach((item, pindex) => {
                        item.choosedCount = 0
                        item.room.forEach((room, cindex) => {
                            choosedIds.forEach(v => {
                                if (v == room.id) {
                                    item.choosedCount++
                                }
                            })
                        })
                        if (item.choosedCount == item.room.length) {
                            this.smbhRoomList[pindex].checked = true
                        }
                    })
                }
            }
            this.showSmbhList = false
        },

        // 选择/取消某个区域
        handleCheckSmbhArea(val, pindex) {
            if (val) {
                this.smbhRoomList[pindex].room.forEach(item => {
                    let cindex = this.smbhChoosedRoom.findIndex(val => val == item.id)
                    if (cindex < 0) {
                        this.smbhChoosedRoom.push(item.id)
                    }
                })
                this.is_smbhAllChoosed()
            } else {
                this.smbhRoomList[pindex].room.forEach(item => {
                    let cindex = this.smbhChoosedRoom.findIndex(val => val == item.id)
                    if (cindex > -1) {
                        this.smbhChoosedRoom.splice(cindex, 1)
                    }
                })
                // 取消全选
                this.checkAllSmbhRoom = false
            }
        },

        // 选择/取消某个包厢
        handleCheckSmbhRoom(val, pindex, cindex) {
            let areaAllRoom = this.smbhRoomList[pindex].room
            let areaRoomCount = 0
            this.smbhRoomList[pindex].room.forEach(item => {
                let chooseIndex = this.smbhChoosedRoom.findIndex(id => id == item.id)
                if (chooseIndex > -1) {
                    areaRoomCount++
                }
            })
            this.smbhRoomList[pindex].checked = areaRoomCount == areaAllRoom.length

            if (!val) { // 取消全选
                this.checkAllSmbhRoom = false
            } else {
                this.is_smbhAllChoosed()
            }
        },

        // 适用包厢全选
        handleCheckAllSmbhRoomChange(val) {
            if (val) {
                this.smbhRoomList.forEach(item => {
                    item.checked = true
                    item.room.forEach(v => {
                        let cindex = this.smbhChoosedRoom.findIndex(val => val == v.id)
                        if (cindex < 0) {
                            this.smbhChoosedRoom.push(v.id)
                        }
                    })
                })
            } else {
                this.smbhRoomList.forEach(item => {
                    item.checked = false
                })
                this.smbhChoosedRoom = []
            }
        },

        // 计算是否全选
        is_smbhAllChoosed() {
            let count = 0
            this.smbhRoomList.forEach(item => {
                if (item.checked) {
                    count++
                }
            })
            this.checkAllSmbhRoom = count == this.smbhRoomList.length
        },

        // 提交修改适用包厢
        submitSmbhRoom: function () {
            let _this = this
            let room_ids = _this.checkAllSmbhRoom ? '-1' : _this.smbhChoosedRoom.join(",")
            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.smbh_shop_id,
                        "config_type": 'force_register_vip_room_ids',
                        "config": room_ids
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        _this.showSmbhList = true
                        $(_this.$refs.smbhList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /*
         * app下单默认导购员设置
         */
        innitAxmTable: function () {
            let _this = this;
            $(_this.$refs.axmList).bootstrapTable('destroy');
            $(_this.$refs.axmList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getAxmList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "10%",
                    formatter: function (value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "app_shopping_guide_set",
                    title: "app下单默认导购员设置",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.axmSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.app_shopping_guide_set == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>下单操作人</option><option value='2'>订台人</option><option value='-1'>无</option></select>";
                        } else if (row.app_shopping_guide_set == "2") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>下单操作人</option><option value='2' selected>订台人</option><option value='-1'>无</option></select>";
                        } else if (row.app_shopping_guide_set == "-1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>下单操作人</option><option value='2'>订台人</option><option value='-1' selected>无</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 列表
        getAxmList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "app_shopping_guide_set"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas2,
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        axmSub: function (id, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config": check_stock,
                        "config_type": "app_shopping_guide_set"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.axmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 刷卡赠送账号登录是否需要密码验证
         */
        // 初始化刷卡赠送账号登录是否需要密码验证
        innitSzmyTable: function () {
            let _this = this;
            $(_this.$refs.szmyList).bootstrapTable('destroy');
            $(_this.$refs.szmyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSzmyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "present_app_card_check_pwd",
                    title: "刷卡赠送账号登录是否需要密码验证",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.szmySub(row.shop_id, 'present_app_card_check_pwd', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.present_app_card_check_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "market_app_card_check_pwd",
                    title: "刷卡点单账号登录是否需要密码验证",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.szmySub(row.shop_id, 'market_app_card_check_pwd', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.market_app_card_check_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "flower_app_card_check_pwd",
                    title: "刷卡送花账号登录是否需要密码验证",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.szmySub(row.shop_id, 'flower_app_card_check_pwd', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.flower_app_card_check_pwd == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 刷卡赠送账号登录是否需要密码验证列表
        getSzmyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'app_card_check_pwd'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 刷卡赠送账号登录是否需要密码验证设置
        szmySub: function (shop_id, key, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": key,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.szmyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 开房剩余时长预警设置
         */
        // 初始化开房剩余时长预警设置
        innitKfyjTable: function () {
            let _this = this;
            $(_this.$refs.kfyjList).bootstrapTable('destroy');
            $(_this.$refs.kfyjList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getKfyjList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "room_remind_end_time",
                    title: "剩余时长预警",
                    width: "50%",
                    events: {
                        'blur .minute': function (e, value, row) {
                            let check_stock = $(this)[0].value;
                            if (value == check_stock) {
                                return
                            }
                            _this.kfyjSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        return "<input class='minute' value='" + value + "'/> 分钟";
                    }
                }]
            });
        },
        // 开房剩余时长预警设置列表
        getKfyjList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'room_remind_end_time'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 开房剩余时长预警设置
        kfyjSub: function (shop_id, num) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": "room_remind_end_time",
                        "config": num
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.kfyjList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 花单金额是否与账单金额合并支付
         */
        innitHzhzTable: function () {
            let _this = this;
            $(_this.$refs.hzhzList).bootstrapTable('destroy');
            $(_this.$refs.hzhzList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getHzhzList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "merge_flower_collection",
                    title: "账单收款时是否合并支付",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.hzhzSub(row.shop_id, check_stock, 'merge_flower_collection');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.merge_flower_collection == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option><option value='3'>手动选择</option></select>";
                        } else if (row.merge_flower_collection == "2") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option><option value='3'>手动选择</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2'>否</option><option value='3' selected>手动选择</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "merge_flower_check_out",
                    title: "结账买单时是否合并支付",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.hzhzSub(row.shop_id, check_stock, 'merge_flower_check_out');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.merge_flower_check_out == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option><option value='3'>手动选择</option></select>";
                        } else if (row.merge_flower_check_out == "2") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option><option value='3'>手动选择</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2'>否</option><option value='3' selected>手动选择</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        getHzhzList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'merge_flower_data'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        hzhzSub: function (shop_id, num, config_type) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": config_type,
                        "config": num
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.hzhzList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 包厢状态图当前消费与未收款是否包含花单金额
         */
        innitBzbhTable: function () {
            let _this = this;
            $(_this.$refs.bzbhList).bootstrapTable('destroy');
            $(_this.$refs.bzbhList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getBzbhList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "merge_flower_room_status_unpaid_amount",
                    title: "包厢状态图当前消费与未收款是否包含花单金额",
                    width: "50%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.bzbhSub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.merge_flower_room_status_unpaid_amount == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        getBzbhList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'merge_flower_data'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        bzbhSub: function (shop_id, num) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": "merge_flower_room_status_unpaid_amount",
                        "config": num
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.bzhzList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 不满低消时酒水服务费统计方式设置
         */
        innitBdjftTable: function () {
            let _this = this;
            $(_this.$refs.bdjftList).bootstrapTable('destroy');
            $(_this.$refs.bdjftList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getBdjftList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "40%"
                }, {
                    field: "type",
                    title: "酒水服务费统计方式",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.BdjftSub(row.shop_id, check_stock, 'service_charge_type');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.type == "1") {
                            strHtml = "<select class='select-sel select2 ct-select middle-size'><option value='1' selected>按实际售卖商品设置的服务费</option><option value='2'>按低消金额折算服务费</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select middle-size'><option value='1'>按实际售卖商品设置的服务费</option><option value='2' selected>按低消金额折算服务费</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "ratio",
                    title: "服务费收取比例设置（%）",
                    width: "30%",
                    events: {
                        'blur .ratio': function (e, value, row) {
                            let check_stock = $(this)[0].value;
                            if (value == check_stock) {
                                return
                            }
                            _this.BdjftSub(row.shop_id, check_stock, 'service_charge_ratio');
                        }
                    },
                    formatter: function (value, row, index) {
                        console.log(row)
                        if (row.type == '1') {
                            return "<input class='ratio' placeholder='请输入服务费收取比例' disabled/> %"
                        } else {
                            return "<input class='ratio' value='" + value + "'/> %";
                        }
                    }
                }]
            });
        },

        getBdjftList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'service_charge'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        BdjftSub: function (shop_id, num, key) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": key,
                        "config": num
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.bdjftList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 自助大厅扫码登录是否默认办理会员卡
         */
        // 初始化自助大厅扫码登录是否默认办理会员卡
        innitZzsmTable: function () {
            let _this = this;
            $(_this.$refs.zzsmList).bootstrapTable('destroy');
            $(_this.$refs.zzsmList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getZzsmList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "js_force_register_vip",
                    title: "自助点酒水扫码登录是否默认办理会员卡",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.zzsmSub(row.shop_id, 'js_force_register_vip', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.js_force_register_vip == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "kf_force_register_vip",
                    title: "自助开房扫码登录是否默认办理会员卡",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.zzsmSub(row.shop_id, 'kf_force_register_vip', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.kf_force_register_vip == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 自助大厅扫码登录是否默认办理会员卡列表
        getZzsmList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "hall"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 自助大厅扫码登录是否默认办理会员卡设置
        zzsmSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.zzsmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 会员积分兑换是否支持连锁门店通用
         */
        innitHjdtyTable: function () {
            let _this = this;
            $(_this.$refs.hjdtyList).bootstrapTable('destroy');
            $(_this.$refs.hjdtyList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getHjdtyList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "vip_points_goods_all_shop",
                    title: "会员积分兑换是否支持连锁门店通用",
                    width: "50%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.hjdtySub(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_points_goods_all_shop == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        getHjdtyList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": 'vip_points_goods_all_shop'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 设置
        hjdtySub: function (shop_id, num) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": shop_id,
                        "config_type": "vip_points_goods_all_shop",
                        "config": num
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.hjdtyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
        * 收银交接是否包含花单金额
        */
        // 初始化收银交接是否包含花单金额
        innitSjbhTable: function () {
            let _this = this;
            $(_this.$refs.sjbhList).bootstrapTable('destroy');
            $(_this.$refs.sjbhList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSjbhList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "flower_shift_turnover",
                    title: "交接班是否包含花单金额",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.sjbhSub(row.shop_id, 'flower_shift_turnover', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.flower_shift_turnover == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "flower_cashier_shift_turnover",
                    title: "营业收入交接班是否包含花单金额",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.sjbhSub(row.shop_id, 'flower_cashier_shift_turnover', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.flower_cashier_shift_turnover == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 收银交接是否包含花单金额列表
        getSjbhList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "flower_shift_turnover_data"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 收银交接是否包含花单金额设置
        sjbhSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.sjbhList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 微信端会员条码显示设置
         */
        // 初始化微信端会员条码显示
        innitWxhtxTable: function () {
            let _this = this;
            $(_this.$refs.wxhtxList).bootstrapTable('destroy');
            $(_this.$refs.wxhtxList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getWxhtxList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "vip_qrcode_static",
                    title: "会员码固定条码是否显示",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wxhtxSub(row.shop_id, 'vip_qrcode_static', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_qrcode_static == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "vip_qrcode_dynamic",
                    title: "会员码动态条码是否显示",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.wxhtxSub(row.shop_id, 'vip_qrcode_dynamic', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_qrcode_dynamic == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 微信端会员条码显示设置列表
        getWxhtxList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "wx_vip_set"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 微信端会员条码显示设置
        wxhtxSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.wxhtxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
        * 账单员工可赠送比例金额是否扣除已赠送金额设置
        */
        // 初始化账单员工可赠送比例金额是否扣除已赠送金额
        innitZykzbjTable: function () {
            let _this = this;
            $(_this.$refs.zykzbjList).bootstrapTable('destroy');
            $(_this.$refs.zykzbjList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getZykzbjList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "room_give_staff_contain_other",
                    title: "账单员工可赠送比例金额是否扣除已赠送金额",
                    width: "50%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.zykzbjSub(row.shop_id, 'room_give_staff_contain_other', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.room_give_staff_contain_other == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 账单员工可赠送比例金额是否扣除已赠送金额列表
        getZykzbjList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "room_give_staff_contain_other"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 账单员工可赠送比例金额是否扣除已赠送金额设置
        zykzbjSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.zykzbjList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 客遗回收入库默认设置
         */
        // 初始客遗回收入库默认设置
        innitKyrkTable: function () {
            let _this = this;
            $(_this.$refs.kyrkList).bootstrapTable('destroy');
            $(_this.$refs.kyrkList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getKyrkList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "guest_leave_store_type",
                    title: "默认采购类型设置",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.kyrkSub(row.shop_id, 'guest_leave_store_type', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        let options = ["<option value='1'>采购</option>",
                            "<option value='2'>赠送</option>",
                            "<option value='3'>盈余</option>",
                            "<option value='4'>换货</option>",
                            "<option value='5'>客遗</option>"]
                        let arr_index = row.guest_leave_store_type - 0 - 1
                        options[arr_index] = '<option selected ' + options[arr_index].split("<option ")[1]
                        strHtml = "<select class='select-sel select2 ct-select'>" + options.join("") + "</select>";
                        return strHtml;
                    }
                }, {
                    field: "guest_leave_supplier_id",
                    title: "默认供应商设置",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.kyrkSub(row.shop_id, 'guest_leave_supplier_id', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        let options = ["<option value='0'>无</option>"];
                        row.supplier_info.forEach(item => {
                            let selected = ''
                            if (item.id == row.guest_leave_supplier_id) {
                                selected = 'selected'
                            }
                            options.push("<option value='" + item.id + "'" + selected + ">" + item.name + "</option>")
                        })
                        strHtml = "<select class='select-sel select2 ct-select guest_leave_supplier" + index + "'>" + options.join("") + "</select>";
                        return strHtml;
                    }
                }, {
                    field: "guest_leave_store_id",
                    title: "默认入库仓库设置",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.kyrkSub(row.shop_id, 'guest_leave_store_id', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        let options = ["<option value='0'>无</option>"];
                        row.store_info.forEach(item => {
                            let selected = ''
                            if (item.id == row.guest_leave_store_id) {
                                selected = 'selected'
                            }
                            options.push("<option value='" + item.id + "'" + selected + ">" + item.name + "</option>")
                        })
                        strHtml = "<select class='select-sel select2 ct-select guest_leave_store" + index + "'>" + options.join("") + "</select>";
                        return strHtml;
                    }
                }]
            });
        },
        // 客遗回收入库默认设置
        getKyrkList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "guest_leave_store_type"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                        _this.$nextTick(() => {
                            data.response.result.data.forEach((item, index) => {
                                $(".guest_leave_supplier" + index).select2({
                                    language: "zh-CN",
                                    width: '150'
                                })
                                $(".guest_leave_store" + index).select2({
                                    language: "zh-CN",
                                    width: '150'
                                })
                            })
                        })
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 客遗回收入库默认采购类型设置
        kyrkSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.kyrkList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 点单收银待支付划线价显示设置
         */
        // 初始化点单收银待支付划线价显示
        innitDdhxjTable: function () {
            let _this = this;
            $(_this.$refs.ddhxjList).bootstrapTable('destroy');
            $(_this.$refs.ddhxjList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getDdhxjList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "40%"
                }, {
                    field: "app_dd_list_price",
                    title: "点单收银待支付划线价显示",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.ddhxjSub(row.shop_id, 'app_dd_list_price', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        let options = ["<option value='1'>原价</option>",
                            "<option value='2'>会员价</option>",
                            "<option value='3'>不显示</option>",]
                        let arr_index = row.app_dd_list_price - 0 - 1
                        options[arr_index] = '<option selected ' + options[arr_index].split("<option ")[1]
                        strHtml = "<select class='select-sel select2 ct-select'>" + options.join("") + "</select>";
                        return strHtml;
                    }
                }]
            });
        },
        // 点单收银待支付划线价显示列表
        getDdhxjList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "app_dd_list_price"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点单收银待支付划线价显示设置
        ddhxjSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.ddhxjList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 报表默认检索时间设置
         */
        // 初始化报表默认检索时间
        innitBbmssTable: function () {
            let _this = this;
            $(_this.$refs.bbmssList).bootstrapTable('destroy');
            $(_this.$refs.bbmssList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getBbmssList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "40%"
                }, {
                    field: "report_default_time",
                    title: "报表默认检索时间设置",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.bbmssSub(row.shop_id, 'report_default_time', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.report_default_time == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>当前营业日</option><option value='2'>上一个营业日</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>当前营业日</option><option value='2' selected>上一个营业日</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 报表默认检索时间设置列表
        getBbmssList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "report_default_time"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 报表默认检索时间设置
        bbmssSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.bbmssList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 订台业绩是否包含未收款金额设置
         */
        // 初始化订台业绩是否包含未收款金额列表
        innitDysbwTable: function () {
            let _this = this;
            $(_this.$refs.dysbwList).bootstrapTable('destroy');
            $(_this.$refs.dysbwList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getDysbwList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "40%"
                }, {
                    field: "achievement_include_unpaid",
                    title: "订台业绩是否包含未收款金额",
                    width: "40%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.dysbwSub(row.shop_id, 'achievement_include_unpaid', check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.achievement_include_unpaid == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },
        // 订台业绩是否包含未收款金额列表
        getDysbwList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "achievement_include_unpaid"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 订台业绩是否包含未收款金额设置
        dysbwSub: function (id, config_type, check_stock) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.dysbwList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 班次设置
         */
        // 初始化班次设置列表
        innitBcszTable: function () {
            let _this = this;
            $(_this.$refs.bcszList).bootstrapTable('destroy');
            $(_this.$refs.bcszList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getBcszList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "20%"
                }, {
                    field: "status",
                    title: "是否开启班次定义",
                    width: "20%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.bcszSub(row.shop_id, 'shift_setting', check_stock, row.time_info);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.status == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "config",
                    title: "班次设置",
                    width: "40%",
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.time_info.length > 0) {
                            row.time_info.forEach(item => {
                                strHtml = strHtml + item.name + '：' + item.start_time + '-' + item.end_time + '；'
                            })
                        }
                        return strHtml.substr(0, strHtml.length - 1)
                    }
                }, {
                    field: "",
                    title: "操作",
                    width: "10%",
                    events: {
                        'click .text-blue': function (e, value, row) {
                            var obj = JSON.parse(JSON.stringify(row))
                            _this.bcszInfo = obj.time_info

                            layer.confirm('', {
                                skin: 'add_goods-alert',
                                type: 1,
                                btn: ['确定', '取消'],
                                title: ['班次修改', true],
                                area: ['750px', ''],
                                content: $(_this.$refs.bcsz_pop),
                                offset: '100px'
                            }, function () {
                                _this.bcszSub(row.shop_id, 'shift_setting', row.status, _this.bcszInfo);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "<span class='text-blue'>修改</span>";
                        return strHtml;
                    }
                },]
            });
        },

        addBcsz() {
            this.bcszInfo.push({
                name: '',
                start_time: '',
                end_time: ''
            })
        },

        delBcsz(index) {
            this.bcszInfo.splice(index, 1)
        },

        // 班次设置列表
        getBcszList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "shift_setting"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 班次设置
        bcszSub: function (id, config_type, check_stock, time_info) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": {
                            "status": check_stock,
                            "time_info": time_info
                        }
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg('设置成功');
                        $(_this.$refs.bcszList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 收银机app包厢状态背景图设置
         */
        // 初始化收银机app包厢状态背景图设置列表
        innitRoomBgTable: function () {
            let _this = this;
            let actionEvents = {
                'click .color-set': function (e, value, row) {
                    console.log('color-set')
                },
                'click .text-blue': function (e, value, row) {
                    console.log('text-blue')
                }
            }
            $(_this.$refs.roombgList).bootstrapTable('destroy');
            $(_this.$refs.roombgList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getRoomBgList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "",
                    title: "房态底图设置",
                    width: "30%",
                    events: {
                        'click .text-blue': function (e, value, row) {
                            _this.shop_id = row.shop_id
                            _this.getRoomBgColors(row.shop_id)
                            _this.showRoomBgColorSet = true
                            _this.showRoomBgImgSet = false
                        }
                    },
                    formatter: function (value, row, index) {
                        let str = "<span class='text-blue'>设置</span>";
                        return str;
                    }
                }, {
                    field: "app_room_page_background",
                    title: "收银机app包厢状态背景图设置",
                    width: "30%",
                    events: {
                        'click .text-blue': function (e, value, row) {
                            _this.shop_id = row.shop_id
                            _this.roomBgImgId = row.app_room_page_background
                            _this.getShopBgImgs(row.shop_id)
                            _this.showRoomBgImgSet = true
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "<span class='text-blue'>设置</span>";
                        return strHtml;
                    }
                },]
            });
        },
        // 收银机app包厢状态背景图设置列表
        getRoomBgList: function (params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": "app_room_page_background"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 获取门店包厢状态背景图列表
        getShopBgImgs: function (shop_id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getRoomPageBgImgList",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.roomBgImgs = data.response.result;
                        _this.inniRoomBgImgUpload()
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 上传包厢状态背景图
        inniRoomBgImgUpload: function () {
            if (this.roomBgImgUploader.length > 0) { // 销毁先前的实例
                this.roomBgImgUploader.forEach(v => {
                    v.destroy()
                })
                this.roomBgImgUploader = []
            }

            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: 'roomBgImgAdd', // 选择文件id
                filters: {
                    mime_types: [ // 文件格式限制
                        { title: "Image files", extensions: "jpg,jpeg,png" }
                    ],
                    max_file_size: '5mb', // 文件大小限制
                    prevent_duplicates: true // 不允许选取重复文件
                },
                // resize: {
                //  width: 527,
                //  height: 296
                // },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'Setting'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        _this.img_url = host + "/" + dir + file_name;
                        layer.msg('上传成功');
                        _this.addRoomBgImg(_this.shop_id, _this.img_url)
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择5mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.roomBgImgUploader.push(uploader)
        },
        // 新增包厢状态背景图
        addRoomBgImg: function (shop_id, img_url) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                        "img_url": img_url,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/uploadRoomPageBgImg",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.getShopBgImgs(shop_id)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 删除背景图
        delRoomBgImg(id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delRoomPageBgImg",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.getShopBgImgs(_this.shop_id)
                        layer.msg("删除成功！")
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 保存包厢状态背景图设置
        saveRoomBgImg: function () {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.shop_id,
                        "config_type": 'app_room_page_background',
                        "config": _this.roomBgImgId
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        _this.showRoomBgImgSet = false;
                        $(_this.$refs.roombgList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 获取门店包厢状态背景颜色列表 
        getRoomBgColors(shop_id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getRoomPageColorConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.room_bg_colors = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 恢复默认
        backToDefaultColor(index) {
            this.room_bg_colors[index].color = this.room_bg_colors[index].default_color
        },

        openColorPickerPop(index) {
            const _this = this
            const origin_color = '#' + _this.room_bg_colors[index].color

            _this.colorPickerIndex = index
            _this.colorPickerPopColor = '#' + _this.room_bg_colors[index].color
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['选择颜色', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.color_picker_pop),
                cancel: function () {
                    // 右上角关闭
                    _this.$set(_this.room_bg_colors[index], 'color', origin_color.replace('#', ''))
                }
            }, function () {
                layer.closeAll();
            }, function () {
                _this.$set(_this.room_bg_colors[index], 'color', origin_color.replace('#', ''))
            });

        },

        // 颜色选择器颜色值改变
        onColorPickerChange(color) {
            this.room_bg_colors[this.colorPickerIndex].color = color.hex8.replace('#', '')
        },

        // 提交颜色设置
        commitRoomBgColorSet() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                        "config": _this.room_bg_colors
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setRoomPageColorConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        _this.showRoomBgColorSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*************************** 团购平台类型设置 ******************************/
        // 获取门店列表
        getShopList: function (resolve) {
            const _this = this;

            Vue.axios.post('PublicData/api_getShopListByPurview', {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        getTgplList(page) {
            const _this = this;

            _this.tgpl_loading = true;
            _this.tgpl_page = page
            Vue.axios.post('ShopGroup/getList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_id": _this.tgpl_form.shop_id,
                        "name": _this.tgpl_form.name
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.tgpl_total = Number(res.data.response.result.total)
                        }
                        _this.tgpl_table = res.data.response.result.rows;
                        _this.tgpl_loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        //点击“新增平台”
        addNewTgpl() {
            let _this = this
            _this.tgplModify = false
            _this.tgpl_add_form = {
                shop_id: _this.tgpl_form.shop_id,
                listorder: '',
                name: '',
            }
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增平台', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.tgpl_pop),
            }, function () {
                Vue.axios.post('ShopGroup/addData', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.tgpl_add_form
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg("操作成功！")
                            _this.getTgplList(1)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },
        //点击“修改”
        editTgpl(row) {
            let _this = this
            _this.tgplModify = true
            _this.tgpl_add_form = {
                id: row.id,
                shop_id: _this.tgpl_form.shop_id,
                listorder: row.listorder,
                name: row.name,
                type: row.type
            }
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['修改', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.tgpl_pop),
            }, function () {
                Vue.axios.post('ShopGroup/editData', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.tgpl_add_form
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg("操作成功！")
                            _this.getTgplList(_this.tgpl_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },
        // 更新状态
        updateTgplStatus(id, status) {
            let _this = this
            let title = status == '-1' ? '是否禁用？' : status == '1' ? '是否启用？' : '删除后数据将不可恢复！确认删除？'

            layer.confirm(title, {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                Vue.axios.post('ShopGroup/upStatus', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                            "status": status
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        layer.closeAll()
                        if (res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.getTgplList(_this.tgpl_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        /*
         * 会员资料必填项设置
         */
        // 初始化会员资料必填项设置列表
        innitHzbtTable: function () {
            let _this = this;
            $(_this.$refs.hzbtList).bootstrapTable('destroy');
            $(_this.$refs.hzbtList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'vip_data_required');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "vip_mobile_required",
                    title: "会员手机号是否必填",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'vip_mobile_required', check_stock, 'hzbtList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_mobile_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "vip_id_number_required",
                    title: "会员身份证号是否必填",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'vip_id_number_required', check_stock, 'hzbtList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_id_number_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        // 通用设置列表
        commonGetConfigList(params, config_type) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "config_type": config_type
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 通用设置
        commonConfigSet(id, config_type, check_stock, ref) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id,
                        "config_type": config_type,
                        "config": check_stock
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs[`${ref}`]).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 微信端优惠券显示设置
         */
        // 初始化微信端优惠券显示设置列表
        innitWyxTable: function () {
            let _this = this;
            $(_this.$refs.wyxList).bootstrapTable('destroy');
            $(_this.$refs.wyxList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'reward_show_setting');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "30%"
                }, {
                    field: "used_reward_show",
                    title: "已使用的优惠券是否显示",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'used_reward_show', check_stock, 'wyxList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.used_reward_show == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "expired_reward_show",
                    title: "已过期的优惠券是否显",
                    width: "30%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'expired_reward_show', check_stock, 'wyxList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.expired_reward_show == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        /*
         * 排队取号会员是否独立排号
         */
        // 初始化排队取号会员是否独立排号设置列表
        innitVipQueueTable: function () {
            let _this = this;
            $(_this.$refs.vipQueueList).bootstrapTable('destroy');
            $(_this.$refs.vipQueueList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'vip_linkup');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "vip_linkup",
                    title: "排队取号会员是否独立排号",
                    width: "50%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'vip_linkup', check_stock, 'vipQueueList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.vip_linkup == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        /*
         * 排队取号叫号语音文本设置
         */
        // 初始化设置列表
        innitQueueVoiceTable: function () {
            let _this = this;
            $(_this.$refs.queueVoiceList).bootstrapTable('destroy');
            $(_this.$refs.queueVoiceList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'call_content');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "call_content",
                    title: "叫号语音文本",
                    width: "50%",
                    events: {
                        'click .edit': function (e, value, row) {
                            console.log(row)
                            _this.openQueueVoiceSetPop(row)
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">设置</span>'
                    }
                }]
            });
        },

        openQueueVoiceSetPop: function (row) {
            let _this = this;
            _this.voice_call_content = row.call_content

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['叫号语音文本设置', true],
                area: ['550px', '400px'],
                content: $(_this.$refs.voice_set_pop),
                offset: '100px'
            }, function () {
                layer.closeAll()
                _this.commonConfigSet(row.shop_id, 'call_content', _this.voice_call_content, 'queueVoiceList');
            });
        },

        insertVariableText() {
            const textToInsert = '【排队号】'
            // 获取input的dom元素
            const textarea = this.$refs.voiceTextarea.$el.querySelector('textarea');

            // 保存当前的光标位置
            const currentCursorPosition = textarea.selectionStart;

            // 获取当前textarea中的文本内容
            const currentValue = textarea.value;

            // 插入文本：保留原有内容，并在光标位置添加新文本
            const updatedValue = currentValue.slice(0, currentCursorPosition) + textToInsert + currentValue.slice(currentCursorPosition);

            // 更新textarea的值并设置新的光标位置（在插入文本之后）
            this.voice_call_content = updatedValue
            textarea.selectionStart = textarea.selectionEnd = currentCursorPosition + textToInsert.length;
        },

        /*
         * 服务评价管理设置
         */
        // 初始化设置列表
        innitServiceCommentTable: function () {
            let _this = this;
            $(_this.$refs.serviceCommentList).bootstrapTable('destroy');
            $(_this.$refs.serviceCommentList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'comment_setting');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "",
                    title: "操作",
                    width: "50%",
                    events: {
                        'click .edit': function (e, value, row) {
                            console.log(row)
                            _this.service_comment_form = JSON.parse(JSON.stringify(row))
                            _this.showServiceCommentList = false
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">设置</span>'
                    }
                }]
            });
        },

        // 打开“关联券弹窗”
        openVoucherPop() {
            let _this = this
            if (this.service_comment_form.comment_voucher_status == '-1') {
                return
            }
            this.service_comment_form.comment_voucher_type = (this.service_comment_form.comment_voucher_type == '2' && this.business_model == 2) ? '2' : '1'// 1：巨嗨卡券，2：友宝售后机商品券
            this.card_type_name = '' // 卡券名称
            this.query_voucher_name = '' // 关联券弹窗检索名称
            let c_voucher_type = (this.service_comment_form.comment_voucher_type == '2' && this.business_model == 2) ? '2' : '1'

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['保存', '取消'],
                title: ['请选择券', true],
                area: ['780px', '580px'],
                content: $(_this.$refs.coupon_pop),
                offset: '100px',
                cancel: function () {
                    // 右上角关闭
                    _this.service_comment_form.comment_voucher_type = c_voucher_type
                }
            }, function () {
                if (!_this.choosedVoucher.goods_name) {
                    layer.msg("请先选择关联券")
                    return
                }
                _this.service_comment_form.comment_voucher_id = _this.choosedVoucher.goods_id
                _this.service_comment_form.comment_voucher_name = _this.choosedVoucher.goods_name + '（' + _this.choosedVoucher.goods_type_name + '）'
                layer.closeAll()
            }, function () {
                _this.service_comment_form.comment_voucher_type = c_voucher_type
            });

            _this.$nextTick(() => {
                _this.getPopCouponList(1)
            })
        },

        // 获取卡券列表
        getCouponList: function (page) {
            let _this = this
            _this.pop_loading = true
            _this.coupon_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": _this.service_comment_form.shop_id,
                        "type": $.trim(_this.card_type_name),
                        "name": _this.query_voucher_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "MerchantGift/getList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.coupon_total = Number(data.response.result.count);
                        }
                        _this.coupon_list = data.response.result.data;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 获取售后机商品券列表
        getUboxVoucherList: function (page) {
            let _this = this
            _this.pop_loading = true
            _this.coupon_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": _this.service_comment_form.shop_id,
                        "type": $.trim(_this.card_type_name),
                        "name": _this.query_voucher_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "MerchantGift/getUboxVoucherList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.coupon_total = Number(data.response.result.count);
                        }
                        _this.coupon_list = data.response.result.data;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 关联券弹窗券类型变化
        onVoucherTypeChange(val) {
            this.card_type_name = ''
            if (val == '1') {
                this.getCouponList(1)
            } else {
                this.getUboxVoucherList(1)
            }
        },

        // 获取弹窗列表
        getPopCouponList(page) {
            if (this.service_comment_form.comment_voucher_type == '1') {
                this.getCouponList(page)
            } else {
                this.getUboxVoucherList(page)
            }
        },

        // 点击兑换弹窗“查询”
        onPopQueryClick() {
            this.choosedVoucher = {}
            this.getPopCouponList(1)
        },

        // 选择券
        onPopCouponSelect(val, row) {
            this.$refs.coupon_table.clearSelection()
            this.$refs.coupon_table.toggleRowSelection(row, true)
            this.choosedVoucher = row
        },

        // 提交服务评价设置
        commitServiceCommentSet() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.service_comment_form.shop_id,
                        "config_type": "comment_setting",
                        "config": _this.service_comment_form
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        _this.showServiceCommentList = true
                        $(_this.$refs.serviceCommentList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        /*
         * 账单自助付款功能设置
         */
        // 初始化设置列表
        innitSelfPayTable: function () {
            let _this = this;
            $(_this.$refs.selfPayList).bootstrapTable('destroy');
            $(_this.$refs.selfPayList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'bill_self_help_payment');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "",
                    title: "操作",
                    width: "50%",
                    events: {
                        'click .edit': function (e, value, row) {
                            const obj = JSON.parse(JSON.stringify(row))
                            _this.self_pay_form = {
                                shop_id: obj.shop_id,
                                status: obj.bill_self_help_payment.status,
                                show: obj.bill_self_help_payment.show
                            }
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: ['确定', '取消'],
                                title: ['设置', true],
                                area: ['550px', 'auto'],
                                content: $(_this.$refs.self_pay_pop),
                                offset: '100px',
                            }, function () {
                                _this.commitSelfPaySet()
                            });

                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">设置</span>'
                    }
                }]
            });
        },

        // 提交服务评价设置
        commitSelfPaySet() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.self_pay_form.shop_id,
                        "config_type": "bill_self_help_payment",
                        "config": _this.self_pay_form
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.closeAll()
                        layer.msg('设置成功');
                        $(_this.$refs.selfPayList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 初始化会员自助注册用户协议设置列表
        innitUserAgreementTable() {
            let _this = this;
            $(_this.$refs.userAgreementList).bootstrapTable('destroy');
            $(_this.$refs.userAgreementList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getUserAgreementList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "name",
                    title: "门店",
                    width: "33%"
                }, {
                    field: "agreement_status",
                    title: "会员注册用户协议设置",
                    width: "33%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.userAgreementStatusSet(row.shop_id, check_stock);
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.agreement_status == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "",
                    title: "操作",
                    width: "33%",
                    events: {
                        'click .text-blue': function (e, value, row) {
                            _this.shop_id = row.shop_id
                            _this.getUserAgreementContent()
                            _this.showUserAgreementContent = true
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "<span class='text-blue'>协议内容设置</span>";
                        return strHtml;
                    }
                }]
            })
        },

        getUserAgreementList(params) {
            let _this = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/getShopSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        userAgreementStatusSet(shop_id, status) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                        "agreement_status": status
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/updateAgreementStatus",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg('设置成功');
                        $(_this.$refs.userAgreementList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        getUserAgreementContent() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/getAgreementContent",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.userAgreementContent = data.response.result._content
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        commitUserAgreementContent() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                        "content": _this.userAgreementContent
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Vip/updateAgreementContent",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("保存成功！")
                        _this.showUserAgreementContent = false
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        /*
         * 在线预订回执设置
         */
        // 初始化设置列表
        innitOnlineReserveReceiptTable() {
            let _this = this;
            $(_this.$refs.onlineReserveReceiptList).bootstrapTable('destroy');
            $(_this.$refs.onlineReserveReceiptList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'shop_book_receipt');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "50%"
                }, {
                    field: "",
                    title: "在线预订回执详情页自定义设置",
                    width: "50%",
                    events: {
                        'click .edit': function (e, value, row) {
                            const obj = JSON.parse(JSON.stringify(row))
                            _this.shop_book_receipt = obj.shop_book_receipt
                            _this.shop_id = obj.shop_id
                            _this.book_receipt_operational_scene = ''
                            _this.getBookReceiptModuleList()
                            _this.showOnlineReserveReceiptList = false
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue edit">设置</span>'
                    }
                }]
            });
        },

        // 打开预定回执详情设置弹窗
        openBookReceiptSetPop() {
            let _this = this;
            _this.book_receipt_set_form = _this.shop_book_receipt[`${_this.book_receipt_operational_scene}`]
            _this.book_receipt_set_form.operational_scene = _this.book_receipt_operational_scene;

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['设置', true],
                area: ['550px', 'auto'],
                content: $(_this.$refs.book_receipt_set_pop),
                offset: '100px',
            }, function () {
                _this.commitBookReceiptSet()
            });
        },

        // 保存预订回执设置
        commitBookReceiptSet() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.shop_id,
                        "config_type": 'shop_book_receipt',
                        "config": _this.book_receipt_set_form
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/upConfig",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg("修改成功！");
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        initBookReceiptUploader() {
            if (this.roomBgImgUploader.length > 0) { // 销毁先前的实例
                this.roomBgImgUploader.forEach(v => {
                    v.destroy()
                })
                this.roomBgImgUploader = []
            }
            this.bookReceiptModuleImgUpload('add_book_receipt_module_poster')
            this.bookReceiptModuleImgUpload('add_book_receipt_module_upload_video_btn')
            this.bookReceiptModuleImgUpload('add_book_receipt_module_img')
        },

        // 初始化预定回执模块图片、视频上传
        bookReceiptModuleImgUpload(btnName) {
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            let mime_types = [] // 文件格式限制
            if (btnName.indexOf("upload_video_btn") > -1) {
                mime_types = [
                    { title: "video files", extensions: "mp4" }
                ]
            } else {
                mime_types = [
                    { title: "Image files", extensions: "jpg,jpeg,png" }
                ]
            }
            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: btnName, // 选择文件id
                filters: {
                    mime_types: mime_types,
                    // mime_types: [ // 文件格式限制
                    //     { title: "Image files", extensions: "jpg,jpeg,png" }
                    // ],
                    max_file_size: '15mb', // 文件大小限制
                    prevent_duplicates: true // 不允许选取重复文件
                },
                // resize: {
                //  width: 527,
                //  height: 296
                // },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'Setting_book_receipt'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        let file_url = host + "/" + dir + file_name
                        if (btnName.indexOf("upload_video_btn") > -1) {
                            _this.add_book_receipt_module_form.detail.video_url = file_url;
                        } else if (btnName.indexOf("add_book_receipt_module_img") > -1 || btnName.indexOf("add_book_receipt_module_poster") > -1) {
                            _this.add_book_receipt_module_form.detail.img_url = file_url;
                        } else if (btnName.indexOf("book-receipt-module-banner-img") > -1) { // 模块 banner
                            let index = btnName.split("book-receipt-module-banner-img-")[1]
                            _this.book_receipt_module_detail[index].img_url = file_url;
                        } else if (btnName.indexOf("book-receipt-module-detail-img") > -1) { // 模块详情页面img
                            let index = btnName.split("book-receipt-module-detail-img-")[1]
                            _this.book_receipt_module_detail[index].detail_img = file_url;
                        } else if (btnName.indexOf("book-receipt-user-operation-img") > -1) { // 用户操作模块图片
                            let index = btnName.split("book-receipt-user-operation-img-")[1]
                            _this.book_receipt_module_detail[index].img = file_url;
                        }
                        layer.msg('上传成功');
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择15mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png,mp4文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.roomBgImgUploader.push(uploader)
        },

        // 获取预订回执模块列表
        getBookReceiptModuleList() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/getModuleListNew",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.book_receipt_scene_list = data.response.result
                        if(_this.book_receipt_scene_list.length > 0) {
                            if(_this.book_receipt_operational_scene == '') {
                                _this.book_receipt_operational_scene = _this.book_receipt_scene_list[0].operational_scene;
                                _this.book_receipt_scene_name = _this.book_receipt_scene_list[0].operational_scene_name;
                                _this.book_receipt_module_list = _this.book_receipt_scene_list[0].module_list;
                            } else {
                                const index = _this.book_receipt_scene_list.findIndex(item => item.operational_scene === _this.book_receipt_operational_scene)
                                _this.book_receipt_scene_name = _this.book_receipt_scene_list[index].operational_scene_name;
                                _this.book_receipt_module_list = _this.book_receipt_scene_list[index].module_list;
                            }
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 切换预订回执场景
        onBookReceiptSceneTabClick(tab) {
            const index = this.book_receipt_scene_list.findIndex(item => item.operational_scene_name === tab.name)
            this.book_receipt_module_list = this.book_receipt_scene_list[index].module_list
            this.book_receipt_operational_scene = this.book_receipt_scene_list[index].operational_scene
        },

        // 获取预订回执模块类型列表
        getBookReceiptModuleTypeList() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/getModuleTypeList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.book_receipt_module_type = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 获取预订回执主题列表
        getBookReceiptThemeList() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/getThemeList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.book_receipt_theme_list = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 新增预订回执模块
        addBookReceiptModule() {
            let _this = this;
            _this.add_book_receipt_module_form = {
                shop_id: _this.shop_id,
                operational_scene: _this.book_receipt_operational_scene,
                id: '',
                listorder: '',
                type: '',
                detail: {
                    theme: [],
                    title: '',
                    img_url: '',
                    video_url: '',
                }
            }

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['新增内容', true],
                area: ['600px', '600px'],
                content: $(_this.$refs.add_book_receipt_module_pop),
                offset: '100px',
            }, function () {
                _this.commitBookReceiptModule()
            });

            _this.$nextTick(() => {
                _this.initBookReceiptUploader()
            })
        },

        // 修改预订回执模块
        editBookReceiptModule(row) {
            let _this = this;
            let obj = JSON.parse(JSON.stringify(row));
            _this.add_book_receipt_module_form = {
                shop_id: _this.shop_id,
                operational_scene: obj.operational_scene,
                id: obj.id,
                listorder: obj.listorder,
                type: obj.type,
                detail: {
                    theme: obj.detail.theme || [],
                    title: obj.detail.title || '',
                    img_url: obj.detail.img_url || '',
                    video_url: obj.detail.video_url || '',
                }
            }

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['修改内容', true],
                area: ['600px', '600px'],
                content: $(_this.$refs.add_book_receipt_module_pop),
                offset: '100px',
            }, function () {
                _this.commitBookReceiptModule()
            });

            _this.$nextTick(() => {
                _this.initBookReceiptUploader()
            })
        },

        // 保存新增、修改预订回执模块
        commitBookReceiptModule() {
            let _this = this;
            if(_this.add_book_receipt_module_form.type == '') {
                layer.msg('请选择类型');
                return;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": _this.add_book_receipt_module_form
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/editModule",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.closeAll();
                        if (_this.add_book_receipt_module_form.id == '') {
                            layer.msg("新增成功！");
                        } else {
                            layer.msg("修改成功！");
                        }
                        _this.getBookReceiptModuleList()
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 更新预订回执模块状态 
        updateBookReceiptModuleStatus(id) {
            let _this = this
            let title = status == '-1' ? '是否禁用？' : '是否启用？'

            layer.confirm(title, {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                Vue.axios.post('BookReceipt/setModuleStatus', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        layer.closeAll()
                        if (res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.getBookReceiptModuleList()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        // 删除预订回执模块 
        delBookReceiptModule(id) {
            let _this = this
            layer.confirm('删除后数据将不可恢复！确认删除吗？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                Vue.axios.post('BookReceipt/deleteModule', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        layer.closeAll()
                        if (res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.getBookReceiptModuleList()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        // 点击列表“模块设置”
        bookReceiptModuleSetting(row) {
            this.book_receipt_module_id = row.id
            this.book_receipt_module_oper_type = row.type
            this.getBookReceiptModuleDetail(row.id, row.type)
        },

        // 获取预订回执模块详情
        getBookReceiptModuleDetail(id, type) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/getModuleDetail",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let res = data.response.result
                        if (type == 1) { // banner
                            res.forEach(item => {
                                item.enter = (!!item.detail_url || !!item.detail_img) ? 1 : -1
                                item.enter_type = item.enter == 1 ? (!!item.detail_url ? 2 : 1) : ''
                            })
                            _this.book_receipt_module_detail = res
                            _this.showBookReceiptModuleBannerSet = true
                            _this.$nextTick(() => {
                                _this.initBookReceiptModuleDetailUploader()
                            })
                        } else if (type == 2) { // 文案
                            _this.book_receipt_module_detail = res
                            if (!_this.book_receipt_module_detail.content) {
                                _this.$set(_this.book_receipt_module_detail, 'content', '')
                            }
                            _this.getBookReceiptModuleKeyWords()
                            _this.showBookReceiptModuleTextSet = true
                        } else if (type == 8) { // 用户操作
                            _this.book_receipt_module_detail = res
                            _this.showBookReceiptModuleUserOperationSet = true
                            _this.$nextTick(() => {
                                _this.initBookReceiptModuleDetailUploader()
                            })
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        addModuleBanner() {
            this.book_receipt_module_detail.push({
                listorder: '',
                img_url: '',
                enter: -1, // 点击图片是否进入详情页
                enter_type: '', // 1图片 2链接
                detail_url: '', // 详情页链接
                detail_img: '', // 详情页图片
            })
            this.$nextTick(() => {
                this.initBookReceiptModuleDetailUploader()
            })
        },

        delModuleBanner(index) {
            this.book_receipt_module_detail.splice(index, 1)
            this.$nextTick(() => {
                this.initBookReceiptModuleDetailUploader()
            })
        },

        onEnterTypeChange(index) {
            this.book_receipt_module_detail[index].detail_img = ''
            this.book_receipt_module_detail[index].detail_url = ''
        },

        // 提交模块详情设置
        commitBookReceiptModuleDetailSet() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.book_receipt_module_id,
                        "detail": _this.book_receipt_module_detail
                    }
                },
                "comment": ""
            };
            if (_this.book_receipt_module_oper_type == 8) { // 用户操作
                let arr = [];
                _this.book_receipt_module_detail.forEach(item => {
                    if (!!item.selected) {
                        arr.push(item)
                    }
                })
                datas.request.param.detail = arr
            }
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/editModuleDetail",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("操作成功");
                        _this.showBookReceiptModuleBannerSet = false
                        _this.showBookReceiptModuleTextSet = false
                        _this.showBookReceiptModuleUserOperationSet = false
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        initBookReceiptModuleDetailUploader() {
            if (this.roomBgImgUploader.length > 0) { // 销毁先前的实例
                this.roomBgImgUploader.forEach(v => {
                    v.destroy()
                })
                this.roomBgImgUploader = []
            }
            this.book_receipt_module_detail.forEach((item, index) => {
                if (this.book_receipt_module_oper_type == 1) {
                    this.bookReceiptModuleImgUpload(`book-receipt-module-banner-img-${index}`)
                    this.bookReceiptModuleImgUpload(`book-receipt-module-detail-img-${index}`)
                } else if (this.book_receipt_module_oper_type == 8) {
                    this.bookReceiptModuleImgUpload(`book-receipt-user-operation-img-${index}`)
                }
            })
        },

        // 获取文案模块关键词变量
        getBookReceiptModuleKeyWords() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "BookReceipt/getParamsMap",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.book_receipt_module_key_words = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        onEditorReady() {
            console.log('editor ready')
        },

        // 插入关键词
        onKeyWordClick(keyword) {
            // 获取编辑器实例
            const editor = this.$refs.moduleTextEditor.quill

            if (!editor) {
                console.error('Editor not initialized')
                return
            }

            // 先让编辑器获得焦点
            editor.focus()

            // 获取当前光标位置，如果没有则设置在末尾
            let range = editor.getSelection()
            if (!range) {
                // 设置光标在末尾
                const lastPosition = editor.getLength()
                editor.setSelection(lastPosition, 0)
                range = { index: lastPosition, length: 0 }
            }

            // 插入文本
            editor.insertText(range.index, keyword.field)

            // 更新光标位置到插入文本后
            const newPosition = range.index + keyword.field.length + 1 // +1 是因为有#号
            editor.setSelection(newPosition, 0)
        },

        // 删除用户操作模块图片
        delUserOperationImg(index) {
            this.book_receipt_module_detail[index].img = ''
        },

        /*
         * 包厢状态新增预定必填项设置
         */
        // 初始化包厢状态新增预定必填项设置设置列表
        innitRoomReserveRequiredTable: function () {
            let _this = this;
            $(_this.$refs.roomReserveRequiredList).bootstrapTable('destroy');
            $(_this.$refs.roomReserveRequiredList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.commonGetConfigList(params, 'book_required_info');
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "book_customer_name_required",
                    title: "客户姓名是否必填",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'book_customer_name_required', check_stock, 'roomReserveRequiredList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.book_customer_name_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "book_customer_mobile_required",
                    title: "客户电话是否必填",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'book_customer_mobile_required', check_stock, 'roomReserveRequiredList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.book_customer_mobile_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }, {
                    field: "book_waiter_required",
                    title: "包厢服务生是否必填",
                    width: "25%",
                    events: {
                        'change .select-sel': function (e, value, row) {
                            let check_stock = $(this).children('option:selected').val();
                            _this.commonConfigSet(row.shop_id, 'book_waiter_required', check_stock, 'roomReserveRequiredList');
                        }
                    },
                    formatter: function (value, row, index) {
                        let strHtml = "";
                        if (row.book_waiter_required == "1") {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                        } else {
                            strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                        }
                        return strHtml;
                    }
                }]
            });
        },

        // 获取智慧超市设置列表
        getSmartMarketList() {
            let _this = this;
            Vue.axios.post(Vue.ctUrl + 'setting/getList', {
                header: Vue.request_header,
                request: {
                    version: Vue.version,
                    param: {
                        "page": _this.smartMarketList_page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                    }
                }
            }).then(res => {
                console.log('获取智慧超市设置列表', res)
                if (res.data.response.result_code == 'true') {
                    _this.smartMarketList = res.data.response.result.data
                    _this.smartMarketList_total = Number(res.data.response.result.count)
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        // 设置广告状态
        setAdStatus(row, type) {
            console.log('设置广告状态', row, type)
            let _this = this;
            let params = {}
            if (type == 1) {
                params.auto_link_room = Number(row.auto_link_room)
            } else if (type == 2) {
                params.room_open_chose = Number(row.room_open_chose)
            } else if (type == 3) {
                params.ad = Number(row.ad)
            }
            params.shop_id = Number(row.id)
            Vue.axios.post(Vue.ctUrl + 'setting/setSetting', {
                header: Vue.request_header,
                request: {
                    version: Vue.version,
                    param: params
                }
            })
                .then(res => {
                    if (res.data.response.result_code == 'true') {
                        layer.msg('设置成功')
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 去广告详情设置
        toAdDetail(row) {
            this.now_shop_id = row.id
            this.isAdDetail = true
            this.getAdDetail(row)
        },
        // 获取广告设置详情
        getAdDetail: function (row) {
            // console.log(row.id);
            
            	const _this = this

				_this.loading = true
				Vue.axios.post('setting/getAds', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": Number(row.id)
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result.ad_type != -1) {
							_this.ad_form.ads = res.data.response.result.ads
							_this.ad_form.ad_type = res.data.response.result.ad_type
						    _this._formateUploadDom()
						}else {
							_this.ad_form = {
								ad_type: 1,
								ads: [{
									id: 0,
									img: '',
									style: '-1',
									content: '',
								}]
							}
							_this._formateUploadDom()
						}
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
            },

        // 返回智慧超市设置列表
        backSmartMarket() {
            this.isAdDetail = false
            // 返回的时候销毁所有上传器
            this.destroyPlupload()

            this.getSmartMarketList()
        },

        commitAdDetail(){
            console.log('commitAdDetail',this.ad_form);
            console.log('now_shop_id',this.now_shop_id);

            Vue.axios.post('setting/setAds', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": this.now_shop_id,
                        "ads": this.ad_form.ads,
                        "ad_type": this.ad_form.ad_type
                    }
                }
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    layer.msg('设置成功')
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg("出错啦")
            })
        },
        // 新增图片
        addImg: function () {
            	this.ad_form.ads.push({
            		id: 0,
                    img: '',
                    style: '-1',
                    content: '',
            	})

            	this.initUpload('faceImg' + (this.ad_form.ads.length - 1), this.ad_form.ads.length - 1, 'img')
            },

            // 切换菜单样式类型
            changeType: function (val) {
            	if (val == '1') {
            		this.ad_form = {
            			ad_type: 1,
            			ads: [{
		                    id: 0,
		                    img: '',
		                    style: '-1',
		                    content: '',
	                	}]
            		}
            	}else if(val == '2') {
            		this.ad_form = {
            			ad_type: 2,
            			ads: [{
		                    id: 0,
		                    img: '',
		                    style: '-1',
		                    content: '',
	                	},{
		                    id: 0,
		                    img: '',
		                    style: '-1',
		                    content: '',
	                	},{
		                    id: 0,
		                    img: '',
		                    style: '-1',
		                    content: '',
	                	}
                    ]
            		}
            	}else if(val == '3') {
            		this.ad_form = {
            			ad_type: 3,
            			ads: [{
		                    id: 0,
		                    img: '',
		                    style: '-1',
		                    content: '',
	                	}]
            		}
            	}
            	this.destroyPlupload()
            	this._formateUploadDom()
            },

            // 销毁不必要的Plupload实例
            destroyPlupload: function () {
           		console.log('destroyPlupload')
           		if(this.plupload_list.length > 0) {
           			this.plupload_list.forEach(v => {
           				v.destroy()
           			})
           			this.plupload_list = []
           		}
           	},

            // (多图轮播）删除图片
            deleteThisImg: function (index) {
            	this.ad_form.ads.splice(index, 1)
            	this.plupload_list.splice(index,1)
            	this.plupload_list[index].destroy()
            },

                 // 初始化上传图片/视频
			initUpload: function(btnName, index, type) {

                console.log('initIndex',index);

				let _this = this;
				let host = '',
					dir = '',
					file_name = '';
				let allow_type = type == 'img' ? 'jpg,jpeg,png,gif' : 'mp4,mkv,m4v,avi'
				let resize_width = '',
					resize_height = '';
				if(btnName.indexOf("faceImg") > -1) {
					resize_width = 1920
					resize_height =  1080 
				}else if(btnName.indexOf("contentImg") > -1) {
					resize_width = 1920
					resize_height = 1080
				}

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: btnName, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: allow_type }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: resize_width,
							height: resize_height
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                let file_url = host + "/" + dir + file_name
                                console.log("文件上传成功：", file_url)
                                if (btnName.indexOf("faceImg") > -1) {
                                	_this.ad_form.ads[index].img = file_url
                                }else if (btnName.indexOf("contentImg") > -1) {
                                	_this.ad_form.ads[index].content = file_url
                                }else if (btnName.indexOf("contentVideo") > -1) {
                                	_this.ad_form.ads[index].content = file_url
                                }
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传'+ allow_type +'文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							},
							// 初始化完成触发
							PostInit: function () {
								if (btnName.indexOf("ads") > -1) {
									if (_this.ad_form.ads[index].uploader_list && _this.ad_form.ads[index].uploader_list.length > 0) {
										_this._destroyContentUploader(index)
										_this.ad_form.ads[index].uploader_list.push(uploader)
									}else {
										_this.$set(_this.ad_form.ads[index], 'uploader_list', [uploader])
									}
								}else {
									_this.plupload_list.push(uploader)
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },

            _destroyContentUploader: function (index) {
        		this.ad_form.ads[index].uploader_list.forEach(v => {
        			v.destroy()
        		})
        		this.ad_form.ads[index].uploader_list = []
            },

            // 切换广告内容类型
       		contentTypeChange: function (val, index) {
                
       			this.$nextTick(() => {
       				if (val == '-1') { // 无
       					if (this.ad_form.ads[index].uploader_list && this.ad_form.ads[index].uploader_list.length > 0) {
       						this._destroyContentUploader(index)
       					}
       				}else if (val == '1') { // 图片
	       				this.initUpload("contentImg" + index, index, 'img')
	       			}
       			})
       		},

            

            // 整理需要初始化上传的dom
            _formateUploadDom: function () {
           		if (this.ad_form.ads.length > 0) {
           			this.ad_form.ads.forEach((item, index) => {
           				this.initUpload('faceImg' + index, index, 'img')
           				if (item.style == '1') { // 广告内容是图片
           					this.initUpload('contentImg' + index, index, 'img')
           				}
           			})
           		}
           	},

            // 获取到店指引列表
            getStoreGuideList() {

                let _this = this;

                let page = this.guide_page;

                this.loading = true;

                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            'page': page,
                            'page_size': Global.PAGESIZE,
                            'config_type': 'shop_guide'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        this.guideList = res.data.response.result.data
                        this.guide_total = res.data.response.result.count
                        console.log('guideList',this.guideList);
                        
                    }else{
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦")
                })
                .finally(() => {
                    this.loading = false;
                })
            },

            // 打开上传到店指引图片弹窗
			guideSet: function (row) {
                console.log('row', row);
                let _this = this
                _this.guide_form.shop_id = row.shop_id
                _this.guide_form.shop_guide_img = row.shop_guide_img
                _this.guide_form.shop_guide_status = row.shop_guide_status

                _this.uploadGuideImg()
                // 打开一个弹窗，可以上传一张图片，图片上传成功后，显示在弹窗中
                layer.confirm('',{
                    skin: 'pb-alert-skin',
                    type: 1,
                    content: $(_this.$refs.guide_set_pop),
                    area: ['600px', '400px'],
                    btn: ['确定', '取消'],
                    title: ['操作指引设置', true],
                    cancel: function() {
                        _this.closeGuideSet()
                    }
                }, function() {
                    _this.saveGuideSet('shop_guide_img', _this.guide_form.shop_guide_img)
                }, function() {
                    _this.closeGuideSet()
                });
			},

            // 上传操作指引图片
            uploadGuideImg: function () {
                let _this = this;
				let host = '',
					dir = '',
					file_name = '';
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: 'guide-img-uploader', // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: "jpg,jpeg,png" }
                        ],
                        // max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                              "header": Vue.request_header,
                              "request": {
                                "param": {
                                  "file": files[0].name,
                                  "path": 'Setting'
                                }
                              },
                              "comment": ""
                            })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });
                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(res.data.response.result_status, _this);
                                    layer.msg(res.data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                        },  
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            console.log('yploaded,success', host + "/" + dir + file_name);
                            
                            _this.guide_form.shop_guide_img = host + "/" + dir + file_name;
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传jpg,jpeg,png文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                })
                // 初始化
                uploader.init();
                _this.guide_img_uploader.push(uploader)
                },

            // 关闭操作指引设置
			closeGuideSet: function () {
				this.guide_form.shop_guide_img = ''
                this.guide_img_uploader.forEach(item => {
                    item.destroy()
                })
                this.guide_img_uploader = []
				layer.closeAll()
			},
            // 删除操作指引图片
            delGuideImg: function () {
                this.guide_form.shop_guide_img = ''
            },
            // 删除操作指引
            delGuide: function (row) {
                console.log('row', row);
                
                let _this = this
                _this.guide_form.shop_id = row.shop_id
                _this.guide_form.shop_guide_img = ''
                // 二次确认
                layer.confirm('确定删除吗？', {
                    title: ['删除到店指引图片', true],
                    skin: 'pb-alert-skin',
                    type: 1,
                    content: '确定删除吗？',
                    btn: ['确定', '取消'],
                    cancel: function() {
                        _this.guide_form.shop_id = ''
                        _this.guide_form.shop_guide_img = ''
                        layer.closeAll()
                    }
                }, function() {
                    _this.saveGuideSet('shop_guide_img', '')
                }, function() {
                    _this.guide_form.shop_id = ''
                    _this.guide_form.shop_guide_img = ''
                    layer.closeAll()
                });
            },
            // 切换操作指引状态
            changeGuideStatus: function (row) {
                console.log('row', row);
                let _this = this
                _this.guide_form.shop_id = row.shop_id
                _this.guide_form.shop_guide_status = row.shop_guide_status
                _this.saveGuideSet('shop_guide_status', _this.guide_form.shop_guide_status)
            },

            // 保存操作指引
			saveGuideSet: function (config_type, config) {
				let _this = this
				Vue.axios.post('Shop/upConfig', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.guide_form.shop_id,
							"config_type": config_type,
							"config": config
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.closeAll()
						layer.msg('保存成功')
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
                this.closeGuideSet()
                setTimeout(() => {
                    this.getStoreGuideList()
                }, 200)
			},

            // 图片预览
            showGuideImg: function (img) {
                console.log('img', img.shop_guide_img);
                // 点击打开图片预览
                layer.open({
                    type: 1,
                    content: '<img src="' + img.shop_guide_img + '" style="max-width: 100%;" />',
                    area: ['375px', '667px'],
                    title: ['图片预览', true]
                })
                
            }
    }
}
</script>
<style lang="less" scoped>
.li-select {
    display: none;
    padding: 30px 20px;
    font-size: 14px;

    ul {
        width: 19%;
        margin: 0 auto;
    }

    >p {
        text-align: center;
    }

    label {
        padding: 0 0 0 8px;
    }
}

.rowpadding {
    margin: 0 0 30px;
}

.selection_clear {
    display: none;
    position: absolute;
    right: 36px;
    top: 1px;
    width: 20px;
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    cursor: pointer;
}

.printer_arrow {
    height: 32px;
    position: absolute;
    top: 1px;
    right: 16px;
    width: 20px;
    cursor: pointer;

    b {
        border-color: #888 transparent transparent transparent;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        height: 0;
        left: 50%;
        margin-left: -4px;
        margin-top: -2px;
        position: absolute;
        top: 50%;
        width: 0;
    }
}

// app支付方式设置
.store-app-set {
    .app-modify {
        display: none;
        padding: 30px 20px;
        font-size: 14px;

        table {
            width: 100%;
        }

        td,
        th {
            height: 40px;
            line-height: 40px;
            border: 1px solid #CCC;
            text-align: center;
        }

        input {
            height: 30px;
            border-bottom: 1px solid #CCC;
        }

        .edit-btn {
            color: #009af0;
            cursor: pointer;
        }
    }
}

// app任务自动接收
.store-sfr-set {
    .sfr-list {
        h1 {
            margin: 0 0 20px;
        }
    }

    .sfr-modify {
        display: none;

        .sfr-modify-shop {
            line-height: 32px;
            background: #DDD;
        }

        .sfr-sel-list {
            padding: 0;
            border: 1px solid #CCC;

            h3 {
                border-bottom: 1px solid #CCC;
                margin: 0;
                line-height: 40px;
                color: #757575;
                font-size: 14px;
                text-align: center;
            }

            ul {
                margin: 50px 0 30px;
            }

            li {
                float: left;
                width: 135px;
                border: 1px solid #CCC;
                margin: 0 0 20px 35px;
                line-height: 30px;
                color: #757575;
                text-align: center;
                cursor: pointer;
                border-radius: 15px;
            }

            .sfr-sel-li {
                border: 1px solid #009af0;
                color: #009af0;
            }
        }
    }
}

// 包厢营业额预警设置
.store-byy-set {
    .byy-list {
        h1 {
            margin: 0 0 30px;
        }
    }

    .byy-edit {
        >p {
            color: #F00;
            margin: 10px 0 30px;
        }

        >div>span {
            line-height: 32px;
        }
    }
}

// 取消开房时限设置
.store-qks-set {
    .qks-edit {
        display: none;

        label {
            padding: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            text-align: right;
            font-weight: normal;
        }

        .row {
            margin: 0 0 20px;
        }

        .el-checkbox {
            margin-left: 30px;
        }

        p {
            padding: 0 0 0 30px;
            color: #FF0707;
        }
    }
}

// 会员到店预警设置
.store-hdy-set {
    .pb-edit-alert {
        input[type=text] {
            display: inline-block;
            width: 100px;
        }
    }
}

// 暂停营业时间设置
.store-zys-set {
    .zys-usetime-allday {
        margin: 0 0 10px;
    }
}

// 每次开房可使用券总量
.store-mkq-set {
    .mkq-usetime-allday {
        margin: 0 0 10px;
    }
}

.store-bdjft-set {
    .middle-size {
        outline: none;
        border: none;
        cursor: pointer;
        width: 220px !important;
    }
}

// 微信扫码默认办理会员适用包厢设置面板
.smbh-room-set {
    .room-wrapper {
        // width: 1000px;
        margin: 20px 0;
        border: 1px solid #f5f5f5;

        .block-title {
            line-height: 40px;
            background: #f5f5f5;
            padding-left: 20px;
        }

        .block {
            margin-top: 20px;

            .rooms {
                padding: 10px 20px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;

                .room {
                    width: 200px;
                    margin: 10px 0;
                }
            }
        }
    }
}

// 班次设置
.bcsz-pop {
    .pop-row {
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .pop-label {
            margin: 0 10px 0 30px;
        }

        .el-input {
            width: 150px;
        }

        .split {
            padding: 0 5px;
        }

        .icon {
            margin-left: 10px;
        }
    }
}

// 收银包厢状态背景图
.room-bg-img-set {
    .tip {
        margin-bottom: 20px;
        color: red;
    }

    .bg-img-wrapper {
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        .item {
            position: relative;
            margin: 0 30px 30px 0;
            display: flex;
            flex-direction: column;
            align-items: center;

            .bg-img {
                width: 320px;
                height: 180px;
                margin-bottom: 10px;
            }

            .del-icon {
                position: absolute;
                right: -10px;
                top: -10px;
                width: 30px;
            }
        }

        #roomBgImgAdd {
            cursor: pointer;
        }
    }
}

// 收银包厢状态背景颜色设置
.room-bg-color-set {
    .room-colors-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .item {
            width: 150px;
            margin: 20px;

            .opers {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                >div {
                    color: #009af0;
                    cursor: pointer;
                }
            }

            .color-box {
                width: 100%;
                height: 120px;

                .room-name {
                    margin-top: 10px;
                    font-size: 16px;
                    padding: 15px 10px;
                    color: #fff;
                }

                .room-status {
                    font-size: 14px;
                    margin: 5px 10px;
                }
            }
        }
    }

    .color-picker-pop {
        .color-picker-chrome {
            margin: 0 auto;
        }
    }
}

// 团购平台类型设置
.add-tgpl-pop {
    .el-input {
        width: 350px;
    }
}

// 排队叫号语音播报设置弹窗
.voice-set-pop {
    .el-textarea {
        margin-top: 20px;
    }
}

// 服务评价管理
.service-comment-set {
    .el-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 30px;
        flex-wrap: wrap;

        .el-input {
            width: 300px;
            margin-left: 20px;
        }

        .short {
            width: 200px;
            margin-bottom: 20px;
        }

        .tip {
            color: red;
        }
    }
}

// 账单自助支付设置
.self-pay-pop {
    .red-tip {
        color: red;
    }
}

// 会员自助注册用户协议设置
.store-userAgreement-set {
    .edit-panel {
        .quill-editor {
            height: 300px;
            /* 设置编辑器高度 */
            margin-bottom: 50px;
        }
    }
}

.store-onlineReserveReceipt-set {
    .add-book-receipt-module-pop {

        .el-select,
        .el-input {
            width: 300px;
        }

        .el-button {
            margin-left: 10px;
        }

        .book-receipt-module-img-wrapper {
            width: 120px;
            height: 120px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .banner-set-panel {
        .banners-wrapper {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;

            .banner-item {
                position: relative;
                width: 500px;
                height: 500px;
                padding: 10px;
                background-color: #f5f5f5;
                margin: 20px 30px 20px 0;

                .banner-item-img-wrapper {
                    width: 120px;
                    height: 120px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .el-icon-error {
                    position: absolute;
                    right: -15px;
                    top: -15px;
                    color: #409eff;
                    font-size: 30px;
                    cursor: pointer;
                }

                .el-input,
                .el-select {
                    width: 280px;
                }
            }
        }
    }

    .text-set-panel {
        .quill-editor {
            height: 300px;
            /* 设置编辑器高度 */
            margin-bottom: 50px;
        }

        .key-words-wrapper {
            margin: 30px 0 30px 0;
            padding: 20px;
            background-color: #f5f5f5;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;

            .tip {
                color: #333;
            }

            .word-item {
                line-height: 30px;
                margin-right: 10px;
                padding: 0 15px;
                border: 1px solid #009af0;
                color: #009af0;
                cursor: pointer;
            }
        }
    }

    .user-operation-set-panel {
        .red-tip {
            color: red;
        }

        .user-operation-set-list {
            width: 900px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .user-operation-set-item {
                width: 380px;
                margin: 20px 20px 20px 0;
                padding: 20px;
                background-color: #f5f5f5;

                .user-operation-img-wrapper {
                    position: relative;
                    width: 120px;
                    height: 120px;
                    cursor: pointer;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .del-icon {
                        position: absolute;
                        right: -10px;
                        top: -10px;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
.block-item {
    		position: relative;
    		width: 900px;
    		margin: 0 0 20px 10px;
    		padding: 15px;
    		background: rgb(242,242,242);
    		.delete-icon {
    			position: absolute;
    			right: 0;
    			top: 0;
    			width: 20px;
    			height: 20px;
    			padding: 15px;
    			box-sizing: content-box;
    		}
    		.good-row {
    			margin-bottom: 10px;
    			display: flex;
    			flex-direction: row;
    			align-items: center;
    			.img-wrapper {
    				margin: 0 20px 0 10px;
    				.add-icon {
    					margin-bottom: 10px;
    				}
    			}
    			.goods-detail {
    				.row {
    					margin-top: 15px;
    				}
    			}
    		}
    	}
        .row {
    		display: flex;
    		flex-direction: row;
    		.goods-detail {
    			margin-left: 20px;
    		}
    	}
    	.img-wrapper,
    	.video-wrapper {
    		width: 320px;
			height: 180px;
    		background: #fff;
			border: 1px solid #ccc;
    		display: flex;
    		flex-direction: column;
    		align-items: center;
    		justify-content: center;
    		&.big-img {
    			width: 680px;
    			height: 94px;
    		}
    		&.goods {
    			width: 150px;
    			height: 150px;
    		}
    		.add-icon {
    			width: 40px;
    			height: 40px;
    			margin: 0;
    		}
    		.add-txt {
    			font-size: 12px;
    			color: #999;
    		}
    		.ad-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.good-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.content-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.video {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    	}
		.red-tip {
			font-size: 12px;
			color: red;
		}

        .guide-set-pop{
            display: none;
            .tip{
                color: red;
                margin-bottom: 25px;
                margin-left: 20px;
            }
            .el-form {
				position: relative;
				margin-bottom: 30px;
				background: #f5f5f5;
				padding: 20px 0;
				.el-form-item {
					margin-bottom: 5px;
					padding-left: 20px;
					.el-input,
					.el-select {
						width: 300px;
					}
				}
				.img-row {
					display: flex;
					flex-direction: row;
					align-items: center;
					.item {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						margin: 0 20px;
						.img-label {
							margin-bottom: 10px;
						}
						.upload-img-wrapper {
							position: relative;
							margin-bottom: 10px;
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							background: rgba(203,203,203);
							width: 160px;
							height: 90px;
							cursor: pointer;
							.upload-img {
								height: 40px;
							}
							.uploaded-img {
								width: 100%;
								height: 100%;
							}
							.txt {
								color: #fff;
							}
							.del-icon {
								position: absolute;
								top: -10px;
								right: -10px;
								width: 30px;
								cursor: pointer;
							}
						}
					}
				}
			}
			.del-btn {
				position: absolute;
				right: 30px;
				top: 20px;
				width: 32px;
			}
        }
</style>